(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.dt.bx === region.d$.bx)
	{
		return 'on line ' + region.dt.bx;
	}
	return 'on lines ' + region.dt.bx + ' through ' + region.d$.bx;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gq,
		impl.ho,
		impl.ha,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		gx: func(record.gx),
		du: record.du,
		dd: record.dd
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.gx;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.du;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.dd) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gq,
		impl.ho,
		impl.ha,
		function(sendToApp, initialModel) {
			var view = impl.ht;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gq,
		impl.ho,
		impl.ha,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dm && impl.dm(sendToApp)
			var view = impl.ht;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fL);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.dz) && (_VirtualDom_doc.title = title = doc.dz);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.gJ;
	var onUrlRequest = impl.gK;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dm: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.eU === next.eU
							&& curr.ec === next.ec
							&& curr.eQ.a === next.eQ.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		gq: function(flags)
		{
			return A3(impl.gq, flags, _Browser_getUrl(), key);
		},
		ht: impl.ht,
		ho: impl.ho,
		ha: impl.ha
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { gj: 'hidden', fQ: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { gj: 'mozHidden', fQ: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { gj: 'msHidden', fQ: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { gj: 'webkitHidden', fQ: 'webkitvisibilitychange' }
		: { gj: 'hidden', fQ: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		e5: _Browser_getScene(),
		fy: {
			cn: _Browser_window.pageXOffset,
			co: _Browser_window.pageYOffset,
			fB: _Browser_doc.documentElement.clientWidth,
			eb: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fB: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		eb: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			e5: {
				fB: node.scrollWidth,
				eb: node.scrollHeight
			},
			fy: {
				cn: node.scrollLeft,
				co: node.scrollTop,
				fB: node.clientWidth,
				eb: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			e5: _Browser_getScene(),
			fy: {
				cn: x,
				co: y,
				fB: _Browser_doc.documentElement.clientWidth,
				eb: _Browser_doc.documentElement.clientHeight
			},
			f7: {
				cn: x + rect.left,
				co: y + rect.top,
				fB: rect.width,
				eb: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}




// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.gb.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.gb.b, xhr)); });
		$elm$core$Maybe$isJust(request.ft) && _Http_track(router, xhr, request.ft.a);

		try {
			xhr.open(request.gy, request.hp, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.hp));
		}

		_Http_configureRequest(xhr, request);

		request.fL.a && xhr.setRequestHeader('Content-Type', request.fL.a);
		xhr.send(request.fL.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ea; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.fr.a || 0;
	xhr.responseType = request.gb.d;
	xhr.withCredentials = request.fG;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		hp: xhr.responseURL,
		g6: xhr.status,
		g7: xhr.statusText,
		ea: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			g0: event.loaded,
			fe: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			gW: event.loaded,
			fe: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}var $author$project$Main$OnUrlChange = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$OnUrlRequest = function (a) {
	return {$: 7, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.j) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.m),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.m);
		} else {
			var treeLen = builder.j * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.p) : builder.p;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.j);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.m) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.m);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{p: nodeList, j: (len / $elm$core$Array$branchFactor) | 0, m: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {d8: fragment, ec: host, cd: path, eQ: port_, eU: protocol, eV: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Page$Index$BarChartModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$EnvUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$EditQuiz$ModalModel = F3(
	function (answer, dummies, showModal) {
		return {fI: answer, aX: dummies, ba: showModal};
	});
var $author$project$Page$Common$NotFound = 0;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Main$EditQuizMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Common$EditQuizView = 4;
var $author$project$Main$ImportQuizesMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Common$ImportQuizesView = 5;
var $author$project$Main$IndexMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Common$IndexView = 1;
var $author$project$Main$LearnMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Common$LearnView = 2;
var $author$project$Main$QuizesMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Common$QuizesView = 3;
var $author$project$Page$EditQuiz$ImageSelectorMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$EditQuiz$Initialized = {$: 11};
var $author$project$Data$Quizes$Quiz = F2(
	function (sentence, image) {
		return {gl: image, g1: sentence};
	});
var $author$project$Data$Quizes$QuizRecord = F6(
	function (key, entry, result, nextScheduledDate, boost, tags) {
		return {dL: boost, d3: entry, ep: key, eF: nextScheduledDate, dh: result, fn: tags};
	});
var $author$project$Data$Quizes$QuizResult = F2(
	function (masteringCount, totalCount) {
		return {ey: masteringCount, fs: totalCount};
	});
var $author$project$ImageSelector$ViewBox = F4(
	function (x, y, w, h) {
		return {ai: h, aS: w, cn: x, co: y};
	});
var $author$project$ImageSelector$ImageMatrix = F6(
	function (a, b, c, d, e, f) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$ImageSelector$identityImageMatrix = A6($author$project$ImageSelector$ImageMatrix, 1, 0, 0, 1, 0, 0);
var $author$project$ImageSelector$maxImageSize = _Utils_Tuple2(320, 320);
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$ImageSelector$initModel = {
	x: $author$project$ImageSelector$identityImageMatrix,
	ax: $elm$core$Maybe$Nothing,
	a_: 0,
	a$: 0,
	a7: $elm$core$Maybe$Nothing,
	aC: $elm$core$Maybe$Nothing,
	bC: $elm$core$Maybe$Nothing,
	ba: false,
	aF: $elm$core$Maybe$Nothing,
	an: $elm$core$Maybe$Nothing,
	ap: $author$project$ImageSelector$identityImageMatrix,
	F: A4($author$project$ImageSelector$ViewBox, 0, 0, $author$project$ImageSelector$maxImageSize.a, $author$project$ImageSelector$maxImageSize.b),
	G: $author$project$ImageSelector$maxImageSize
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$ImageSelector$init = _Utils_Tuple2($author$project$ImageSelector$initModel, $elm$core$Platform$Cmd$none);
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Analytics$setCurrentScreen = _Platform_outgoingPort('setCurrentScreen', $elm$json$Json$Encode$string);
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Page$EditQuiz$init = F2(
	function (m, _v0) {
		var env = _v0.a;
		var key = _v0.b;
		var _v1 = $author$project$ImageSelector$init;
		var imageSelectorModel = _v1.a;
		var imageSelectorCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				m,
				{
					bZ: env,
					eg: $elm$core$Maybe$Nothing,
					eh: imageSelectorModel,
					ep: key,
					eA: A3($author$project$Page$EditQuiz$ModalModel, '', _List_Nil, false),
					de: $elm$core$Maybe$Just(
						A2($author$project$Data$Quizes$Quiz, _List_Nil, $elm$core$Maybe$Nothing)),
					eX: $elm$core$Maybe$Just(
						A6(
							$author$project$Data$Quizes$QuizRecord,
							'',
							{de: ''},
							A2($author$project$Data$Quizes$QuizResult, 0, 0),
							$elm$time$Time$millisToPosix(0),
							false,
							_List_Nil)),
					e7: $elm$core$Maybe$Nothing
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Page$EditQuiz$ImageSelectorMsg, imageSelectorCmd),
						A2(
						$elm$core$Task$perform,
						function (_v2) {
							return $author$project$Page$EditQuiz$Initialized;
						},
						$elm$core$Process$sleep(0)),
						$author$project$Analytics$setCurrentScreen('edit_quiz')
					])));
	});
var $author$project$Page$ImportQuizes$init = F2(
	function (m, env) {
		return _Utils_Tuple2(
			_Utils_update(
				m,
				{bZ: env, gU: _List_Nil, e8: $elm$core$Maybe$Nothing}),
			$author$project$Analytics$setCurrentScreen('import_quizes'));
	});
var $author$project$Page$Index$BarChartMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Index$Loaded = {$: 3};
var $author$project$Page$Index$PieChartMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$BarChart$initModel = {aV: 0, bX: 500.0, ai: 300, al: 40, eW: 0, aS: 300};
var $author$project$BarChart$init = function (_v0) {
	var w = _v0.a;
	var h = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			$author$project$BarChart$initModel,
			{ai: h, aS: w}),
		$elm$core$Platform$Cmd$none);
};
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$darkBlue = A4($avh4$elm_color$Color$RgbaSpace, 32 / 255, 74 / 255, 135 / 255, 1.0);
var $avh4$elm_color$Color$darkGreen = A4($avh4$elm_color$Color$RgbaSpace, 78 / 255, 154 / 255, 6 / 255, 1.0);
var $avh4$elm_color$Color$darkOrange = A4($avh4$elm_color$Color$RgbaSpace, 206 / 255, 92 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$darkPurple = A4($avh4$elm_color$Color$RgbaSpace, 92 / 255, 53 / 255, 102 / 255, 1.0);
var $avh4$elm_color$Color$darkRed = A4($avh4$elm_color$Color$RgbaSpace, 164 / 255, 0 / 255, 0 / 255, 1.0);
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{p: nodeList, j: nodeListSize, m: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$PieChart$init = function (_v0) {
	var w = _v0.a;
	var h = _v0.b;
	return _Utils_Tuple2(
		{
			av: 0.0,
			aV: 0.0,
			ai: h,
			az: _List_Nil,
			c4: $elm$core$Array$fromList(
				_List_fromArray(
					[$avh4$elm_color$Color$darkBlue, $avh4$elm_color$Color$darkGreen, $avh4$elm_color$Color$darkPurple, $avh4$elm_color$Color$darkOrange, $avh4$elm_color$Color$darkRed])),
			aS: w
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Page$Index$init = F2(
	function (m, env) {
		var _v0 = $author$project$PieChart$init(
			_Utils_Tuple2(300, 300));
		var pieChartModel = _v0.a;
		var pieChartCmd = _v0.b;
		var _v1 = $author$project$BarChart$init(
			_Utils_Tuple2(300, 300));
		var barChartModel = _v1.a;
		var barChartCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				m,
				{
					dO: $author$project$Page$Index$BarChartModel(barChartModel),
					d2: $elm$core$Dict$empty,
					bZ: env,
					fc: false,
					fk: _List_Nil
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						function (_v2) {
							return $author$project$Page$Index$Loaded;
						},
						$elm$core$Process$sleep(500)),
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Index$PieChartMsg, pieChartCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Index$BarChartMsg, barChartCmd),
						$author$project$Analytics$setCurrentScreen('show_chart')
					])));
	});
var $author$project$Page$Learn$StartNextSession = function (a) {
	return {$: 3, a: a};
};
var $author$project$Env$config = function (_v0) {
	var env = _v0;
	return env.bU;
};
var $author$project$Page$Learn$initTemporaryMessage = {gx: '', dy: 3000, bP: false};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Page$Learn$init = F2(
	function (m, env) {
		var config = $author$project$Env$config(env);
		return _Utils_Tuple2(
			_Utils_update(
				m,
				{dV: config.dV, dW: $elm$core$Maybe$Nothing, bZ: env, eq: $elm$core$Maybe$Nothing, dh: $elm$core$Maybe$Nothing, fb: $elm$core$Maybe$Nothing, fc: false, fi: $elm$core$Maybe$Nothing, fj: $elm$core$Maybe$Nothing, fo: $author$project$Page$Learn$initTemporaryMessage, fr: config.ei}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						$author$project$Page$Learn$StartNextSession,
						A2(
							$elm$core$Task$andThen,
							function (_v0) {
								return $elm$time$Time$now;
							},
							$elm$core$Process$sleep(0))),
						$author$project$Analytics$setCurrentScreen('learn')
					])));
	});
var $author$project$Page$Quizes$GotTimeZone = function (a) {
	return {$: 5, a: a};
};
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Page$Quizes$init = F2(
	function (m, env) {
		return _Utils_Tuple2(
			_Utils_update(
				m,
				{d1: _List_Nil, bZ: env, fc: false, bQ: $elm$time$Time$utc}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Page$Quizes$GotTimeZone, $elm$time$Time$here),
						$author$project$Analytics$setCurrentScreen('quizes')
					])));
	});
var $author$project$Main$toEnv = function (model) {
	return model.bZ;
};
var $author$project$Main$updateWith = F3(
	function (toMsg, viewType, _v0) {
		var model = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bO: viewType}),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Main$changeRouteTo = F2(
	function (route, model) {
		var env = $author$project$Main$toEnv(model);
		if (route.$ === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{bO: 0}),
				$elm$core$Platform$Cmd$none);
		} else {
			switch (route.a.$) {
				case 0:
					var _v1 = route.a;
					return A3(
						$author$project$Main$updateWith,
						$author$project$Main$LearnMsg,
						2,
						A2($author$project$Page$Learn$init, model, env));
				case 1:
					var _v2 = route.a;
					return A3(
						$author$project$Main$updateWith,
						$author$project$Main$IndexMsg,
						1,
						A2($author$project$Page$Index$init, model, env));
				case 2:
					var _v3 = route.a;
					return A3(
						$author$project$Main$updateWith,
						$author$project$Main$QuizesMsg,
						3,
						A2($author$project$Page$Quizes$init, model, env));
				case 3:
					var key = route.a.a;
					return A3(
						$author$project$Main$updateWith,
						$author$project$Main$EditQuizMsg,
						4,
						A2(
							$author$project$Page$EditQuiz$init,
							model,
							_Utils_Tuple2(env, key)));
				default:
					var _v4 = route.a;
					return A3(
						$author$project$Main$updateWith,
						$author$project$Main$ImportQuizesMsg,
						5,
						A2($author$project$Page$ImportQuizes$init, model, env));
			}
		}
	});
var $author$project$Env$Env = $elm$core$Basics$identity;
var $author$project$Env$Config = F6(
	function (initialTimeout, cps, speakEnglish, timeBonus, inputEachChar, countDownOnSelectBlank) {
		return {dU: countDownOnSelectBlank, dV: cps, ei: initialTimeout, el: inputEachChar, fg: speakEnglish, fq: timeBonus};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Env$configDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Env$Config,
	A2($elm$json$Json$Decode$field, 'initialTimeout', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'cps', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'speakEnglish', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'timeBonus', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'inputEachChar', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'countDownOnSelectBlank', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Env$defaultConfig = {dU: false, dV: 24, ei: 20 * 1000, el: false, fg: false, fq: false};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Env$tuple2Decoder = F2(
	function (dec1, dec2) {
		return A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, dec1),
			A2($elm$json$Json$Decode$index, 1, dec2));
	});
var $author$project$Env$historyDecoder = $elm$json$Json$Decode$list(
	A2($author$project$Env$tuple2Decoder, $elm$json$Json$Decode$string, $elm$json$Json$Decode$int));
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Env$create = F5(
	function (title_, key_, config_, history_, origin_) {
		return {
			bU: A2(
				$elm$core$Result$withDefault,
				$author$project$Env$defaultConfig,
				A2($elm$json$Json$Decode$decodeValue, $author$project$Env$configDecoder, config_)),
			az: A2(
				$elm$core$Result$withDefault,
				_List_Nil,
				A2($elm$json$Json$Decode$decodeString, $author$project$Env$historyDecoder, history_)),
			ep: key_,
			b$: $elm$core$Maybe$Nothing,
			c0: origin_,
			dz: title_,
			bi: $elm$time$Time$millisToPosix(0),
			bQ: $elm$time$Time$utc
		};
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aK: frag, aM: params, aH: unvisited, fw: value, aR: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aH;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.fw);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.fw);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.cd),
					$elm$url$Url$Parser$prepareQuery(url.eV),
					url.d8,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$EditQuiz = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$ImportQuizes = {$: 4};
var $author$project$Route$Index = {$: 1};
var $author$project$Route$Learn = {$: 0};
var $author$project$Route$Quizes = {$: 2};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aR;
		var unvisited = _v0.aH;
		var params = _v0.aM;
		var frag = _v0.aK;
		var value = _v0.fw;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aR;
			var unvisited = _v1.aH;
			var params = _v1.aM;
			var frag = _v1.aK;
			var value = _v1.fw;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Route$rootPath = 'memory-quiz';
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.aR;
		var unvisited = _v0.aH;
		var params = _v0.aM;
		var frag = _v0.aK;
		var value = _v0.fw;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.aR;
			var unvisited = _v0.aH;
			var params = _v0.aM;
			var frag = _v0.aK;
			var value = _v0.fw;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$parser = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s($author$project$Route$rootPath),
	$elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Learn,
				$elm$url$Url$Parser$s('learn')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Index,
				$elm$url$Url$Parser$oneOf(
					_List_fromArray(
						[
							$elm$url$Url$Parser$top,
							$elm$url$Url$Parser$s('index'),
							$elm$url$Url$Parser$s('index.html'),
							$elm$url$Url$Parser$s('index.htm')
						]))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Quizes,
				$elm$url$Url$Parser$s('quizes')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EditQuiz($elm$core$Maybe$Nothing),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('quizes'),
					$elm$url$Url$Parser$s('edit'))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeL, $author$project$Route$EditQuiz, $elm$core$Maybe$Just),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('quizes'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('edit'),
						$elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ImportQuizes,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('quizes'),
					$elm$url$Url$Parser$s('import')))
			])));
var $author$project$Route$fromUrl = function (url) {
	return A2($elm$url$Url$Parser$parse, $author$project$Route$parser, url);
};
var $author$project$Env$setZone = F2(
	function (zone, _v0) {
		var env = _v0;
		return _Utils_update(
			env,
			{bQ: zone});
	});
var $author$project$Main$init = F3(
	function (_v0, url, key) {
		var origin = _v0.c0;
		var config = _v0.bU;
		var tags = _v0.fn;
		var history = _v0.az;
		var route = $author$project$Route$fromUrl(url);
		var env = A5($author$project$Env$create, 'RUN RUN LEARN!!', key, config, history, origin);
		var defaultModel = {
			dF: 0,
			dO: $author$project$Page$Index$BarChartModel($author$project$BarChart$initModel),
			dR: $elm$core$Maybe$Nothing,
			dV: 24,
			dW: $elm$core$Maybe$Nothing,
			d1: _List_Nil,
			d2: $elm$core$Dict$empty,
			bZ: env,
			eg: $elm$core$Maybe$Nothing,
			eh: $author$project$ImageSelector$initModel,
			ep: $elm$core$Maybe$Nothing,
			eq: $elm$core$Maybe$Nothing,
			eA: A3($author$project$Page$EditQuiz$ModalModel, '', _List_Nil, false),
			eM: {fZ: 10, gO: 0},
			de: $elm$core$Maybe$Nothing,
			gU: _List_Nil,
			eX: $elm$core$Maybe$Nothing,
			dh: $elm$core$Maybe$Nothing,
			e7: $elm$core$Maybe$Nothing,
			e8: $elm$core$Maybe$Nothing,
			fb: $elm$core$Maybe$Nothing,
			fc: false,
			fd: false,
			fi: $elm$core$Maybe$Nothing,
			fj: $elm$core$Maybe$Nothing,
			fk: _List_Nil,
			dv: {
				g3: false,
				hd: _List_fromArray(
					['中学受験', '英語', 'TOEIC']),
				he: '',
				fn: tags
			},
			fo: $author$project$Page$Learn$initTemporaryMessage,
			fr: 0,
			bO: 0,
			bQ: $elm$time$Time$utc
		};
		var _v1 = A2($author$project$Main$changeRouteTo, route, defaultModel);
		var submodel = _v1.a;
		var subcommand = _v1.b;
		return _Utils_Tuple2(
			submodel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						subcommand,
						A2(
						$elm$core$Task$perform,
						function (zone) {
							return $author$project$Main$EnvUpdated(
								A2(
									$author$project$Env$setZone,
									zone,
									$author$project$Main$toEnv(submodel)));
						},
						$elm$time$Time$here)
					])));
	});
var $author$project$Main$DBError = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$QuizDB$dbError = _Platform_incomingPort('dbError', $elm$json$Json$Decode$value);
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Page$EditQuiz$DeleteConfirmed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$EditQuiz$DeleteQuizResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$EditQuiz$GotQuiz = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$EditQuiz$TagChooserMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Env$confirmed = _Platform_incomingPort(
	'confirmed',
	A2(
		$elm$json$Json$Decode$andThen,
		function (result) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (answer) {
					return $elm$json$Json$Decode$succeed(
						{fI: answer, dh: result});
				},
				A2($elm$json$Json$Decode$field, 'answer', $elm$json$Json$Decode$bool));
		},
		A2($elm$json$Json$Decode$field, 'result', $elm$json$Json$Decode$value)));
var $author$project$QuizDB$deleteQuizResult = _Platform_incomingPort(
	'deleteQuizResult',
	A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (deleted) {
					return $elm$json$Json$Decode$succeed(
						{f1: deleted, ep: key});
				},
				A2($elm$json$Json$Decode$field, 'deleted', $elm$json$Json$Decode$bool));
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
var $author$project$QuizDB$gotQuiz = _Platform_incomingPort('gotQuiz', $elm$json$Json$Decode$value);
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$ImageSelector$GotImage = function (a) {
	return {$: 13, a: a};
};
var $author$project$ImageSelector$GotObjectUrl = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$ImageSelector$gotObjectUrl = _Platform_incomingPort(
	'gotObjectUrl',
	A2(
		$elm$json$Json$Decode$andThen,
		function (width) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (objectUrl) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (height) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (dataUrl) {
									return $elm$json$Json$Decode$succeed(
										{dX: dataUrl, eb: height, b5: objectUrl, fB: width});
								},
								A2($elm$json$Json$Decode$field, 'dataUrl', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float));
				},
				A2($elm$json$Json$Decode$field, 'objectUrl', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float)));
var $author$project$ImageSelector$imageRendered = _Platform_incomingPort('imageRendered', $elm$json$Json$Decode$string);
var $author$project$ImageSelector$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$ImageSelector$imageRendered($author$project$ImageSelector$GotImage),
				$author$project$ImageSelector$gotObjectUrl($author$project$ImageSelector$GotObjectUrl)
			]));
};
var $author$project$Page$TagChooser$GotTags = function (a) {
	return {$: 3, a: a};
};
var $author$project$QuizDB$gotTags = _Platform_incomingPort(
	'gotTags',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Page$TagChooser$subscriptions = function (model) {
	return $author$project$QuizDB$gotTags($author$project$Page$TagChooser$GotTags);
};
var $author$project$Page$EditQuiz$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$QuizDB$gotQuiz($author$project$Page$EditQuiz$GotQuiz),
				$author$project$QuizDB$deleteQuizResult($author$project$Page$EditQuiz$DeleteQuizResult),
				$author$project$Env$confirmed($author$project$Page$EditQuiz$DeleteConfirmed),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$EditQuiz$ImageSelectorMsg,
				$author$project$ImageSelector$subscriptions(model.eh)),
				(model.bO === 4) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$EditQuiz$TagChooserMsg,
				$author$project$Page$TagChooser$subscriptions(model.dv)) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Page$ImportQuizes$FileLoaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$ImportQuizes$ImportQuizes = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$ImportQuizes$TagChooserMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Env$quizesDownloaded = _Platform_incomingPort(
	'quizesDownloaded',
	A2(
		$elm$json$Json$Decode$andThen,
		function (tags) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (quizes) {
					return $elm$json$Json$Decode$succeed(
						{gU: quizes, fn: tags});
				},
				A2(
					$elm$json$Json$Decode$field,
					'quizes',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
		},
		A2(
			$elm$json$Json$Decode$field,
			'tags',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Ports$FileSaver$rqzLoaded = _Platform_incomingPort(
	'rqzLoaded',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Page$ImportQuizes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$FileSaver$rqzLoaded($author$project$Page$ImportQuizes$FileLoaded),
				(model.bO === 5) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$ImportQuizes$TagChooserMsg,
				$author$project$Page$TagChooser$subscriptions(model.dv)) : $elm$core$Platform$Sub$none,
				$author$project$Env$quizesDownloaded(
				function (_v0) {
					var quizes = _v0.gU;
					var tags = _v0.fn;
					return A2($author$project$Page$ImportQuizes$ImportQuizes, quizes, tags);
				})
			]));
};
var $author$project$Page$Index$GotStatistics = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Index$TagChooserMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$QuizDB$gotStatistics = _Platform_incomingPort('gotStatistics', $elm$json$Json$Decode$value);
var $author$project$BarChart$AnimationFrame = $elm$core$Basics$identity;
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {c_: oldTime, e_: request, fl: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.e_;
		var oldTime = _v0.c_;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.fl;
		var oldTime = _v0.c_;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $author$project$BarChart$subscriptions = function (model) {
	var animationSubscription = (_Utils_cmp(model.aV, model.bX) < 0) ? $elm$browser$Browser$Events$onAnimationFrameDelta($elm$core$Basics$identity) : $elm$core$Platform$Sub$none;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[animationSubscription]));
};
var $author$project$PieChart$AnimationFrame = function (a) {
	return {$: 0, a: a};
};
var $author$project$PieChart$subscriptions = function (model) {
	var animating = model.aV < 3000;
	var animationSubscription = animating ? $elm$browser$Browser$Events$onAnimationFrameDelta($author$project$PieChart$AnimationFrame) : $elm$core$Platform$Sub$none;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[animationSubscription]));
};
var $author$project$Page$Index$subscriptions = function (model) {
	var chartSubscriptions = function () {
		var _v0 = model.dO;
		if (_v0.$ === 1) {
			var barChartModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$Index$BarChartMsg,
				$author$project$BarChart$subscriptions(barChartModel));
		} else {
			var pieChartModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$Index$PieChartMsg,
				$author$project$PieChart$subscriptions(pieChartModel));
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$QuizDB$gotStatistics($author$project$Page$Index$GotStatistics),
				chartSubscriptions,
				(model.bO === 1) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$Index$TagChooserMsg,
				$author$project$Page$TagChooser$subscriptions(model.dv)) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Page$Learn$OnAnimation = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Learn$QuestionReady = function (a) {
	return {$: 1, a: a};
};
var $author$project$QuizDB$gotNextScheduledReview = _Platform_incomingPort(
	'gotNextScheduledReview',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$value));
var $author$project$Page$Learn$GotScheduledReview = function (a) {
	return {$: 4, a: a};
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Data$Quizes$QuizEntry = function (quiz) {
	return {de: quiz};
};
var $author$project$Data$Quizes$intToBool = function (i) {
	if (!i) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Data$Quizes$quizRecordDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Quizes$QuizRecord,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'question',
		A2($elm$json$Json$Decode$map, $author$project$Data$Quizes$QuizEntry, $elm$json$Json$Decode$string)),
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Data$Quizes$QuizResult,
		A2($elm$json$Json$Decode$field, 'masteringCount', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'totalCount', $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'next_review',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Quizes$intToBool,
		A2($elm$json$Json$Decode$field, 'boost', $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'tags',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Learn$gotScheduledReview = function (values) {
	var records = A2(
		$elm$core$List$filterMap,
		$elm$core$Result$toMaybe,
		A2(
			$elm$core$List$map,
			$elm$json$Json$Decode$decodeValue($author$project$Data$Quizes$quizRecordDecoder),
			values));
	return $author$project$Page$Learn$GotScheduledReview(records);
};
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $author$project$QuizDB$questionReady = _Platform_incomingPort(
	'questionReady',
	A2(
		$elm$json$Json$Decode$andThen,
		function (version) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (name) {
					return $elm$json$Json$Decode$succeed(
						{gC: name, hs: version});
				},
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$int)));
var $author$project$Page$Learn$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$QuizDB$questionReady($author$project$Page$Learn$QuestionReady),
				$author$project$QuizDB$gotNextScheduledReview($author$project$Page$Learn$gotScheduledReview),
				function () {
				var _v0 = model.fj;
				if (!_v0.$) {
					return $elm$browser$Browser$Events$onAnimationFrame($author$project$Page$Learn$OnAnimation);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Page$Quizes$Confirmed = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Quizes$GotEntries = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Quizes$GotQuizes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Quizes$TagChooserMsg = function (a) {
	return {$: 16, a: a};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Data$Quizes$decodeQuizRecord = function (v) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Quizes$quizRecordDecoder, v);
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$Data$Quizes$foldResult = function (results) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (res, acc) {
				return A3(
					$elm$core$Result$map2,
					F2(
						function (r, lr) {
							return A2($elm$core$List$cons, r, lr);
						}),
					res,
					acc);
			}),
		$elm$core$Result$Ok(_List_Nil),
		results);
};
var $author$project$QuizDB$gotAllQuizes = _Platform_incomingPort(
	'gotAllQuizes',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$value));
var $author$project$QuizDB$gotEntries = _Platform_incomingPort(
	'gotEntries',
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (_v1) {
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple2(_v0, _v1));
					},
					A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$value));
			},
			A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string))));
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Ports$Browser$simpleConfirmed = _Platform_incomingPort('simpleConfirmed', $elm$json$Json$Decode$bool);
var $author$project$Page$Quizes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$QuizDB$gotAllQuizes($author$project$Page$Quizes$GotQuizes),
				(model.bO === 3) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$Quizes$TagChooserMsg,
				$author$project$Page$TagChooser$subscriptions(model.dv)) : $elm$core$Platform$Sub$none,
				$author$project$QuizDB$gotEntries(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						$elm$core$Tuple$mapSecond($author$project$Data$Quizes$decodeQuizRecord)),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							function (_v0) {
								var k = _v0.a;
								var res = _v0.b;
								return A2(
									$elm$core$Result$map,
									$elm$core$Tuple$pair(k),
									res);
							}),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Data$Quizes$foldResult,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Result$withDefault(_List_Nil),
								$author$project$Page$Quizes$GotEntries))))),
				$author$project$Ports$Browser$simpleConfirmed($author$project$Page$Quizes$Confirmed)
			]));
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$LearnMsg,
				$author$project$Page$Learn$subscriptions(model)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$IndexMsg,
				$author$project$Page$Index$subscriptions(model)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$QuizesMsg,
				$author$project$Page$Quizes$subscriptions(model)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$EditQuizMsg,
				$author$project$Page$EditQuiz$subscriptions(model)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$ImportQuizesMsg,
				$author$project$Page$ImportQuizes$subscriptions(model)),
				$author$project$QuizDB$dbError($author$project$Main$DBError)
			]));
};
var $author$project$Env$key = function (_v0) {
	var env = _v0;
	return env.ep;
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $billstclair$elm_sha256$Sha256$initialHs = function (is224) {
	return is224 ? {n: 3238371032, T: 914150663, U: 812702999, V: 4144912697, o: 4290775857, ab: 1750603025, ac: 1694076839, ai: 3204075428} : {n: 1779033703, T: 3144134277, U: 1013904242, V: 2773480762, o: 1359893119, ab: 2600822924, ac: 528734635, ai: 1541459225};
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $billstclair$elm_sha256$Sha256$extra = _List_fromArray(
	[-2147483648, 8388608, 32768, 128]);
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $billstclair$elm_sha256$Sha256$get = F2(
	function (index, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, index, array));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $billstclair$elm_sha256$Sha256$getAt = F2(
	function (index, list) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm_community$list_extra$List$Extra$getAt, index, list));
	});
var $billstclair$elm_sha256$Sha256$getShift = F2(
	function (i, n) {
		return 8 * (3 - ((i + n) & 3));
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $billstclair$elm_sha256$Sha256$orIntoBlocks = F3(
	function (idx, val, blocks) {
		return A3(
			$elm$core$Array$set,
			idx,
			val | A2($billstclair$elm_sha256$Sha256$get, idx, blocks),
			blocks);
	});
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $billstclair$elm_sha256$Sha256$sl = F2(
	function (num, shift) {
		return num << shift;
	});
var $billstclair$elm_sha256$Sha256$sr = F2(
	function (num, shift) {
		return num >> shift;
	});
var $billstclair$elm_sha256$Sha256$indexLoop = F5(
	function (i, index, message, length, blocks) {
		indexLoop:
		while (true) {
			if (!((_Utils_cmp(index, length) < 0) && (i < 64))) {
				return _Utils_Tuple3(i, index, blocks);
			} else {
				var shift = $billstclair$elm_sha256$Sha256$getShift(i);
				var code = A2($billstclair$elm_sha256$Sha256$get, index, message);
				var _v0 = (code < 128) ? _Utils_Tuple3(
					1,
					0,
					A2(
						$billstclair$elm_sha256$Sha256$sl,
						code,
						shift(0))) : ((code < 2048) ? _Utils_Tuple3(
					2,
					0,
					A2(
						$billstclair$elm_sha256$Sha256$sl,
						128 | (code & 63),
						shift(1)) | A2(
						$billstclair$elm_sha256$Sha256$sl,
						192 | A2($billstclair$elm_sha256$Sha256$sr, code, 6),
						shift(0))) : (((code < 55296) || (code >= 57344)) ? _Utils_Tuple3(
					3,
					0,
					A2(
						$billstclair$elm_sha256$Sha256$sl,
						128 | (code & 63),
						shift(2)) | (A2(
						$billstclair$elm_sha256$Sha256$sl,
						128 | (A2($billstclair$elm_sha256$Sha256$sr, code, 6) & 63),
						shift(1)) | A2(
						$billstclair$elm_sha256$Sha256$sl,
						224 | A2($billstclair$elm_sha256$Sha256$sr, code, 12),
						shift(0)))) : _Utils_Tuple3(
					4,
					1,
					function () {
						var code2 = (A2($billstclair$elm_sha256$Sha256$get, index + 1, message) & 1023) | (65536 + A2($billstclair$elm_sha256$Sha256$sl, code & 1023, 10));
						return A2(
							$billstclair$elm_sha256$Sha256$sl,
							128 | (code2 & 63),
							shift(3)) | (A2(
							$billstclair$elm_sha256$Sha256$sl,
							128 | (A2($billstclair$elm_sha256$Sha256$sr, code2, 6) & 63),
							shift(2)) | (A2(
							$billstclair$elm_sha256$Sha256$sl,
							128 | ((code2 >> 12) & 63),
							shift(1)) | A2(
							$billstclair$elm_sha256$Sha256$sl,
							240 | (code2 >> 18),
							shift(0))));
					}())));
				var iInc = _v0.a;
				var idxInc = _v0.b;
				var val = _v0.c;
				var blocks2 = A3(
					$billstclair$elm_sha256$Sha256$orIntoBlocks,
					A2($billstclair$elm_sha256$Sha256$sr, i, 2),
					val,
					blocks);
				var $temp$i = i + iInc,
					$temp$index = (index + idxInc) + 1,
					$temp$message = message,
					$temp$length = length,
					$temp$blocks = blocks2;
				i = $temp$i;
				index = $temp$index;
				message = $temp$message;
				length = $temp$length;
				blocks = $temp$blocks;
				continue indexLoop;
			}
		}
	});
var $billstclair$elm_sha256$Sha256$srz = F2(
	function (num, shift) {
		return num >>> shift;
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $billstclair$elm_sha256$Sha256$jLoop1 = F2(
	function (j, blocks) {
		jLoop1:
		while (true) {
			var t2 = A2($billstclair$elm_sha256$Sha256$get, j - 2, blocks);
			var t1 = A2($billstclair$elm_sha256$Sha256$get, j - 15, blocks);
			var s1 = A2($billstclair$elm_sha256$Sha256$srz, t2, 10) ^ ((A2($billstclair$elm_sha256$Sha256$srz, t2, 19) | A2($billstclair$elm_sha256$Sha256$sl, t2, 13)) ^ (A2($billstclair$elm_sha256$Sha256$srz, t2, 17) | A2($billstclair$elm_sha256$Sha256$sl, t2, 15)));
			var s0 = A2($billstclair$elm_sha256$Sha256$srz, t1, 3) ^ ((A2($billstclair$elm_sha256$Sha256$srz, t1, 18) | A2($billstclair$elm_sha256$Sha256$sl, t1, 14)) ^ (A2($billstclair$elm_sha256$Sha256$srz, t1, 7) | A2($billstclair$elm_sha256$Sha256$sl, t1, 25)));
			var blocks2 = A3(
				$elm$core$Array$set,
				j,
				A2(
					$billstclair$elm_sha256$Sha256$sl,
					((A2($billstclair$elm_sha256$Sha256$get, j - 16, blocks) + s0) + A2($billstclair$elm_sha256$Sha256$get, j - 7, blocks)) + s1,
					0),
				blocks);
			if (j < 63) {
				var $temp$j = j + 1,
					$temp$blocks = blocks2;
				j = $temp$j;
				blocks = $temp$blocks;
				continue jLoop1;
			} else {
				return blocks2;
			}
		}
	});
var $billstclair$elm_sha256$Sha256$ks = $elm$core$Array$fromList(
	_List_fromArray(
		[1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]));
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $billstclair$elm_sha256$Sha256$lognot = $elm$core$Bitwise$complement;
var $billstclair$elm_sha256$Sha256$jLoopBody2 = F4(
	function (j, ab, hs, blocks) {
		var h = hs.ai;
		var s1 = (A2($billstclair$elm_sha256$Sha256$srz, h, 25) | A2($billstclair$elm_sha256$Sha256$sl, h, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, h, 11) | A2($billstclair$elm_sha256$Sha256$sl, h, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, h, 6) | A2($billstclair$elm_sha256$Sha256$sl, h, 26)));
		var g = hs.ac;
		var f = hs.ab;
		var e = hs.o;
		var d = hs.V;
		var s0 = (A2($billstclair$elm_sha256$Sha256$srz, d, 22) | A2($billstclair$elm_sha256$Sha256$sl, d, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, d, 13) | A2($billstclair$elm_sha256$Sha256$sl, d, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, d, 2) | A2($billstclair$elm_sha256$Sha256$sl, d, 30)));
		var ch = ($billstclair$elm_sha256$Sha256$lognot(h) & f) ^ (h & e);
		var t1 = (((g + s1) + ch) + A2($billstclair$elm_sha256$Sha256$get, j + 1, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j + 1, blocks);
		var c = hs.U;
		var g2 = A2($billstclair$elm_sha256$Sha256$sl, c + t1, 0);
		var ch2 = (g2 & h) ^ ($billstclair$elm_sha256$Sha256$lognot(g2) & e);
		var s3 = (A2($billstclair$elm_sha256$Sha256$srz, g2, 25) | A2($billstclair$elm_sha256$Sha256$sl, g2, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, g2, 11) | A2($billstclair$elm_sha256$Sha256$sl, g2, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, g2, 6) | A2($billstclair$elm_sha256$Sha256$sl, g2, 26)));
		var t3 = (((f + s3) + ch2) + A2($billstclair$elm_sha256$Sha256$get, j + 2, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j + 2, blocks);
		var b = hs.T;
		var f2 = A2($billstclair$elm_sha256$Sha256$sl, b + t3, 0);
		var ch3 = (f2 & g2) ^ ($billstclair$elm_sha256$Sha256$lognot(f2) & h);
		var s5 = (A2($billstclair$elm_sha256$Sha256$srz, f2, 25) | A2($billstclair$elm_sha256$Sha256$sl, f2, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, f2, 11) | A2($billstclair$elm_sha256$Sha256$sl, f2, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, f2, 6) | A2($billstclair$elm_sha256$Sha256$sl, f2, 26)));
		var t5 = (((e + s5) + ch3) + A2($billstclair$elm_sha256$Sha256$get, j + 3, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j + 3, blocks);
		var a = hs.n;
		var da = d & a;
		var maj = ab ^ (da ^ (d & b));
		var t2 = s0 + maj;
		var c2 = A2($billstclair$elm_sha256$Sha256$sl, t1 + t2, 0);
		var cd = c2 & d;
		var s2 = (A2($billstclair$elm_sha256$Sha256$srz, c2, 22) | A2($billstclair$elm_sha256$Sha256$sl, c2, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, c2, 13) | A2($billstclair$elm_sha256$Sha256$sl, c2, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, c2, 2) | A2($billstclair$elm_sha256$Sha256$sl, c2, 30)));
		var e2 = A2($billstclair$elm_sha256$Sha256$sl, a + t5, 0);
		var maj2 = da ^ (cd ^ (c2 & a));
		var t4 = s2 + maj2;
		var b2 = A2($billstclair$elm_sha256$Sha256$sl, t3 + t4, 0);
		var bc = b2 & c2;
		var maj3 = cd ^ (bc ^ (b2 & d));
		var s4 = (A2($billstclair$elm_sha256$Sha256$srz, b2, 22) | A2($billstclair$elm_sha256$Sha256$sl, b2, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, b2, 13) | A2($billstclair$elm_sha256$Sha256$sl, b2, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, b2, 2) | A2($billstclair$elm_sha256$Sha256$sl, b2, 30)));
		var t6 = s4 + maj3;
		var a2 = A2($billstclair$elm_sha256$Sha256$sl, t5 + t6, 0);
		return {n: a2, T: b2, U: c2, V: d, o: e2, ab: f2, ac: g2, ai: h};
	});
var $billstclair$elm_sha256$Sha256$jLoop2 = F5(
	function (j, first, is224, hs, blocks) {
		jLoop2:
		while (true) {
			var jp4 = j + 4;
			var first2 = false;
			var _v0 = function () {
				if (first) {
					if (is224) {
						var t1 = A2($billstclair$elm_sha256$Sha256$get, 0, blocks) - 1413257819;
						return _Utils_Tuple3(
							300032,
							A2($billstclair$elm_sha256$Sha256$sl, t1 - 150054599, 0),
							A2($billstclair$elm_sha256$Sha256$sl, t1 + 24177077, 0));
					} else {
						var t2 = A2($billstclair$elm_sha256$Sha256$get, 0, blocks) - 210244248;
						return _Utils_Tuple3(
							704751109,
							A2($billstclair$elm_sha256$Sha256$sl, t2 - 1521486534, 0),
							A2($billstclair$elm_sha256$Sha256$sl, t2 + 143694565, 0));
					}
				} else {
					var s1 = (A2($billstclair$elm_sha256$Sha256$srz, hs.o, 25) | A2($billstclair$elm_sha256$Sha256$sl, hs.o, 7)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, hs.o, 11) | A2($billstclair$elm_sha256$Sha256$sl, hs.o, 21)) ^ (A2($billstclair$elm_sha256$Sha256$srz, hs.o, 6) | A2($billstclair$elm_sha256$Sha256$sl, hs.o, 26)));
					var s0 = (A2($billstclair$elm_sha256$Sha256$srz, hs.n, 22) | A2($billstclair$elm_sha256$Sha256$sl, hs.n, 10)) ^ ((A2($billstclair$elm_sha256$Sha256$srz, hs.n, 13) | A2($billstclair$elm_sha256$Sha256$sl, hs.n, 19)) ^ (A2($billstclair$elm_sha256$Sha256$srz, hs.n, 2) | A2($billstclair$elm_sha256$Sha256$sl, hs.n, 30)));
					var ch = (hs.o & hs.ab) ^ ($billstclair$elm_sha256$Sha256$lognot(hs.o) & hs.ac);
					var t3 = (((hs.ai + s1) + ch) + A2($billstclair$elm_sha256$Sha256$get, j, $billstclair$elm_sha256$Sha256$ks)) + A2($billstclair$elm_sha256$Sha256$get, j, blocks);
					var ab2 = hs.n & hs.T;
					var maj = (hs.T & hs.U) ^ (ab2 ^ (hs.n & hs.U));
					var t4 = s0 + maj;
					return _Utils_Tuple3(
						ab2,
						A2($billstclair$elm_sha256$Sha256$sl, hs.V + t3, 0),
						A2($billstclair$elm_sha256$Sha256$sl, t3 + t4, 0));
				}
			}();
			var ab = _v0.a;
			var h = _v0.b;
			var d = _v0.c;
			var hs2 = _Utils_update(
				hs,
				{V: d, ai: h});
			var hs3 = A4($billstclair$elm_sha256$Sha256$jLoopBody2, j, ab, hs2, blocks);
			if (jp4 < 64) {
				var $temp$j = jp4,
					$temp$first = first2,
					$temp$is224 = is224,
					$temp$hs = hs3,
					$temp$blocks = blocks;
				j = $temp$j;
				first = $temp$first;
				is224 = $temp$is224;
				hs = $temp$hs;
				blocks = $temp$blocks;
				continue jLoop2;
			} else {
				return hs3;
			}
		}
	});
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $billstclair$elm_sha256$Sha256$makeBlocks = function (block) {
	return A3(
		$elm$core$Array$set,
		0,
		block,
		A2($elm$core$Array$repeat, 64, 0));
};
var $billstclair$elm_sha256$Sha256$sumHS = F2(
	function (hs1, hs2) {
		return {
			n: A2($billstclair$elm_sha256$Sha256$sl, hs1.n + hs2.n, 0),
			T: A2($billstclair$elm_sha256$Sha256$sl, hs1.T + hs2.T, 0),
			U: A2($billstclair$elm_sha256$Sha256$sl, hs1.U + hs2.U, 0),
			V: A2($billstclair$elm_sha256$Sha256$sl, hs1.V + hs2.V, 0),
			o: A2($billstclair$elm_sha256$Sha256$sl, hs1.o + hs2.o, 0),
			ab: A2($billstclair$elm_sha256$Sha256$sl, hs1.ab + hs2.ab, 0),
			ac: A2($billstclair$elm_sha256$Sha256$sl, hs1.ac + hs2.ac, 0),
			ai: A2($billstclair$elm_sha256$Sha256$sl, hs1.ai + hs2.ai, 0)
		};
	});
var $billstclair$elm_sha256$Sha256$outerLoop = F9(
	function (first, hs, block, start, bytes, index, is224, message, length) {
		outerLoop:
		while (true) {
			var blocks = $billstclair$elm_sha256$Sha256$makeBlocks(block);
			var _v0 = A5($billstclair$elm_sha256$Sha256$indexLoop, start, index, message, length, blocks);
			var i = _v0.a;
			var index2 = _v0.b;
			var blocks2 = _v0.c;
			var bytes2 = (bytes + i) - start;
			var start2 = i - 64;
			var _v1 = _Utils_eq(index2, length) ? _Utils_Tuple2(
				A3(
					$billstclair$elm_sha256$Sha256$orIntoBlocks,
					A2($billstclair$elm_sha256$Sha256$sr, i, 2),
					A2($billstclair$elm_sha256$Sha256$getAt, i & 3, $billstclair$elm_sha256$Sha256$extra),
					blocks2),
				index2 + 1) : _Utils_Tuple2(blocks2, index2);
			var blocks3 = _v1.a;
			var index3 = _v1.b;
			var block2 = A2($billstclair$elm_sha256$Sha256$get, 16, blocks3);
			var _v2 = ((_Utils_cmp(index3, length) > 0) && (i < 56)) ? _Utils_Tuple2(
				true,
				A3(
					$elm$core$Array$set,
					15,
					A2($billstclair$elm_sha256$Sha256$sl, bytes2, 3),
					blocks3)) : _Utils_Tuple2(false, blocks3);
			var end = _v2.a;
			var blocks4 = _v2.b;
			var blocks5 = A2($billstclair$elm_sha256$Sha256$jLoop1, 16, blocks4);
			var hs2 = A5($billstclair$elm_sha256$Sha256$jLoop2, 0, first, is224, hs, blocks5);
			var hs3 = A2($billstclair$elm_sha256$Sha256$sumHS, hs, hs2);
			if (!end) {
				var $temp$first = false,
					$temp$hs = hs3,
					$temp$block = block2,
					$temp$start = start2,
					$temp$bytes = bytes2,
					$temp$index = index3,
					$temp$is224 = is224,
					$temp$message = message,
					$temp$length = length;
				first = $temp$first;
				hs = $temp$hs;
				block = $temp$block;
				start = $temp$start;
				bytes = $temp$bytes;
				index = $temp$index;
				is224 = $temp$is224;
				message = $temp$message;
				length = $temp$length;
				continue outerLoop;
			} else {
				return hs3;
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $billstclair$elm_sha256$Sha256$stringToMessage = function (string) {
	return $elm$core$Array$fromList(
		A2(
			$elm$core$List$map,
			$elm$core$Char$toCode,
			$elm$core$String$toList(string)));
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Char$fromCode = _Char_fromCode;
var $billstclair$elm_sha256$Sha256$toHex1 = function (x) {
	var x2 = x & 15;
	return $elm$core$Char$fromCode(
		x2 + ((x2 < 10) ? $elm$core$Char$toCode('0') : ((-10) + $elm$core$Char$toCode('a'))));
};
var $billstclair$elm_sha256$Sha256$toHex8 = function (x) {
	return $elm$core$String$fromList(
		A2(
			$elm$core$List$map,
			function (shift) {
				return $billstclair$elm_sha256$Sha256$toHex1(
					A2($billstclair$elm_sha256$Sha256$sr, x, shift));
			},
			_List_fromArray(
				[28, 24, 20, 16, 12, 8, 4, 0])));
};
var $billstclair$elm_sha256$Sha256$toHex56 = function (hs) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Basics$append,
		'',
		A2(
			$elm$core$List$map,
			$billstclair$elm_sha256$Sha256$toHex8,
			_List_fromArray(
				[hs.n, hs.T, hs.U, hs.V, hs.o, hs.ab, hs.ac])));
};
var $billstclair$elm_sha256$Sha256$toHex64 = function (hs) {
	return _Utils_ap(
		$billstclair$elm_sha256$Sha256$toHex56(hs),
		$billstclair$elm_sha256$Sha256$toHex8(hs.ai));
};
var $billstclair$elm_sha256$Sha256$hash = F2(
	function (string, is224) {
		var start = 0;
		var message = $billstclair$elm_sha256$Sha256$stringToMessage(string);
		var length = $elm$core$Array$length(message);
		var index = 0;
		var hs = $billstclair$elm_sha256$Sha256$initialHs(is224);
		var bytes = 0;
		var block = 0;
		var hs2 = A9($billstclair$elm_sha256$Sha256$outerLoop, true, hs, block, start, bytes, index, is224, message, length);
		return is224 ? $billstclair$elm_sha256$Sha256$toHex56(hs2) : $billstclair$elm_sha256$Sha256$toHex64(hs2);
	});
var $billstclair$elm_sha256$Sha256$sha256 = function (string) {
	return A2($billstclair$elm_sha256$Sha256$hash, string, false);
};
var $author$project$Data$Quizes$makeRecord = F2(
	function (tags, quiz) {
		var key = $billstclair$elm_sha256$Sha256$sha256(quiz);
		var initialSchedule = $elm$time$Time$millisToPosix(0);
		var initialResult = A2($author$project$Data$Quizes$QuizResult, 0, 0);
		var entry = $author$project$Data$Quizes$QuizEntry(quiz);
		var boosted = false;
		return A6($author$project$Data$Quizes$QuizRecord, key, entry, initialResult, initialSchedule, boosted, tags);
	});
var $author$project$Data$Quizes$boolToInt = function (b) {
	return b ? 1 : 0;
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Data$Quizes$quizRecordEncoder = function (record) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(record.ep)),
				_Utils_Tuple2(
				'question',
				$elm$json$Json$Encode$string(record.d3.de)),
				_Utils_Tuple2(
				'next_review',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(record.eF))),
				_Utils_Tuple2(
				'boost',
				$elm$json$Json$Encode$int(
					$author$project$Data$Quizes$boolToInt(record.dL))),
				_Utils_Tuple2(
				'masteringCount',
				$elm$json$Json$Encode$int(record.dh.ey)),
				_Utils_Tuple2(
				'totalCount',
				$elm$json$Json$Encode$int(record.dh.fs)),
				_Utils_Tuple2(
				'tags',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, record.fn))
			]));
};
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Page$EditQuiz$GetQuiz = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$EditQuiz$Previewed = function (a) {
	return {$: 14, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Env$confirm = _Platform_outgoingPort(
	'confirm',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.gx)),
					_Utils_Tuple2(
					'result',
					$elm$core$Basics$identity($.dh))
				]));
	});
var $author$project$QuizDB$deleteQuiz = _Platform_outgoingPort('deleteQuiz', $elm$json$Json$Encode$string);
var $elm$random$Random$Generate = $elm$core$Basics$identity;
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0;
		return A2($elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			A2($elm$random$Random$map, tagger, generator));
	});
var $author$project$QuizDB$getQuiz = _Platform_outgoingPort('getQuiz', $elm$json$Json$Encode$string);
var $author$project$QuizDB$getTags = _Platform_outgoingPort('getTags', $elm$json$Json$Encode$string);
var $author$project$Page$TagChooser$init = function (tags) {
	return _Utils_Tuple2(
		{g3: false, hd: _List_Nil, he: '', fn: tags},
		$author$project$QuizDB$getTags(''));
};
var $elm$core$String$lines = _String_lines;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Page$EditQuiz$pickBase64 = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $elm$core$List$head, $elm$core$List$reverse),
	$elm$core$String$split(','));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$EditQuiz$pickMimeType = function (dataUrl) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$List$head,
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$List$tail,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split('/'),
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split(';'),
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$List$head,
							A2(
								$elm$core$Maybe$map,
								$elm$core$String$split(','),
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$List$head,
									$elm$core$List$tail(
										A2($elm$core$String$split, ':', dataUrl))))))))));
};
var $author$project$WikiParser$Grammar$Question = F2(
	function (quiz, image) {
		return {gl: image, de: quiz};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {dQ: col, fX: contextStack, eR: problem, e2: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.e2, s.dQ, x, s.d));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.b, s.e2, s.dQ, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{dQ: newCol, d: s.d, h: s.h, b: newOffset, e2: newRow, a: s.a});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $author$project$WikiParser$Grammar$imageEnd = $elm$parser$Parser$symbol(']>');
var $author$project$WikiParser$Grammar$imageStart = $elm$parser$Parser$symbol('<[');
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.b, s.e2, s.dQ, s.a);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.a) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.b, adjustedOffset) < 0,
			0,
			{dQ: newCol, d: s.d, h: s.h, b: adjustedOffset, e2: newRow, a: s.a});
	};
};
var $elm$parser$Parser$chompUntilEndOr = $elm$parser$Parser$Advanced$chompUntilEndOr;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dQ: 1, d: s.d, h: s.h, b: s.b + 1, e2: s.e2 + 1, a: s.a}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dQ: s.dQ + 1, d: s.d, h: s.h, b: newOffset, e2: s.e2, a: s.a}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $author$project$WikiParser$Utils$notHelper = function (parser_) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return true;
				},
				$elm$parser$Parser$backtrackable(parser_)),
				$elm$parser$Parser$succeed(false)
			]));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $author$project$WikiParser$Utils$not = function (parser) {
	return A2(
		$elm$parser$Parser$andThen,
		function (chomped) {
			return chomped ? $elm$parser$Parser$problem('Not expected') : $elm$parser$Parser$chompIf(
				function (_v0) {
					return true;
				});
		},
		$author$project$WikiParser$Utils$notHelper(parser));
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.b, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $author$project$WikiParser$Utils$zeroOrMore = function (parser) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_v0) {
							var consumed = _v0.a;
							var res = _v0.b;
							return consumed ? $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, res, list)) : $elm$parser$Parser$Done(
								$elm$core$List$reverse(list));
						},
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									$elm$parser$Parser$succeed(
										F3(
											function (s, r, e) {
												return _Utils_Tuple2(
													!_Utils_eq(s, e),
													r);
											})),
									$elm$parser$Parser$getOffset),
								parser),
							$elm$parser$Parser$getOffset)),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $author$project$WikiParser$Utils$oneOrMore = function (parser) {
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed(
				F2(
					function (first, rest) {
						return A2($elm$core$List$cons, first, rest);
					})),
			parser),
		$author$project$WikiParser$Utils$zeroOrMore(parser));
};
var $author$project$WikiParser$Grammar$imageStringParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$getChompedString(
				$author$project$WikiParser$Utils$oneOrMore(
					$author$project$WikiParser$Utils$not(
						$elm$parser$Parser$symbol('|')))),
			$elm$parser$Parser$symbol('|'))),
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompUntilEndOr(']')));
var $author$project$WikiParser$Grammar$toDataUrl = function (_v0) {
	var imgFormat = _v0.a;
	var base64 = _v0.b;
	return 'data:image/' + (imgFormat + (';base64,' + base64));
};
var $elm$core$String$trim = _String_trim;
var $author$project$WikiParser$Grammar$imageParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$String$trim),
		$author$project$WikiParser$Grammar$imageStart),
	A2(
		$elm$parser$Parser$ignorer,
		A2($elm$parser$Parser$map, $author$project$WikiParser$Grammar$toDataUrl, $author$project$WikiParser$Grammar$imageStringParser),
		$author$project$WikiParser$Grammar$imageEnd));
var $author$project$WikiParser$Utils$optional = function (parser) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$map, $elm$core$Maybe$Just, parser),
				$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$WikiParser$Grammar$Option = function (a) {
	return {$: 1, a: a};
};
var $author$project$WikiParser$Grammar$optionEnd = $elm$parser$Parser$symbol(']]');
var $author$project$WikiParser$Grammar$optionStart = $elm$parser$Parser$symbol('[[');
var $author$project$WikiParser$Grammar$Options = F3(
	function (answer, dummies, config) {
		return {fI: answer, bU: config, aX: dummies};
	});
var $author$project$WikiParser$Grammar$comma = $elm$parser$Parser$symbol(',');
var $author$project$WikiParser$Grammar$configEnd = $elm$parser$Parser$symbol('}}');
var $author$project$WikiParser$Grammar$configStart = $elm$parser$Parser$symbol('{{');
var $author$project$WikiParser$Grammar$dummiesSeparator = $elm$parser$Parser$symbol('::');
var $author$project$WikiParser$Grammar$answerChar = $elm$parser$Parser$getChompedString(
	$author$project$WikiParser$Utils$not(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$author$project$WikiParser$Grammar$dummiesSeparator, $author$project$WikiParser$Grammar$configStart, $author$project$WikiParser$Grammar$configEnd, $author$project$WikiParser$Grammar$optionStart, $author$project$WikiParser$Grammar$optionEnd, $author$project$WikiParser$Grammar$comma]))));
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{dQ: col, d: s0.d, h: s0.h, b: offset, e2: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.e2, s.dQ, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $elm$parser$Parser$spaces = $elm$parser$Parser$Advanced$spaces;
var $author$project$WikiParser$Grammar$doubleQuotedString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$spaces),
		$elm$parser$Parser$symbol('\"')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile(
				function (c) {
					return c !== '\"';
				})),
		$elm$parser$Parser$symbol('\"')));
var $author$project$WikiParser$Grammar$answerString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$String$trim),
		$elm$parser$Parser$spaces),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$author$project$WikiParser$Utils$oneOrMore($author$project$WikiParser$Grammar$answerChar)),
				$author$project$WikiParser$Grammar$doubleQuotedString
			])));
var $author$project$WikiParser$Grammar$answerParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$List$cons),
		$author$project$WikiParser$Grammar$answerString),
	$author$project$WikiParser$Utils$zeroOrMore(
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$spaces),
				$author$project$WikiParser$Grammar$comma),
			$author$project$WikiParser$Grammar$answerString)));
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $author$project$WikiParser$Grammar$defaultConfig = {e9: false};
var $author$project$WikiParser$Grammar$configParser = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$backtrackable($author$project$WikiParser$Grammar$configStart)),
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$commit($author$project$WikiParser$Grammar$defaultConfig),
				$author$project$WikiParser$Grammar$configEnd)),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$backtrackable($elm$parser$Parser$spaces)),
			$elm$parser$Parser$commit($author$project$WikiParser$Grammar$defaultConfig))
		]));
var $author$project$WikiParser$Grammar$dummiesParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$author$project$WikiParser$Grammar$dummiesSeparator),
	$author$project$WikiParser$Grammar$answerParser);
var $author$project$WikiParser$Grammar$optionsParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$WikiParser$Grammar$Options),
			$author$project$WikiParser$Grammar$answerParser),
		A2(
			$elm$parser$Parser$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$author$project$WikiParser$Utils$optional($author$project$WikiParser$Grammar$dummiesParser))),
	A2(
		$elm$parser$Parser$map,
		$elm$core$Maybe$withDefault($author$project$WikiParser$Grammar$defaultConfig),
		$author$project$WikiParser$Utils$optional($author$project$WikiParser$Grammar$configParser)));
var $author$project$WikiParser$Grammar$option = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($author$project$WikiParser$Grammar$Option),
		$author$project$WikiParser$Grammar$optionStart),
	A2($elm$parser$Parser$ignorer, $author$project$WikiParser$Grammar$optionsParser, $author$project$WikiParser$Grammar$optionEnd));
var $author$project$WikiParser$Grammar$Sentence = function (a) {
	return {$: 0, a: a};
};
var $author$project$WikiParser$Grammar$sentenceString = A2(
	$elm$parser$Parser$keeper,
	$elm$parser$Parser$succeed($author$project$WikiParser$Grammar$Sentence),
	$elm$parser$Parser$getChompedString(
		$author$project$WikiParser$Utils$zeroOrMore(
			$author$project$WikiParser$Utils$not(
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$author$project$WikiParser$Grammar$optionStart, $author$project$WikiParser$Grammar$optionEnd, $author$project$WikiParser$Grammar$imageStart, $author$project$WikiParser$Grammar$imageEnd]))))));
var $author$project$WikiParser$Grammar$quizBodyParser = $author$project$WikiParser$Utils$zeroOrMore(
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[$author$project$WikiParser$Grammar$option, $author$project$WikiParser$Grammar$sentenceString])));
var $author$project$WikiParser$Grammar$questionParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($author$project$WikiParser$Grammar$Question),
		$author$project$WikiParser$Grammar$quizBodyParser),
	$author$project$WikiParser$Utils$optional($author$project$WikiParser$Grammar$imageParser));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {dQ: col, eR: problem, e2: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.e2, p.dQ, p.eR);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{dQ: 1, d: _List_Nil, h: 1, b: 0, e2: 1, a: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $author$project$WikiParser$parse = function (wiki) {
	return A2($elm$parser$Parser$run, $author$project$WikiParser$Grammar$questionParser, wiki);
};
var $author$project$Data$Quizes$BlankSelection = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Data$Quizes$Options = F2(
	function (options, userInput) {
		return {gM: options, hr: userInput};
	});
var $author$project$Data$Quizes$Text = function (a) {
	return {$: 0, a: a};
};
var $elm$random$Random$andThen = F2(
	function (callback, _v0) {
		var genA = _v0;
		return function (seed) {
			var _v1 = genA(seed);
			var result = _v1.a;
			var newSeed = _v1.b;
			var _v2 = callback(result);
			var genB = _v2;
			return genB(newSeed);
		};
	});
var $elm$random$Random$constant = function (value) {
	return function (seed) {
		return _Utils_Tuple2(value, seed);
	};
};
var $author$project$Page$Learn$foldRandomGeneratorList = function (generators) {
	var folder = F2(
		function (genA, gens) {
			return A2(
				$elm$random$Random$andThen,
				function (res) {
					return A2(
						$elm$random$Random$map,
						function (v) {
							return A2($elm$core$List$cons, v, res);
						},
						genA);
				},
				gens);
		});
	return A3(
		$elm$core$List$foldr,
		folder,
		$elm$random$Random$constant(_List_Nil),
		generators);
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Data$Quizes$BlankChoice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$CharacterClass$foldRandomGeneratorList = function (generators) {
	var folder = F2(
		function (genA, gens) {
			return A2(
				$elm$random$Random$andThen,
				function (res) {
					return A2(
						$elm$random$Random$map,
						function (v) {
							return A2($elm$core$List$cons, v, res);
						},
						genA);
				},
				gens);
		});
	return A3(
		$elm$core$List$foldr,
		folder,
		$elm$random$Random$constant(_List_Nil),
		generators);
};
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $author$project$CharacterClass$intCodes = A2(
	$elm$core$List$map,
	$elm$core$Char$toCode,
	_List_fromArray(
		['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']));
var $author$project$CharacterClass$floatCodes = _Utils_ap(
	$author$project$CharacterClass$intCodes,
	_List_fromArray(
		[
			$elm$core$Char$toCode('.')
		]));
var $author$project$CharacterClass$charRange = F2(
	function (l, h) {
		return A2(
			$elm$core$List$range,
			$elm$core$Char$toCode(l),
			$elm$core$Char$toCode(h));
	});
var $author$project$CharacterClass$hiraganaCodes = A2($author$project$CharacterClass$charRange, 'ぁ', 'ゔ');
var $author$project$CharacterClass$kanjiChars = _List_fromArray(
	['亜', '哀', '挨', '愛', '曖', '悪', '握', '圧', '扱', '宛', '嵐', '安', '案', '暗', '以', '衣', '位', '囲', '医', '依', '委', '威', '為', '畏', '胃', '尉', '異', '移', '萎', '偉', '椅', '彙', '意', '違', '維', '慰', '遺', '緯', '域', '育', '一', '壱', '逸', '茨', '芋', '引', '印', '因', '咽', '姻', '員', '院', '淫', '陰', '飲', '隠', '韻', '右', '宇', '羽', '雨', '唄', '鬱', '畝', '浦', '運', '雲', '永', '泳', '英', '映', '栄', '営', '詠', '影', '鋭', '衛', '易', '疫', '益', '液', '駅', '悦', '越', '謁', '閲', '円', '延', '沿', '炎', '怨', '宴', '媛', '援', '園', '煙', '猿', '遠', '鉛', '塩', '演', '縁', '艶', '汚', '王', '凹', '央', '応', '往', '押', '旺', '欧', '殴', '桜', '翁', '奥', '横', '岡', '屋', '億', '憶', '臆', '虞', '乙', '俺', '卸', '音', '恩', '温', '穏', '下', '化', '火', '加', '可', '仮', '何', '花', '佳', '価', '果', '河', '苛', '科', '架', '夏', '家', '荷', '華', '菓', '貨', '渦', '過', '嫁', '暇', '禍', '靴', '寡', '歌', '箇', '稼', '課', '蚊', '牙', '瓦', '我', '画', '芽', '賀', '雅', '餓', '介', '回', '灰', '会', '快', '戒', '改', '怪', '拐', '悔', '海', '界', '皆', '械', '絵', '開', '階', '塊', '楷', '解', '潰', '壊', '懐', '諧', '貝', '外', '劾', '害', '崖', '涯', '街', '慨', '蓋', '該', '概', '骸', '垣', '柿', '各', '角', '拡', '革', '格', '核', '殻', '郭', '覚', '較', '隔', '閣', '確', '獲', '嚇', '穫', '学', '岳', '楽', '額', '顎', '掛', '潟', '括', '活', '喝', '渇', '割', '葛', '滑', '褐', '轄', '且', '株', '釜', '鎌', '刈', '干', '刊', '甘', '汗', '缶', '完', '肝', '官', '冠', '巻', '看', '陥', '乾', '勘', '患', '貫', '寒', '喚', '堪', '換', '敢', '棺', '款', '間', '閑', '勧', '寛', '幹', '感', '漢', '慣', '管', '関', '歓', '監', '緩', '憾', '還', '館', '環', '簡', '観', '韓', '艦', '鑑', '丸', '含', '岸', '岩', '玩', '眼', '頑', '顔', '願', '企', '伎', '危', '机', '気', '岐', '希', '忌', '汽', '奇', '祈', '季', '紀', '軌', '既', '記', '起', '飢', '鬼', '帰', '基', '寄', '規', '亀', '喜', '幾', '揮', '期', '棋', '貴', '棄', '毀', '旗', '器', '畿', '輝', '機', '騎', '技', '宜', '偽', '欺', '義', '疑', '儀', '戯', '擬', '犠', '議', '菊', '吉', '喫', '詰', '却', '客', '脚', '逆', '虐', '九', '久', '及', '弓', '丘', '旧', '休', '吸', '朽', '臼', '求', '究', '泣', '急', '級', '糾', '宮', '救', '球', '給', '嗅', '窮', '牛', '去', '巨', '居', '拒', '拠', '挙', '虚', '許', '距', '魚', '御', '漁', '凶', '共', '叫', '狂', '京', '享', '供', '協', '況', '峡', '挟', '狭', '恐', '恭', '胸', '脅', '強', '教', '郷', '境', '橋', '矯', '鏡', '競', '響', '驚', '仰', '暁', '業', '凝', '曲', '局', '極', '玉', '巾', '斤', '均', '近', '金', '菌', '勤', '琴', '筋', '僅', '禁', '緊', '錦', '謹', '襟', '吟', '銀', '区', '句', '苦', '駆', '具', '惧', '愚', '空', '偶', '遇', '隅', '串', '屈', '掘', '窟', '熊', '繰', '君', '訓', '勲', '薫', '軍', '郡', '群', '兄', '刑', '形', '系', '径', '茎', '係', '型', '契', '計', '恵', '啓', '掲', '渓', '経', '蛍', '敬', '景', '軽', '傾', '携', '継', '詣', '慶', '憬', '稽', '憩', '警', '鶏', '芸', '迎', '鯨', '隙', '劇', '撃', '激', '桁', '欠', '穴', '血', '決', '結', '傑', '潔', '月', '犬', '件', '見', '券', '肩', '建', '研', '県', '倹', '兼', '剣', '拳', '軒', '健', '険', '圏', '堅', '検', '嫌', '献', '絹', '遣', '権', '憲', '賢', '謙', '鍵', '繭', '顕', '験', '懸', '元', '幻', '玄', '言', '弦', '限', '原', '現', '舷', '減', '源', '厳', '己', '戸', '古', '呼', '固', '股', '虎', '孤', '弧', '故', '枯', '個', '庫', '湖', '雇', '誇', '鼓', '錮', '顧', '五', '互', '午', '呉', '後', '娯', '悟', '碁', '語', '誤', '護', '口', '工', '公', '勾', '孔', '功', '巧', '広', '甲', '交', '光', '向', '后', '好', '江', '考', '行', '坑', '孝', '抗', '攻', '更', '効', '幸', '拘', '肯', '侯', '厚', '恒', '洪', '皇', '紅', '荒', '郊', '香', '候', '校', '耕', '航', '貢', '降', '高', '康', '控', '梗', '黄', '喉', '慌', '港', '硬', '絞', '項', '溝', '鉱', '構', '綱', '酵', '稿', '興', '衡', '鋼', '講', '購', '乞', '号', '合', '拷', '剛', '傲', '豪', '克', '告', '谷', '刻', '国', '黒', '穀', '酷', '獄', '骨', '駒', '込', '頃', '今', '困', '昆', '恨', '根', '婚', '混', '痕', '紺', '魂', '墾', '懇', '左', '佐', '沙', '査', '砂', '唆', '差', '詐', '鎖', '座', '挫', '才', '再', '災', '妻', '采', '砕', '宰', '栽', '彩', '採', '済', '祭', '斎', '細', '菜', '最', '裁', '債', '催', '塞', '歳', '載', '際', '埼', '在', '材', '剤', '財', '罪', '崎', '作', '削', '昨', '柵', '索', '策', '酢', '搾', '錯', '咲', '冊', '札', '刷', '刹', '拶', '殺', '察', '撮', '擦', '雑', '皿', '三', '山', '参', '桟', '蚕', '惨', '産', '傘', '散', '算', '酸', '賛', '残', '斬', '暫', '士', '子', '支', '止', '氏', '仕', '史', '司', '四', '市', '矢', '旨', '死', '糸', '至', '伺', '志', '私', '使', '刺', '始', '姉', '枝', '祉', '肢', '姿', '思', '指', '施', '師', '恣', '紙', '脂', '視', '紫', '詞', '歯', '嗣', '試', '詩', '資', '飼', '誌', '雌', '摯', '賜', '諮', '示', '字', '寺', '次', '耳', '自', '似', '児', '事', '侍', '治', '持', '時', '滋', '慈', '辞', '磁', '餌', '璽', '鹿', '式', '識', '軸', '七', '𠮟', '失', '室', '疾', '執', '湿', '嫉', '漆', '質', '実', '芝', '写', '社', '車', '舎', '者', '射', '捨', '赦', '斜', '煮', '遮', '謝', '邪', '蛇', '尺', '借', '酌', '釈', '爵', '若', '弱', '寂', '手', '主', '守', '朱', '取', '狩', '首', '殊', '珠', '酒', '腫', '種', '趣', '寿', '受', '呪', '授', '需', '儒', '樹', '収', '囚', '州', '舟', '秀', '周', '宗', '拾', '秋', '臭', '修', '袖', '終', '羞', '習', '週', '就', '衆', '集', '愁', '酬', '醜', '蹴', '襲', '十', '汁', '充', '住', '柔', '重', '従', '渋', '銃', '獣', '縦', '叔', '祝', '宿', '淑', '粛', '縮', '塾', '熟', '出', '述', '術', '俊', '春', '瞬', '旬', '巡', '盾', '准', '殉', '純', '循', '順', '準', '潤', '遵', '処', '初', '所', '書', '庶', '暑', '署', '緒', '諸', '女', '如', '助', '序', '叙', '徐', '除', '小', '升', '少', '召', '匠', '床', '抄', '肖', '尚', '招', '承', '昇', '松', '沼', '昭', '宵', '将', '消', '症', '祥', '称', '笑', '唱', '商', '渉', '章', '紹', '訟', '勝', '掌', '晶', '焼', '焦', '硝', '粧', '詔', '証', '象', '傷', '奨', '照', '詳', '彰', '障', '憧', '衝', '賞', '償', '礁', '鐘', '上', '丈', '冗', '条', '状', '乗', '城', '浄', '剰', '常', '情', '場', '畳', '蒸', '縄', '壌', '嬢', '錠', '譲', '醸', '色', '拭', '食', '植', '殖', '飾', '触', '嘱', '織', '職', '辱', '尻', '心', '申', '伸', '臣', '芯', '身', '辛', '侵', '信', '津', '神', '唇', '娠', '振', '浸', '真', '針', '深', '紳', '進', '森', '診', '寝', '慎', '新', '審', '震', '薪', '親', '人', '刃', '仁', '尽', '迅', '甚', '陣', '尋', '腎', '須', '図', '水', '吹', '垂', '炊', '帥', '粋', '衰', '推', '酔', '遂', '睡', '穂', '随', '髄', '枢', '崇', '数', '据', '杉', '裾', '寸', '瀬', '是', '井', '世', '正', '生', '成', '西', '声', '制', '姓', '征', '性', '青', '斉', '政', '星', '牲', '省', '凄', '逝', '清', '盛', '婿', '晴', '勢', '聖', '誠', '精', '製', '誓', '静', '請', '整', '醒', '税', '夕', '斥', '石', '赤', '昔', '析', '席', '脊', '隻', '惜', '戚', '責', '跡', '積', '績', '籍', '切', '折', '拙', '窃', '接', '設', '雪', '摂', '節', '説', '舌', '絶', '千', '川', '仙', '占', '先', '宣', '専', '泉', '浅', '洗', '染', '扇', '栓', '旋', '船', '戦', '煎', '羨', '腺', '詮', '践', '箋', '銭', '潜', '線', '遷', '選', '薦', '繊', '鮮', '全', '前', '善', '然', '禅', '漸', '膳', '繕', '狙', '阻', '祖', '租', '素', '措', '粗', '組', '疎', '訴', '塑', '遡', '礎', '双', '壮', '早', '争', '走', '奏', '相', '荘', '草', '送', '倉', '捜', '挿', '桑', '巣', '掃', '曹', '曽', '爽', '窓', '創', '喪', '痩', '葬', '装', '僧', '想', '層', '総', '遭', '槽', '踪', '操', '燥', '霜', '騒', '藻', '造', '像', '増', '憎', '蔵', '贈', '臓', '即', '束', '足', '促', '則', '息', '捉', '速', '側', '測', '俗', '族', '属', '賊', '続', '卒', '率', '存', '村', '孫', '尊', '損', '遜', '他', '多', '汰', '打', '妥', '唾', '堕', '惰', '駄', '太', '対', '体', '耐', '待', '怠', '胎', '退', '帯', '泰', '堆', '袋', '逮', '替', '貸', '隊', '滞', '態', '戴', '大', '代', '台', '第', '題', '滝', '宅', '択', '沢', '卓', '拓', '託', '濯', '諾', '濁', '但', '達', '脱', '奪', '棚', '誰', '丹', '旦', '担', '単', '炭', '胆', '探', '淡', '短', '嘆', '端', '綻', '誕', '鍛', '団', '男', '段', '断', '弾', '暖', '談', '壇', '地', '池', '知', '値', '恥', '致', '遅', '痴', '稚', '置', '緻', '竹', '畜', '逐', '蓄', '築', '秩', '窒', '茶', '着', '嫡', '中', '仲', '虫', '沖', '宙', '忠', '抽', '注', '昼', '柱', '衷', '酎', '鋳', '駐', '著', '貯', '丁', '弔', '庁', '兆', '町', '長', '挑', '帳', '張', '彫', '眺', '釣', '頂', '鳥', '朝', '貼', '超', '腸', '跳', '徴', '嘲', '潮', '澄', '調', '聴', '懲', '直', '勅', '捗', '沈', '珍', '朕', '陳', '賃', '鎮', '追', '椎', '墜', '通', '痛', '塚', '漬', '坪', '爪', '鶴', '低', '呈', '廷', '弟', '定', '底', '抵', '邸', '亭', '貞', '帝', '訂', '庭', '逓', '停', '偵', '堤', '提', '程', '艇', '締', '諦', '泥', '的', '笛', '摘', '滴', '適', '敵', '溺', '迭', '哲', '鉄', '徹', '撤', '天', '典', '店', '点', '展', '添', '転', '塡', '田', '伝', '殿', '電', '斗', '吐', '妬', '徒', '途', '都', '渡', '塗', '賭', '土', '奴', '努', '度', '怒', '刀', '冬', '灯', '当', '投', '豆', '東', '到', '逃', '倒', '凍', '唐', '島', '桃', '討', '透', '党', '悼', '盗', '陶', '塔', '搭', '棟', '湯', '痘', '登', '答', '等', '筒', '統', '稲', '踏', '糖', '頭', '謄', '藤', '闘', '騰', '同', '洞', '胴', '動', '堂', '童', '道', '働', '銅', '導', '瞳', '峠', '匿', '特', '得', '督', '徳', '篤', '毒', '独', '読', '栃', '凸', '突', '届', '屯', '豚', '頓', '貪', '鈍', '曇', '丼', '那', '奈', '内', '梨', '謎', '鍋', '南', '軟', '難', '二', '尼', '弐', '匂', '肉', '虹', '日', '入', '乳', '尿', '任', '妊', '忍', '認', '寧', '熱', '年', '念', '捻', '粘', '燃', '悩', '納', '能', '脳', '農', '濃', '把', '波', '派', '破', '覇', '馬', '婆', '罵', '拝', '杯', '背', '肺', '俳', '配', '排', '敗', '廃', '輩', '売', '倍', '梅', '培', '陪', '媒', '買', '賠', '白', '伯', '拍', '泊', '迫', '剝', '舶', '博', '薄', '麦', '漠', '縛', '爆', '箱', '箸', '畑', '肌', '八', '鉢', '発', '髪', '伐', '抜', '罰', '閥', '反', '半', '氾', '犯', '帆', '汎', '伴', '判', '坂', '阪', '板', '版', '班', '畔', '般', '販', '斑', '飯', '搬', '煩', '頒', '範', '繁', '藩', '晩', '番', '蛮', '盤', '比', '皮', '妃', '否', '批', '彼', '披', '肥', '非', '卑', '飛', '疲', '秘', '被', '悲', '扉', '費', '碑', '罷', '避', '尾', '眉', '美', '備', '微', '鼻', '膝', '肘', '匹', '必', '泌', '筆', '姫', '百', '氷', '表', '俵', '票', '評', '漂', '標', '苗', '秒', '病', '描', '猫', '品', '浜', '貧', '賓', '頻', '敏', '瓶', '不', '夫', '父', '付', '布', '扶', '府', '怖', '阜', '附', '訃', '負', '赴', '浮', '婦', '符', '富', '普', '腐', '敷', '膚', '賦', '譜', '侮', '武', '部', '舞', '封', '風', '伏', '服', '副', '幅', '復', '福', '腹', '複', '覆', '払', '沸', '仏', '物', '粉', '紛', '雰', '噴', '墳', '憤', '奮', '分', '文', '聞', '丙', '平', '兵', '併', '並', '柄', '陛', '閉', '塀', '幣', '弊', '蔽', '餅', '米', '壁', '璧', '癖', '別', '蔑', '片', '辺', '返', '変', '偏', '遍', '編', '弁', '便', '勉', '歩', '保', '哺', '捕', '補', '舗', '母', '募', '墓', '慕', '暮', '簿', '方', '包', '芳', '邦', '奉', '宝', '抱', '放', '法', '泡', '胞', '俸', '倣', '峰', '砲', '崩', '訪', '報', '蜂', '豊', '飽', '褒', '縫', '亡', '乏', '忙', '坊', '妨', '忘', '防', '房', '肪', '某', '冒', '剖', '紡', '望', '傍', '帽', '棒', '貿', '貌', '暴', '膨', '謀', '頰', '北', '木', '朴', '牧', '睦', '僕', '墨', '撲', '没', '勃', '堀', '本', '奔', '翻', '凡', '盆', '麻', '摩', '磨', '魔', '毎', '妹', '枚', '昧', '埋', '幕', '膜', '枕', '又', '末', '抹', '万', '満', '慢', '漫', '未', '味', '魅', '岬', '密', '蜜', '脈', '妙', '民', '眠', '矛', '務', '無', '夢', '霧', '娘', '名', '命', '明', '迷', '冥', '盟', '銘', '鳴', '滅', '免', '面', '綿', '麺', '茂', '模', '毛', '妄', '盲', '耗', '猛', '網', '目', '黙', '門', '紋', '問', '冶', '夜', '野', '弥', '厄', '役', '約', '訳', '薬', '躍', '闇', '由', '油', '喩', '愉', '諭', '輸', '癒', '唯', '友', '有', '勇', '幽', '悠', '郵', '湧', '猶', '裕', '遊', '雄', '誘', '憂', '融', '優', '与', '予', '余', '誉', '預', '幼', '用', '羊', '妖', '洋', '要', '容', '庸', '揚', '揺', '葉', '陽', '溶', '腰', '様', '瘍', '踊', '窯', '養', '擁', '謡', '曜', '抑', '沃', '浴', '欲', '翌', '翼', '拉', '裸', '羅', '来', '雷', '頼', '絡', '落', '酪', '辣', '乱', '卵', '覧', '濫', '藍', '欄', '吏', '利', '里', '理', '痢', '裏', '履', '璃', '離', '陸', '立', '律', '慄', '略', '柳', '流', '留', '竜', '粒', '隆', '硫', '侶', '旅', '虜', '慮', '了', '両', '良', '料', '涼', '猟', '陵', '量', '僚', '領', '寮', '療', '瞭', '糧', '力', '緑', '林', '厘', '倫', '輪', '隣', '臨', '瑠', '涙', '累', '塁', '類', '令', '礼', '冷', '励', '戻', '例', '鈴', '零', '霊', '隷', '齢', '麗', '暦', '歴', '列', '劣', '烈', '裂', '恋', '連', '廉', '練', '錬', '呂', '炉', '賂', '路', '露', '老', '労', '弄', '郎', '朗', '浪', '廊', '楼', '漏', '籠', '六', '録', '麓', '論', '和', '話', '賄', '脇', '惑', '枠', '湾', '腕']);
var $author$project$CharacterClass$kanjiCodes = A2($elm$core$List$map, $elm$core$Char$toCode, $author$project$CharacterClass$kanjiChars);
var $author$project$CharacterClass$katakanaCodes = _Utils_ap(
	A2($author$project$CharacterClass$charRange, 'ァ', 'ヴ'),
	_List_fromArray(
		[
			$elm$core$Char$toCode('ー')
		]));
var $author$project$CharacterClass$lowerEnglishCodes = A2($author$project$CharacterClass$charRange, 'a', 'z');
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$CharacterClass$nakaguroCodes = _List_fromArray(
	[
		$elm$core$Char$toCode('・')
	]);
var $author$project$CharacterClass$punctuationCodes = A2(
	$elm$core$List$map,
	$elm$core$Char$toCode,
	_List_fromArray(
		[' ', ':', '-', ',', ';', '.']));
var $author$project$CharacterClass$rationalCodes = _Utils_ap(
	$author$project$CharacterClass$intCodes,
	A2(
		$elm$core$List$map,
		$elm$core$Char$toCode,
		_List_fromArray(
			['/', '+', '-'])));
var $author$project$CharacterClass$upperEnglishCodes = A2($author$project$CharacterClass$charRange, 'A', 'Z');
var $author$project$CharacterClass$charsInSameGroup = function (code) {
	var allCodes = _Utils_ap(
		$author$project$CharacterClass$intCodes,
		_Utils_ap(
			$author$project$CharacterClass$floatCodes,
			_Utils_ap(
				$author$project$CharacterClass$rationalCodes,
				_Utils_ap(
					$author$project$CharacterClass$nakaguroCodes,
					_Utils_ap(
						$author$project$CharacterClass$katakanaCodes,
						_Utils_ap(
							$author$project$CharacterClass$hiraganaCodes,
							_Utils_ap($author$project$CharacterClass$kanjiCodes, $author$project$CharacterClass$punctuationCodes)))))));
	return A2($elm$core$List$member, code, $author$project$CharacterClass$intCodes) ? $author$project$CharacterClass$intCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$floatCodes) ? $author$project$CharacterClass$floatCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$rationalCodes) ? $author$project$CharacterClass$rationalCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$nakaguroCodes) ? $author$project$CharacterClass$nakaguroCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$katakanaCodes) ? $author$project$CharacterClass$katakanaCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$hiraganaCodes) ? $author$project$CharacterClass$hiraganaCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$upperEnglishCodes) ? $author$project$CharacterClass$upperEnglishCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$lowerEnglishCodes) ? $author$project$CharacterClass$lowerEnglishCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$kanjiCodes) ? $author$project$CharacterClass$kanjiCodes : (A2($elm$core$List$member, code, $author$project$CharacterClass$punctuationCodes) ? $author$project$CharacterClass$punctuationCodes : allCodes)))))))));
};
var $elm_community$random_extra$Random$List$get = F2(
	function (index, list) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, index, list));
	});
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$random_extra$Random$List$choose = function (list) {
	if ($elm$core$List$isEmpty(list)) {
		return $elm$random$Random$constant(
			_Utils_Tuple2($elm$core$Maybe$Nothing, list));
	} else {
		var lastIndex = $elm$core$List$length(list) - 1;
		var gen = A2($elm$random$Random$int, 0, lastIndex);
		var front = function (i) {
			return A2($elm$core$List$take, i, list);
		};
		var back = function (i) {
			return A2($elm$core$List$drop, i + 1, list);
		};
		return A2(
			$elm$random$Random$map,
			function (index) {
				return _Utils_Tuple2(
					A2($elm_community$random_extra$Random$List$get, index, list),
					A2(
						$elm$core$List$append,
						front(index),
						back(index)));
			},
			gen);
	}
};
var $author$project$CharacterClass$randomNearCode = function (code) {
	return A2(
		$elm$random$Random$map,
		function (_v0) {
			var c = _v0.a;
			return A2($elm$core$Maybe$withDefault, code, c);
		},
		$elm_community$random_extra$Random$List$choose(
			$author$project$CharacterClass$charsInSameGroup(code)));
};
var $author$project$CharacterClass$randomizedDummyString = function (s) {
	var chars = $author$project$CharacterClass$foldRandomGeneratorList(
		A2(
			$elm$core$List$map,
			$elm$random$Random$map(
				A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar)),
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Char$toCode, $author$project$CharacterClass$randomNearCode),
				$elm$core$String$toList(s))));
	return A2(
		$elm$random$Random$map,
		$elm$core$String$join(''),
		chars);
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$CharacterClass$randomizedDummy = F2(
	function (n, answers) {
		var longestAnswer = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				A2(
					$elm_community$list_extra$List$Extra$maximumBy,
					function (_v0) {
						var s = _v0.a;
						var l = _v0.b;
						return l;
					},
					A2(
						$elm$core$List$map,
						function (s) {
							return _Utils_Tuple2(
								s,
								$elm$core$String$length(s));
						},
						answers))));
		return $author$project$CharacterClass$foldRandomGeneratorList(
			A2(
				$elm$core$List$repeat,
				n,
				$author$project$CharacterClass$randomizedDummyString(longestAnswer)));
	});
var $author$project$Page$Learn$makeBlank = F2(
	function (answers, n) {
		var randomDummies = A2($author$project$CharacterClass$randomizedDummy, n, answers);
		return A2(
			$elm$random$Random$map,
			function (dummies) {
				return A2(
					$author$project$Data$Quizes$BlankChoice,
					$elm$core$Set$fromList(answers),
					A2(
						$author$project$Data$Quizes$Options,
						_Utils_ap(answers, dummies),
						A2(
							$elm$core$List$map,
							function (_v0) {
								return $elm$core$Maybe$Nothing;
							},
							answers)));
			},
			randomDummies);
	});
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0;
		return function (seed) {
			return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var $owanturist$elm_union_find$UnionFind$findFast = F2(
	function (id, dict) {
		findFast:
		while (true) {
			var _v0 = A2($elm$core$Dict$get, id, dict);
			if (_v0.$ === 1) {
				return id;
			} else {
				var cursor = _v0.a;
				if (_Utils_eq(id, cursor)) {
					return id;
				} else {
					var $temp$id = cursor,
						$temp$dict = dict;
					id = $temp$id;
					dict = $temp$dict;
					continue findFast;
				}
			}
		}
	});
var $owanturist$elm_union_find$UnionFind$find = F2(
	function (id, _v0) {
		var dict = _v0.b;
		return A2($owanturist$elm_union_find$UnionFind$findFast, id, dict);
	});
var $elm$core$Array$isEmpty = function (_v0) {
	var len = _v0.a;
	return !len;
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $owanturist$elm_union_find$UnionFind$QuickUnionPathCompression = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $owanturist$elm_union_find$UnionFind$quickUnionPathCompression = A2($owanturist$elm_union_find$UnionFind$QuickUnionPathCompression, 0, $elm$core$Dict$empty);
var $owanturist$elm_union_find$UnionFind$findCompressed = F2(
	function (id, dict) {
		var _v0 = A2($elm$core$Dict$get, id, dict);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(
				id,
				A3($elm$core$Dict$insert, id, id, dict));
		} else {
			var cursor = _v0.a;
			if (_Utils_eq(id, cursor)) {
				return _Utils_Tuple2(id, dict);
			} else {
				var _v1 = A2($owanturist$elm_union_find$UnionFind$findCompressed, cursor, dict);
				var parent = _v1.a;
				var nextDict = _v1.b;
				return _Utils_Tuple2(
					parent,
					A3($elm$core$Dict$insert, id, parent, nextDict));
			}
		}
	});
var $owanturist$elm_union_find$UnionFind$union = F3(
	function (left, right, _v0) {
		var count_ = _v0.a;
		var dict = _v0.b;
		var _v1 = A2($owanturist$elm_union_find$UnionFind$findCompressed, left, dict);
		var leftRoot = _v1.a;
		var leftDict = _v1.b;
		var _v2 = A2($owanturist$elm_union_find$UnionFind$findCompressed, right, leftDict);
		var rightRoot = _v2.a;
		var rightDict = _v2.b;
		return _Utils_eq(leftRoot, rightRoot) ? A2($owanturist$elm_union_find$UnionFind$QuickUnionPathCompression, count_, rightDict) : A2(
			$owanturist$elm_union_find$UnionFind$QuickUnionPathCompression,
			count_ + 1,
			A3($elm$core$Dict$insert, leftRoot, rightRoot, rightDict));
	});
var $elm_community$random_extra$Utils$selectUniqByIndexes = F2(
	function (values, randomIndexes) {
		var modByLength = $elm$core$Basics$modBy(
			$elm$core$Array$length(values));
		var step = F2(
			function (randomIndex, _v1) {
				var uf = _v1.a;
				var acc = _v1.b;
				var leaderOfElement = A2($owanturist$elm_union_find$UnionFind$find, randomIndex, uf);
				var leaderOfNextElement = A2(
					$owanturist$elm_union_find$UnionFind$find,
					modByLength(leaderOfElement + 1),
					uf);
				var _v0 = A2($elm$core$Array$get, leaderOfElement, values);
				if (_v0.$ === 1) {
					return _Utils_Tuple2(uf, acc);
				} else {
					var value = _v0.a;
					return _Utils_Tuple2(
						A3($owanturist$elm_union_find$UnionFind$union, leaderOfElement, leaderOfNextElement, uf),
						A2($elm$core$List$cons, value, acc));
				}
			});
		return $elm$core$Array$isEmpty(values) ? _List_Nil : A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2($owanturist$elm_union_find$UnionFind$quickUnionPathCompression, _List_Nil),
			randomIndexes).b;
	});
var $elm_community$random_extra$Random$List$shuffle = function (list) {
	var values = $elm$core$Array$fromList(list);
	var length = $elm$core$Array$length(values);
	return A2(
		$elm$random$Random$map,
		$elm_community$random_extra$Utils$selectUniqByIndexes(values),
		A2(
			$elm$random$Random$list,
			length,
			A2($elm$random$Random$int, 0, length - 1)));
};
var $author$project$Page$Learn$renderQuiz = function (q) {
	var quizBodyElements = A2(
		$elm$core$List$concatMap,
		function (seg) {
			if (seg.$ === 1) {
				var opt = seg.a;
				var dummies = (!$elm$core$List$length(opt.aX)) ? opt.aX : _Utils_ap(opt.fI, opt.aX);
				return A2(
					$elm$core$List$intersperse,
					A2(
						$elm$core$Tuple$pair,
						', ',
						$author$project$WikiParser$Grammar$Sentence(', ')),
					A2(
						$elm$core$List$map,
						function (ans) {
							return A2(
								$elm$core$Tuple$pair,
								ans,
								$author$project$WikiParser$Grammar$Option(
									_Utils_update(
										opt,
										{
											fI: _List_fromArray(
												[ans]),
											aX: dummies
										})));
						},
						opt.fI));
			} else {
				var s = seg.a;
				return _List_fromArray(
					[
						A2(
						$elm$core$Tuple$pair,
						s,
						$author$project$WikiParser$Grammar$Sentence(s))
					]);
			}
		},
		q.de);
	var indices = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, seg) {
					if (seg.b.$ === 1) {
						return $elm$core$Maybe$Just(index);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}),
			quizBodyElements));
	var blankIndices = A2(
		$elm$random$Random$map,
		$elm$core$List$take(1),
		$elm_community$random_extra$Random$List$shuffle(indices));
	var bodySegments = A2(
		$elm$random$Random$map,
		function (indices_) {
			return A2(
				$elm$core$List$map,
				function (_v2) {
					var index = _v2.a;
					var _v3 = _v2.b;
					var ans = _v3.a;
					var seg = _v3.b;
					if (A2($elm$core$List$member, index, indices_)) {
						return seg;
					} else {
						if (!seg.$) {
							var s = seg.a;
							return $author$project$WikiParser$Grammar$Sentence(s);
						} else {
							var opt = seg.a;
							return $author$project$WikiParser$Grammar$Sentence(ans);
						}
					}
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, quizBodyElements));
		},
		blankIndices);
	var body = A2(
		$elm$random$Random$andThen,
		function (b) {
			return $author$project$Page$Learn$foldRandomGeneratorList(
				A2(
					$elm$core$List$concatMap,
					function (qz) {
						if (!qz.$) {
							var s = qz.a;
							return _List_fromArray(
								[
									$elm$random$Random$constant(
									$author$project$Data$Quizes$Text(s))
								]);
						} else {
							var ops = qz.a;
							return (!$elm$core$List$length(ops.aX)) ? _List_fromArray(
								[
									A2($author$project$Page$Learn$makeBlank, ops.fI, 5)
								]) : _List_fromArray(
								[
									$elm$random$Random$constant(
									A2(
										$author$project$Data$Quizes$BlankSelection,
										$elm$core$Set$fromList(ops.fI),
										A2(
											$author$project$Data$Quizes$Options,
											_Utils_ap(ops.fI, ops.aX),
											A2(
												$elm$core$List$map,
												function (_v1) {
													return $elm$core$Maybe$Nothing;
												},
												ops.fI))))
								]);
						}
					},
					b));
		},
		bodySegments);
	return A2(
		$elm$random$Random$map,
		function (b) {
			return A2($author$project$Data$Quizes$Quiz, b, q.gl);
		},
		body);
};
var $author$project$Page$EditQuiz$unMaybeRandomGenerator = function (m) {
	if (m.$ === 1) {
		return $elm$random$Random$constant($elm$core$Maybe$Nothing);
	} else {
		var g = m.a;
		return A2($elm$random$Random$map, $elm$core$Maybe$Just, g);
	}
};
var $author$project$Page$EditQuiz$previewQuiz = function (quizText) {
	return $author$project$Page$EditQuiz$unMaybeRandomGenerator(
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$Learn$renderQuiz,
			$elm$core$Result$toMaybe(
				$author$project$WikiParser$parse(quizText))));
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Page$EditQuiz$replaceString = F3(
	function (s, options, _v0) {
		var start = _v0.a;
		var end = _v0.b;
		var dummies = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				$elm$core$String$trim),
			options);
		var dummiesString = (!$elm$core$List$isEmpty(dummies)) ? ('::' + A2($elm$core$String$join, ',', dummies)) : '';
		var chars = $elm$core$String$toList(s);
		var inParens = $elm$core$String$trim(
			$elm$core$String$fromList(
				A2(
					$elm$core$List$take,
					end - start,
					A2($elm$core$List$drop, start, chars))));
		var beforeParens = $elm$core$String$trim(
			$elm$core$String$fromList(
				A2($elm$core$List$take, start, chars)));
		var afterParens = $elm$core$String$trim(
			$elm$core$String$fromList(
				A2($elm$core$List$drop, end, chars)));
		return beforeParens + ('[[' + (inParens + (dummiesString + (']]' + afterParens))));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Route$routeToString = function (route) {
	var paths = function () {
		switch (route.$) {
			case 0:
				return _List_fromArray(
					['learn']);
			case 1:
				return _List_Nil;
			case 2:
				return _List_fromArray(
					['quizes']);
			case 4:
				return _List_fromArray(
					['quizes', 'import']);
			default:
				var hash = route.a;
				return _Utils_ap(
					_List_fromArray(
						['quizes', 'edit']),
					function () {
						if (!hash.$) {
							var h = hash.a;
							return _List_fromArray(
								[h]);
						} else {
							return _List_Nil;
						}
					}());
		}
	}();
	return A2(
		$elm$url$Url$Builder$absolute,
		A2($elm$core$List$cons, $author$project$Route$rootPath, paths),
		_List_Nil);
};
var $author$project$Page$EditQuiz$subString = F2(
	function (s, _v0) {
		var start = _v0.a;
		var end = _v0.b;
		return $elm$core$String$trim(
			$elm$core$String$fromList(
				A2(
					$elm$core$List$take,
					end - start,
					A2(
						$elm$core$List$drop,
						start,
						$elm$core$String$toList(s)))));
	});
var $author$project$ImageSelector$FileSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$ImageSelector$GotDataUrl = function (a) {
	return {$: 2, a: a};
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$ImageSelector$getObjectUrl = _Platform_outgoingPort('getObjectUrl', $elm$json$Json$Encode$string);
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $elm$core$Basics$sin = _Basics_sin;
var $author$project$ImageSelector$getRotateMatrix_ = function (theta) {
	var t = $elm$core$Basics$degrees(theta);
	return A6(
		$author$project$ImageSelector$ImageMatrix,
		$elm$core$Basics$cos(t),
		$elm$core$Basics$sin(t),
		-$elm$core$Basics$sin(t),
		$elm$core$Basics$cos(t),
		0,
		0);
};
var $author$project$ImageSelector$getTranslateMatrix = function (_v0) {
	var tx = _v0.a;
	var ty = _v0.b;
	return A6($author$project$ImageSelector$ImageMatrix, 1, 0, 0, 1, tx, ty);
};
var $author$project$ImageSelector$Vector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$ImageSelector$innerProduct = F2(
	function (_v0, _v1) {
		var a1 = _v0.a;
		var b1 = _v0.b;
		var c1 = _v0.c;
		var a2 = _v1.a;
		var b2 = _v1.b;
		var c2 = _v1.c;
		return ((a1 * a2) + (b1 * b2)) + (c1 * c2);
	});
var $author$project$ImageSelector$multImageMatrix = F2(
	function (_v0, _v1) {
		var a1 = _v0.a;
		var b1 = _v0.b;
		var c1 = _v0.c;
		var d1 = _v0.d;
		var tx1 = _v0.e;
		var ty1 = _v0.f;
		var a2 = _v1.a;
		var b2 = _v1.b;
		var c2 = _v1.c;
		var d2 = _v1.d;
		var tx2 = _v1.e;
		var ty2 = _v1.f;
		return A6(
			$author$project$ImageSelector$ImageMatrix,
			A2(
				$author$project$ImageSelector$innerProduct,
				A3($author$project$ImageSelector$Vector, a1, c1, tx1),
				A3($author$project$ImageSelector$Vector, a2, b2, 0)),
			A2(
				$author$project$ImageSelector$innerProduct,
				A3($author$project$ImageSelector$Vector, b1, d1, ty1),
				A3($author$project$ImageSelector$Vector, a2, b2, 0)),
			A2(
				$author$project$ImageSelector$innerProduct,
				A3($author$project$ImageSelector$Vector, a1, c1, tx1),
				A3($author$project$ImageSelector$Vector, c2, d2, 0)),
			A2(
				$author$project$ImageSelector$innerProduct,
				A3($author$project$ImageSelector$Vector, b1, d1, ty1),
				A3($author$project$ImageSelector$Vector, c2, d2, 0)),
			A2(
				$author$project$ImageSelector$innerProduct,
				A3($author$project$ImageSelector$Vector, a1, c1, tx1),
				A3($author$project$ImageSelector$Vector, tx2, ty2, 1)),
			A2(
				$author$project$ImageSelector$innerProduct,
				A3($author$project$ImageSelector$Vector, b1, d1, ty1),
				A3($author$project$ImageSelector$Vector, tx2, ty2, 1)));
	});
var $author$project$ImageSelector$getRotateMatrix = F2(
	function (_v0, theta) {
		var x = _v0.a;
		var y = _v0.b;
		var t2 = $author$project$ImageSelector$getTranslateMatrix(
			_Utils_Tuple2(x, y));
		var t1 = $author$project$ImageSelector$getTranslateMatrix(
			_Utils_Tuple2(-x, -y));
		var rot = $author$project$ImageSelector$getRotateMatrix_(theta);
		return A2(
			$author$project$ImageSelector$multImageMatrix,
			t2,
			A2($author$project$ImageSelector$multImageMatrix, rot, t1));
	});
var $author$project$ImageSelector$getScaleMatrix = function (s) {
	return A6($author$project$ImageSelector$ImageMatrix, s, 0, 0, s, 0, 0);
};
var $author$project$ImageSelector$initImageSize = _Utils_Tuple2(240, 240);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$ImageSelector$renderImage = _Platform_outgoingPort(
	'renderImage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'canvasImageMatrix',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$float)($.dM)),
					_Utils_Tuple2(
					'objectUrl',
					$elm$json$Json$Encode$string($.b5)),
					_Utils_Tuple2(
					'viewBox',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'h',
									$elm$json$Json$Encode$float($.ai)),
									_Utils_Tuple2(
									'w',
									$elm$json$Json$Encode$float($.aS)),
									_Utils_Tuple2(
									'x',
									$elm$json$Json$Encode$float($.cn)),
									_Utils_Tuple2(
									'y',
									$elm$json$Json$Encode$float($.co))
								]));
					}($.F))
				]));
	});
var $author$project$ImageSelector$revokeObjectUrl = _Platform_outgoingPort('revokeObjectUrl', $elm$json$Json$Encode$string);
var $author$project$ImageSelector$startTouches = F2(
	function (ev, model) {
		var t2 = A2(
			$elm$core$Maybe$andThen,
			$elm$core$List$head,
			$elm$core$List$tail(ev.bj));
		var t1 = $elm$core$List$head(ev.bj);
		var startTouchPair = A3(
			$elm$core$Maybe$map2,
			F2(
				function (t1_, t2_) {
					return _Utils_Tuple2(t1_.aW, t2_.aW);
				}),
			t1,
			t2);
		return _Utils_update(
			model,
			{an: startTouchPair});
	});
var $author$project$ImageSelector$toCanvasTransform = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	var tx = _v0.e;
	var ty = _v0.f;
	return _List_fromArray(
		[a, b, c, d, tx, ty]);
};
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$ImageSelector$Diff = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$ImageSelector$TriangularScale = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$ImageSelector$updateTempMatrix = function (model) {
	var startTouches_ = model.an;
	var currentTouches = model.ax;
	var scale_rot = A2(
		$elm$core$Maybe$map,
		function (_v13) {
			var dx = _v13.a;
			var dx_ = _v13.b;
			var dy = _v13.c;
			var dy_ = _v13.d;
			return A2(
				$author$project$ImageSelector$TriangularScale,
				((dx_ * dx) + (dy_ * dy)) / (A2($elm$core$Basics$pow, dx, 2) + A2($elm$core$Basics$pow, dy, 2)),
				((dy_ * dx) - (dx_ * dy)) / (A2($elm$core$Basics$pow, dx, 2) + A2($elm$core$Basics$pow, dy, 2)));
		},
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (_v7, _v10) {
					var _v8 = _v7.a;
					var x1 = _v8.a;
					var y1 = _v8.b;
					var _v9 = _v7.b;
					var x2 = _v9.a;
					var y2 = _v9.b;
					var _v11 = _v10.a;
					var x1_ = _v11.a;
					var y1_ = _v11.b;
					var _v12 = _v10.b;
					var x2_ = _v12.a;
					var y2_ = _v12.b;
					return A4($author$project$ImageSelector$Diff, x1 - x2, x1_ - x2_, y1 - y2, y1_ - y2_);
				}),
			startTouches_,
			currentTouches));
	var translate = A4(
		$elm$core$Maybe$map3,
		F3(
			function (_v2, _v4, _v6) {
				var _v3 = _v2.a;
				var x1 = _v3.a;
				var y1 = _v3.b;
				var _v5 = _v4.a;
				var x1_ = _v5.a;
				var y1_ = _v5.b;
				var s_cos = _v6.a;
				var s_sin = _v6.b;
				return _Utils_Tuple2((x1_ - (x1 * s_cos)) + (y1 * s_sin), (y1_ - (x1 * s_sin)) - (y1 * s_cos));
			}),
		startTouches_,
		currentTouches,
		scale_rot);
	var tMatrix = A3(
		$elm$core$Maybe$map2,
		F2(
			function (_v0, _v1) {
				var s_cos = _v0.a;
				var s_sin = _v0.b;
				var tx = _v1.a;
				var ty = _v1.b;
				return A6($author$project$ImageSelector$ImageMatrix, s_cos, s_sin, -s_sin, s_cos, tx, ty);
			}),
		scale_rot,
		translate);
	return _Utils_update(
		model,
		{
			ap: A2(
				$elm$core$Maybe$withDefault,
				model.x,
				A3(
					$elm$core$Maybe$map2,
					$author$project$ImageSelector$multImageMatrix,
					tMatrix,
					$elm$core$Maybe$Just(model.x)))
		});
};
var $author$project$ImageSelector$updateTouches = F2(
	function (ev, model) {
		var currentTouchPair = A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var t2 = A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					$elm$core$List$tail(ev.bj));
				var t1 = $elm$core$List$head(ev.bj);
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (t1_, t2_) {
							return _Utils_Tuple2(t1_.aW, t2_.aW);
						}),
					t1,
					t2);
			},
			model.an);
		return _Utils_update(
			model,
			{ax: currentTouchPair});
	});
var $author$project$ImageSelector$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['image/jpg']),
						$author$project$ImageSelector$FileSelected));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a_: 0,
							a$: 0,
							bC: $elm$core$Maybe$Nothing,
							ba: true,
							aF: $elm$core$Maybe$Nothing,
							F: A4($author$project$ImageSelector$ViewBox, 0, 0, $author$project$ImageSelector$initImageSize.a, $author$project$ImageSelector$initImageSize.b),
							G: $author$project$ImageSelector$initImageSize
						}),
					A2(
						$elm$core$Task$perform,
						$author$project$ImageSelector$GotDataUrl,
						$elm$file$File$toUrl(file)));
			case 2:
				var dataUrl = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$ImageSelector$getObjectUrl(dataUrl));
			case 3:
				var objectUrl = msg.a.b5;
				var dataUrl = msg.a.dX;
				var width = msg.a.fB;
				var height = msg.a.eb;
				var scaleMatrix = $author$project$ImageSelector$getScaleMatrix(
					A2($elm$core$Basics$max, model.F.aS / width, model.F.ai / height));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							x: scaleMatrix,
							a_: height,
							a$: width,
							a7: $elm$core$Maybe$Just(dataUrl),
							aC: $elm$core$Maybe$Just(objectUrl),
							ap: scaleMatrix
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var w = msg.a;
				var h = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a_: h, a$: w}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ev = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: $elm$core$Maybe$Just(ev.eP.aW)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ev = msg.a;
				var currentOffset = A2(
					$elm$core$Maybe$andThen,
					function (_v4) {
						return $elm$core$Maybe$Just(ev.eP.aW);
					},
					model.aF);
				var diff = A3(
					$elm$core$Maybe$map2,
					F2(
						function (start, current) {
							return A3(
								$elm$core$Tuple$mapBoth,
								function (x) {
									return x - start.a;
								},
								function (y) {
									return y - start.b;
								},
								current);
						}),
					model.aF,
					currentOffset);
				var _v1 = A2(
					$elm$core$Maybe$withDefault,
					model.G,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var dw = _v2.a;
							var dh = _v2.b;
							var _v3 = model.F;
							var w = _v3.aS;
							var h = _v3.ai;
							return A2(
								$elm$core$Tuple$pair,
								A2($elm$core$Basics$min, $author$project$ImageSelector$maxImageSize.a, w + dw),
								A2($elm$core$Basics$min, $author$project$ImageSelector$maxImageSize.b, h + dh));
						},
						diff));
				var w_ = _v1.a;
				var h_ = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_Tuple2(w_, h_)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var ev = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: $elm$core$Maybe$Nothing,
							F: A4($author$project$ImageSelector$ViewBox, 0, 0, model.G.a, model.G.b)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var ev = msg.a;
				return _Utils_Tuple2(
					A2($author$project$ImageSelector$startTouches, ev, model),
					$elm$core$Platform$Cmd$none);
			case 8:
				var ev = msg.a;
				return _Utils_Tuple2(
					$author$project$ImageSelector$updateTempMatrix(
						A2($author$project$ImageSelector$updateTouches, ev, model)),
					$elm$core$Platform$Cmd$none);
			case 9:
				var ev = msg.a;
				var currentImageMatrix = ($elm$core$List$length(ev.bj) > 1) ? model.x : model.ap;
				var _v5 = ($elm$core$List$length(ev.bj) > 1) ? _Utils_Tuple2(model.an, model.ax) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				var startTouchPair = _v5.a;
				var currentTouchPair = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{x: currentImageMatrix, ax: currentTouchPair, an: startTouchPair}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var deg = msg.a;
				var mat = A2(
					$author$project$ImageSelector$getRotateMatrix,
					_Utils_Tuple2(model.F.aS / 2, model.F.ai / 2),
					deg);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							x: A2($author$project$ImageSelector$multImageMatrix, mat, model.x),
							ap: A2($author$project$ImageSelector$multImageMatrix, mat, model.x)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var renderCmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (objectUrl_) {
							return $author$project$ImageSelector$renderImage(
								{
									dM: $author$project$ImageSelector$toCanvasTransform(model.x),
									b5: objectUrl_,
									F: model.F
								});
						},
						model.a7));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ba: false}),
					renderCmd);
			case 13:
				var url = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							x: $author$project$ImageSelector$identityImageMatrix,
							ax: $elm$core$Maybe$Nothing,
							a7: $elm$core$Maybe$Nothing,
							aC: $elm$core$Maybe$Nothing,
							bC: $elm$core$Maybe$Just(url),
							an: $elm$core$Maybe$Nothing,
							ap: $author$project$ImageSelector$identityImageMatrix
						}),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$ImageSelector$revokeObjectUrl, model.aC)));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{x: $author$project$ImageSelector$identityImageMatrix, ax: $elm$core$Maybe$Nothing, a7: $elm$core$Maybe$Nothing, aC: $elm$core$Maybe$Nothing, ba: false, an: $elm$core$Maybe$Nothing, ap: $author$project$ImageSelector$identityImageMatrix}),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$ImageSelector$revokeObjectUrl, model.aC)));
		}
	});
var $author$project$Page$TagChooser$ShowHideCandidates = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ports$Browser$saveTags = _Platform_outgoingPort(
	'saveTags',
	$elm$json$Json$Encode$list($elm$json$Json$Encode$string));
var $author$project$Page$TagChooser$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 4:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$QuizDB$getTags(model.he),
								A2(
								$elm$core$Task$perform,
								function (_v1) {
									return $author$project$Page$TagChooser$ShowHideCandidates(true);
								},
								$elm$core$Process$sleep(100))
							])));
			case 5:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						function (_v2) {
							return $author$project$Page$TagChooser$ShowHideCandidates(false);
						},
						$elm$core$Process$sleep(100)));
			case 6:
				var shown = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g3: shown}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var tag = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{he: tag}),
					$author$project$QuizDB$getTags(tag));
			case 1:
				var tag = msg.a;
				var trimmedTag = $elm$core$String$trim(tag);
				var newTags = ((trimmedTag === '') || A2($elm$core$List$member, trimmedTag, model.fn)) ? model.fn : _Utils_ap(
					model.fn,
					_List_fromArray(
						[trimmedTag]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g3: false, he: '', fn: newTags}),
					$author$project$Ports$Browser$saveTags(newTags));
			case 2:
				var tag = msg.a;
				var newTags = A2(
					$elm$core$List$filter,
					function (t) {
						return !_Utils_eq(t, tag);
					},
					model.fn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fn: newTags}),
					$author$project$Ports$Browser$saveTags(newTags));
			default:
				var tagCandidates = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hd: tagCandidates}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$QuizDB$updateQuestions = _Platform_outgoingPort(
	'updateQuestions',
	$elm$json$Json$Encode$list($elm$core$Basics$identity));
var $author$project$Page$EditQuiz$update = F2(
	function (msg, model) {
		var modalModel = model.eA;
		var env = model.bZ;
		switch (msg.$) {
			case 11:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Task$perform($author$project$Page$EditQuiz$GetQuiz),
									A2($elm$core$Maybe$map, $elm$core$Task$succeed, model.ep)))
							])));
			case 9:
				switch (msg.a.$) {
					case 1:
						var _v1 = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									eA: _Utils_update(
										modalModel,
										{ba: false})
								}),
							$elm$core$Platform$Cmd$none);
					case 0:
						var input_ = msg.a.a;
						var newQuizText = A3(
							$elm$core$Maybe$map2,
							F2(
								function (selected_, record) {
									return A3($author$project$Page$EditQuiz$replaceString, record.d3.de, input_, selected_);
								}),
							model.e7,
							model.eX);
						var newRecord = A3(
							$elm$core$Maybe$map2,
							F2(
								function (quiz, record) {
									var entry = record.d3;
									return _Utils_update(
										record,
										{
											d3: _Utils_update(
												entry,
												{de: quiz})
										});
								}),
							newQuizText,
							model.eX);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									eA: _Utils_update(
										modalModel,
										{aX: _List_Nil, ba: false}),
									eX: newRecord,
									e7: $elm$core$Maybe$Nothing
								}),
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$elm$random$Random$generate($author$project$Page$EditQuiz$Previewed),
									A2($elm$core$Maybe$map, $author$project$Page$EditQuiz$previewQuiz, newQuizText))));
					default:
						var input_ = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									eA: _Utils_update(
										modalModel,
										{
											aX: $elm$core$String$lines(input_)
										})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 14:
				var prev = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{de: prev}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var quizText = msg.a;
				var newRecord = A2(
					$elm$core$Maybe$map,
					function (record) {
						var entry = record.d3;
						return _Utils_update(
							record,
							{
								d3: _Utils_update(
									entry,
									{de: quizText})
							});
					},
					model.eX);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eX: newRecord}),
					A2(
						$elm$random$Random$generate,
						$author$project$Page$EditQuiz$Previewed,
						$author$project$Page$EditQuiz$previewQuiz(quizText)));
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					model,
					function () {
						var _v2 = model.de;
						if (_v2.$ === 1) {
							return $elm$core$Platform$Cmd$none;
						} else {
							var tags = model.dv.fn;
							var schedule = $elm$time$Time$millisToPosix(0);
							var result = A2($author$project$Data$Quizes$QuizResult, 0, 0);
							var mimeType = A2($elm$core$Maybe$andThen, $author$project$Page$EditQuiz$pickMimeType, model.eg);
							var data = A2($elm$core$Maybe$andThen, $author$project$Page$EditQuiz$pickBase64, model.eg);
							var recordWithImage = function () {
								var _v3 = model.eg;
								if (_v3.$ === 1) {
									return model.eX;
								} else {
									return A4(
										$elm$core$Maybe$map3,
										F3(
											function (record, mimeType_, data_) {
												var entry_ = record.d3;
												return _Utils_update(
													record,
													{
														d3: _Utils_update(
															entry_,
															{de: entry_.de + ('<[' + (mimeType_ + ('|' + (data_ + ']>'))))})
													});
											}),
										model.eX,
										mimeType,
										data);
								}
							}();
							var entry = A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.d3;
								},
								recordWithImage);
							var key = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.de;
										},
										$billstclair$elm_sha256$Sha256$sha256),
									entry));
							var keyChanged = A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function (k) {
										return !_Utils_eq(k, key);
									},
									model.ep));
							var boost = false;
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$QuizDB$updateQuestions(
										_List_fromArray(
											[
												$author$project$Data$Quizes$quizRecordEncoder(
												A6(
													$author$project$Data$Quizes$QuizRecord,
													key,
													A2(
														$elm$core$Maybe$withDefault,
														$author$project$Data$Quizes$QuizEntry(''),
														entry),
													result,
													schedule,
													boost,
													tags))
											])),
										keyChanged ? A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2($elm$core$Maybe$map, $author$project$QuizDB$deleteQuiz, model.ep)) : $elm$core$Platform$Cmd$none,
										A2(
										$elm$browser$Browser$Navigation$replaceUrl,
										$author$project$Env$key(env),
										$author$project$Route$routeToString($author$project$Route$Quizes))
									]));
						}
					}());
			case 3:
				var key = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Env$confirm(
						{
							gx: 'この問題を削除しますか?',
							dh: $elm$json$Json$Encode$string(key)
						}));
			case 4:
				var answer = msg.a.fI;
				var result = msg.a.dh;
				var key = answer ? $elm$core$Result$toMaybe(
					A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, result)) : $elm$core$Maybe$Nothing;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$QuizDB$deleteQuiz, key)));
			case 5:
				var key = msg.a.ep;
				var deleted = msg.a.f1;
				var newCmd = deleted ? A2(
					$elm$browser$Browser$Navigation$replaceUrl,
					$author$project$Env$key(env),
					$author$project$Route$routeToString($author$project$Route$Quizes)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(model, newCmd);
			case 6:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 7:
				var start = msg.a;
				var end = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							e7: $elm$core$Maybe$Just(
								_Utils_Tuple2(start, end))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var quizText = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.d3;
							},
							function ($) {
								return $.de;
							}),
						model.eX));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eA: _Utils_update(
								modalModel,
								{
									fI: A2(
										$elm$core$Maybe$withDefault,
										quizText,
										A2(
											$elm$core$Maybe$map,
											$author$project$Page$EditQuiz$subString(quizText),
											model.e7)),
									aX: _List_Nil,
									ba: true
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				if (msg.a.$ === 13) {
					var imageDataUrl = msg.a.a;
					var _v4 = A2(
						$author$project$ImageSelector$update,
						$author$project$ImageSelector$GotImage(imageDataUrl),
						model.eh);
					var subModel = _v4.a;
					var subCmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eg: $elm$core$Maybe$Just(imageDataUrl),
								eh: subModel
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Page$EditQuiz$ImageSelectorMsg, subCmd)
								])));
				} else {
					var imageSelectorMsg = msg.a;
					var _v5 = A2($author$project$ImageSelector$update, imageSelectorMsg, model.eh);
					var newModel = _v5.a;
					var cmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eh: newModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Page$EditQuiz$ImageSelectorMsg, cmd));
				}
			case 12:
				var key = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$QuizDB$getQuiz(key));
			case 13:
				var value = msg.a;
				var quizRecord = $elm$core$Result$toMaybe(
					A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Quizes$quizRecordDecoder, value));
				var _v6 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.dv, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						$author$project$Page$TagChooser$init,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fn;
							},
							quizRecord)));
				var tagChooserModel = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eX: quizRecord, dv: tagChooserModel}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$elm$random$Random$generate($author$project$Page$EditQuiz$Previewed),
									A2(
										$elm$core$Maybe$map,
										$author$project$Page$EditQuiz$previewQuiz,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.d3;
												},
												function ($) {
													return $.de;
												}),
											quizRecord)))),
								cmd
							])));
			default:
				var tagChooserMsg = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (m) {
						return _Utils_update(
							model,
							{dv: m});
					},
					$elm$core$Platform$Cmd$map($author$project$Page$EditQuiz$TagChooserMsg),
					A2($author$project$Page$TagChooser$update, tagChooserMsg, model.dv));
		}
	});
var $author$project$Page$ImportQuizes$NavigationBack = {$: 3};
var $author$project$Ports$FileSaver$loadRqz = _Platform_outgoingPort('loadRqz', $elm$core$Basics$identity);
var $author$project$Page$ImportQuizes$update = F2(
	function (msg, model) {
		var _v0 = function () {
			switch (msg.$) {
				case 0:
					var input = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gU: A2($elm$core$String$split, '\n\n', input)
							}),
						$elm$core$Platform$Cmd$none);
				case 2:
					var quizes = msg.a;
					var tags = msg.b;
					var _v2 = A2(
						$author$project$Page$ImportQuizes$update,
						A2($author$project$Page$ImportQuizes$ImportQuizes, quizes, tags),
						model);
					var m1 = _v2.a;
					var cmd1 = _v2.b;
					var _v3 = A2($author$project$Page$ImportQuizes$update, $author$project$Page$ImportQuizes$NavigationBack, m1);
					var m2 = _v3.a;
					var cmd2 = _v3.b;
					return _Utils_Tuple2(
						m2,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd1, cmd2])));
				case 1:
					var quizes = msg.a;
					var tags = msg.b;
					var questions = A2(
						$elm$core$List$map,
						$author$project$Data$Quizes$makeRecord(tags),
						quizes);
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$QuizDB$updateQuestions(
									A2($elm$core$List$map, $author$project$Data$Quizes$quizRecordEncoder, questions))
								])));
				case 3:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$replaceUrl,
							$author$project$Env$key(model.bZ),
							$author$project$Route$routeToString($author$project$Route$Index)));
				case 4:
					if (!msg.a.$) {
						var f = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									e8: $elm$core$Maybe$Just(f)
								}),
							$author$project$Ports$FileSaver$loadRqz(f));
					} else {
						var _v4 = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{gU: _List_Nil, e8: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					}
				case 5:
					var quizes = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gU: quizes}),
						$elm$core$Platform$Cmd$none);
				default:
					var tagChooserMsg = msg.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (m) {
							return _Utils_update(
								model,
								{dv: m});
						},
						$elm$core$Platform$Cmd$map($author$project$Page$ImportQuizes$TagChooserMsg),
						A2($author$project$Page$TagChooser$update, tagChooserMsg, model.dv));
			}
		}();
		var newModel = _v0.a;
		var newCmd = _v0.b;
		return _Utils_Tuple2(newModel, newCmd);
	});
var $author$project$Page$Index$ConfigMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Index$GotTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Index$PieChartModel = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$QuizDB$getStatistics = _Platform_outgoingPort(
	'getStatistics',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Analytics$logEvent = _Platform_outgoingPort(
	'logEvent',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$core$Basics$identity(b)
				]));
	});
var $author$project$PieChart$SetData = function (a) {
	return {$: 2, a: a};
};
var $author$project$PieChart$Datum = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$PieChart$animationSpeedRate = 0.08;
var $author$project$PieChart$update = F2(
	function (msg, model) {
		var history = model.az;
		var newModel = function () {
			switch (msg.$) {
				case 0:
					var delta = msg.a;
					return _Utils_update(
						model,
						{av: model.av + ((360 - model.av) * $author$project$PieChart$animationSpeedRate), aV: model.aV + delta});
				case 1:
					var _v1 = msg.a;
					var label = _v1.a;
					var value = _v1.b;
					return _Utils_update(
						model,
						{
							av: 0,
							aV: 0,
							az: _Utils_ap(
								history,
								_List_fromArray(
									[
										A2($author$project$PieChart$Datum, label, value)
									]))
						});
				default:
					var newDatum = msg.a;
					return _Utils_update(
						model,
						{av: 0, aV: 0, az: newDatum});
			}
		}();
		return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$PieChart$setData = F2(
	function (data, model) {
		return A2(
			$author$project$PieChart$update,
			$author$project$PieChart$SetData(data),
			model);
	});
var $author$project$Env$setToday = F2(
	function (today_, _v0) {
		var env = _v0;
		return _Utils_update(
			env,
			{bi: today_});
	});
var $elm$core$List$sortWith = _List_sortWith;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Page$Index$statisticsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$map(
		function (_v0) {
			var label = _v0.a;
			var value = _v0.b;
			return A2($author$project$PieChart$Datum, label, value);
		}),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$toList,
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$float)));
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Page$Index$toDisplayLabel = function (_v0) {
	var label = _v0.a;
	var value = _v0.b;
	var labelTable = $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2('learning', '学習中'),
				_Utils_Tuple2('notyet', '未学習'),
				_Utils_Tuple2('weak', '弱点'),
				_Utils_Tuple2('mastering', '得意'),
				_Utils_Tuple2('mastered', 'かんぺき!')
			]));
	var labelPrefix = A2(
		$elm$core$Maybe$withDefault,
		label,
		A2($elm$core$Dict$get, label, labelTable));
	var displayLabel = labelPrefix + (' (' + ($elm$core$String$fromFloat(value) + ')'));
	return A2($author$project$PieChart$Datum, displayLabel, value);
};
var $author$project$BarChart$update = F2(
	function (msg, model) {
		var delta = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aV: model.aV + delta}),
			$elm$core$Platform$Cmd$none);
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Ports$Browser$saveConfig = _Platform_outgoingPort(
	'saveConfig',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'countDownOnSelectBlank',
					$elm$json$Json$Encode$bool($.dU)),
					_Utils_Tuple2(
					'cps',
					$elm$json$Json$Encode$int($.dV)),
					_Utils_Tuple2(
					'initialTimeout',
					$elm$json$Json$Encode$int($.ei)),
					_Utils_Tuple2(
					'inputEachChar',
					$elm$json$Json$Encode$bool($.el)),
					_Utils_Tuple2(
					'speakEnglish',
					$elm$json$Json$Encode$bool($.fg)),
					_Utils_Tuple2(
					'timeBonus',
					$elm$json$Json$Encode$bool($.fq))
				]));
	});
var $author$project$Env$setConfig = F2(
	function (config_, _v0) {
		var env = _v0;
		return _Utils_update(
			env,
			{bU: config_});
	});
var $author$project$Page$Config$update = F2(
	function (msg, model) {
		var newEnv = A2(
			$elm$core$Maybe$withDefault,
			model.bZ,
			A2(
				$elm$core$Maybe$map,
				function (conf) {
					return A2($author$project$Env$setConfig, conf, model.bZ);
				},
				model.dR));
		switch (msg.$) {
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: $elm$core$Maybe$Nothing, bZ: newEnv}),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$Ports$Browser$saveConfig, model.dR)));
			case 0:
				var timeout = msg.a;
				var newConf = A2(
					$elm$core$Maybe$map,
					function (conf) {
						return _Utils_update(
							conf,
							{ei: timeout * 1000});
					},
					model.dR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: newConf}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var cps = msg.a;
				var newConf = A2(
					$elm$core$Maybe$map,
					function (conf) {
						return _Utils_update(
							conf,
							{dV: cps});
					},
					model.dR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: newConf}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var timeBonus = msg.a;
				var newConf = A2(
					$elm$core$Maybe$map,
					function (conf) {
						return _Utils_update(
							conf,
							{fq: timeBonus});
					},
					model.dR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: newConf}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var inputEachChar = msg.a;
				var newConf = A2(
					$elm$core$Maybe$map,
					function (conf) {
						return _Utils_update(
							conf,
							{el: inputEachChar});
					},
					model.dR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: newConf}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var p = msg.a;
				var newConf = A2(
					$elm$core$Maybe$map,
					function (conf) {
						return _Utils_update(
							conf,
							{dU: p});
					},
					model.dR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: newConf}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var spoken = msg.a;
				var newConf = A2(
					$elm$core$Maybe$map,
					function (conf) {
						return _Utils_update(
							conf,
							{fg: spoken});
					},
					model.dR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: newConf}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dR: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Index$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 6:
				var newShowMenu = !model.fc;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fc: newShowMenu}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$QuizDB$getStatistics(0),
								A2($elm$core$Task$perform, $author$project$Page$Index$GotTime, $elm$time$Time$now)
							])));
			case 4:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bZ: A2($author$project$Env$setToday, time, model.bZ)
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var pieChartMsg = msg.a;
				var _v1 = model.dO;
				if (!_v1.$) {
					var pieChartModel = _v1.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (m) {
							return _Utils_update(
								model,
								{
									dO: $author$project$Page$Index$PieChartModel(m)
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Page$Index$PieChartMsg),
						A2($author$project$PieChart$update, pieChartMsg, pieChartModel));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var value = msg.a;
				var decodedStats = function () {
					var _v6 = A2($elm$json$Json$Decode$decodeValue, $author$project$Page$Index$statisticsDecoder, value);
					if (!_v6.$) {
						var stats = _v6.a;
						return stats;
					} else {
						var e = _v6.a;
						return _List_Nil;
					}
				}();
				var compareByTable = F2(
					function (_v4, _v5) {
						var label1 = _v4.a;
						var label2 = _v5.a;
						var order = $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2('mastered', 5),
									_Utils_Tuple2('mastering', 4),
									_Utils_Tuple2('learning', 3),
									_Utils_Tuple2('weak', 2),
									_Utils_Tuple2('notyet', 1)
								]));
						var v1 = A2(
							$elm$core$Maybe$withDefault,
							100,
							A2($elm$core$Dict$get, label1, order));
						var v2 = A2(
							$elm$core$Maybe$withDefault,
							100,
							A2($elm$core$Dict$get, label2, order));
						return (_Utils_cmp(v1, v2) < 0) ? 0 : (_Utils_eq(v1, v2) ? 1 : 2);
					});
				var sortedStats = A2(
					$elm$core$List$map,
					$author$project$Page$Index$toDisplayLabel,
					A2(
						$elm$core$List$sortWith,
						compareByTable,
						A2(
							$elm$core$List$filter,
							function (_v3) {
								var v = _v3.b;
								return v > 0;
							},
							decodedStats)));
				var _v2 = model.dO;
				if (!_v2.$) {
					var pieChartModel = _v2.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (m) {
							return _Utils_update(
								model,
								{
									dO: $author$project$Page$Index$PieChartModel(m)
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Page$Index$PieChartMsg),
						A2($author$project$PieChart$setData, sortedStats, pieChartModel));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var barChartMsg = msg.a;
				var _v7 = model.dO;
				if (_v7.$ === 1) {
					var barChartModel = _v7.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (m) {
							return _Utils_update(
								model,
								{
									dO: $author$project$Page$Index$BarChartModel(m)
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Page$Index$BarChartMsg),
						A2($author$project$BarChart$update, barChartMsg, barChartModel));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var chart = msg.a;
				switch (chart) {
					case 'History':
						var _v9 = $author$project$BarChart$init(
							_Utils_Tuple2(300, 300));
						var m = _v9.a;
						var c = _v9.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									dO: $author$project$Page$Index$BarChartModel(m)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Page$Index$BarChartMsg, c),
										$author$project$Analytics$logEvent(
										_Utils_Tuple2('show_history', $elm$json$Json$Encode$null))
									])));
					case 'Achievement':
						var _v10 = $author$project$PieChart$init(
							_Utils_Tuple2(300, 300));
						var m = _v10.a;
						var c = _v10.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									dO: $author$project$Page$Index$PieChartModel(m)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Page$Index$PieChartMsg, c),
										$author$project$Analytics$logEvent(
										_Utils_Tuple2('show_achievement', $elm$json$Json$Encode$null))
									])));
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dR: $elm$core$Maybe$Just(
								$author$project$Env$config(model.bZ)),
							fc: false
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var configMsg = msg.a;
				var _v11 = A2($author$project$Page$Config$update, configMsg, model);
				var configModel = _v11.a;
				var cmd = _v11.b;
				return _Utils_Tuple2(
					configModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Page$Index$ConfigMsg, cmd));
			default:
				var tagChooserMsg = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (tm) {
						return _Utils_update(
							model,
							{dv: tm});
					},
					$elm$core$Platform$Cmd$map($author$project$Page$Index$TagChooserMsg),
					A2($author$project$Page$TagChooser$update, tagChooserMsg, model.dv));
		}
	});
var $author$project$SelectKeyboard$Dismiss = {$: 2};
var $author$project$Page$Learn$KeyboardMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$Learn$NextQuiz = {$: 6};
var $author$project$Page$Learn$RecordResult = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$Learn$RescheduleQuiz = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Page$Learn$ResultPage = F2(
	function (score, quizes) {
		return {gU: quizes, cg: score};
	});
var $author$project$Page$Learn$SessionFinished = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Learn$SessionRandomized = function (a) {
	return {$: 5, a: a};
};
var $author$project$SelectKeyboard$Submit = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Learn$abstractEnglishPart = F2(
	function (minimumLength, page) {
		var whitespaces = _List_fromArray(
			[' ', ':', '-', ',', ';', '.']);
		var charRange = F2(
			function (b, e) {
				return A2(
					$elm$core$List$map,
					$elm$core$Char$fromCode,
					A2(
						$elm$core$List$range,
						$elm$core$Char$toCode(b),
						$elm$core$Char$toCode(e)));
			});
		var englishChars = _Utils_ap(
			A2(charRange, 'A', 'Z'),
			_Utils_ap(
				A2(charRange, 'a', 'z'),
				whitespaces));
		var sentence = $elm$core$String$trim(
			$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					function (c) {
						return A2($elm$core$List$member, c, whitespaces) ? ' ' : c;
					},
					A2(
						$elm$core$List$filter,
						function (c) {
							return A2($elm$core$List$member, c, englishChars);
						},
						$elm$core$String$toList(page.eX.d3.de)))));
		var words = A2($elm$core$String$split, ' ', sentence);
		var maxLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(
				A2($elm$core$List$map, $elm$core$String$length, words)));
		return (_Utils_cmp(maxLength, minimumLength) > -1) ? sentence : '';
	});
var $author$project$Page$Learn$addMinutes = F2(
	function (now, minutes) {
		var nowInMillis = $elm$time$Time$posixToMillis(now);
		var minutesInMillis = (minutes * 60) * 1000;
		return $elm$time$Time$millisToPosix(nowInMillis + minutesInMillis);
	});
var $author$project$Page$Learn$calcDisplayTime = F2(
	function (conf, page) {
		var sentenceLength = function (body) {
			if (!body.$) {
				var s = body.a;
				return $elm$core$String$length(s);
			} else {
				return 1;
			}
		};
		var secPerChar = 1000.0 / conf.dV;
		return secPerChar * A3(
			$elm$core$List$foldr,
			F2(
				function (s, l) {
					return l + sentenceLength(s);
				}),
			0,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.de;
						},
						function ($) {
							return $.g1;
						}),
					page)));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Page$Learn$isCorrect = function (quiz) {
	var isCorrect_ = F2(
		function (ans, userInput) {
			return _Utils_eq(
				ans,
				$elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						$elm$core$Maybe$withDefault(''),
						A2(
							$elm$core$List$map,
							$elm$core$Maybe$map($elm$core$String$trim),
							userInput))));
		});
	var correct_ = function (body) {
		switch (body.$) {
			case 0:
				return true;
			case 2:
				var answers = body.a;
				var options = body.b.gM;
				var userInput = body.b.hr;
				return A2(isCorrect_, answers, userInput);
			case 1:
				var answers = body.a;
				var options = body.b.gM;
				var userInput = body.b.hr;
				return A2(isCorrect_, answers, userInput);
			default:
				var answers = body.a;
				var userInput = body.b;
				return A2(isCorrect_, answers, userInput);
		}
	};
	return A2($elm$core$List$all, correct_, quiz.g1);
};
var $author$project$Page$Learn$countCorrect_ = function (sess) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (page) {
				return $author$project$Page$Learn$isCorrect(page.de);
			},
			sess.am));
};
var $author$project$Page$Learn$countCorrect = function (sess) {
	return A2($elm$core$Maybe$map, $author$project$Page$Learn$countCorrect_, sess);
};
var $author$project$Page$Learn$encodeQuizRecord = function (record) {
	var master_rate = (!record.dh.fs) ? 0 : (record.dh.ey / record.dh.fs);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'master',
				$elm$json$Json$Encode$float(master_rate)),
				_Utils_Tuple2(
				'boost',
				$elm$json$Json$Encode$bool(record.dL)),
				_Utils_Tuple2(
				'schedule',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(record.eF)))
			]));
};
var $author$project$Page$Learn$encodeSessionQuizes = function (session) {
	return A2(
		$elm$json$Json$Encode$list,
		$author$project$Page$Learn$encodeQuizRecord,
		A2(
			$elm$core$List$map,
			function (page) {
				return page.eX;
			},
			session.S));
};
var $author$project$Page$Learn$encodeSessionResult = function (_v0) {
	var score = _v0.cg;
	var duration = _v0.bX;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'score',
				$elm$json$Json$Encode$int(score)),
				_Utils_Tuple2(
				'duration',
				$elm$json$Json$Encode$int(duration))
			]));
};
var $author$project$Env$history = function (_v0) {
	var env = _v0;
	return $elm$core$List$reverse(
		A2($elm$core$List$take, 7, env.az));
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.dt, posixMinutes) < 0) {
					return posixMinutes + era.b;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		dY: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		eB: month,
		fD: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).dY;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).eB;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $author$project$Env$dateString = F2(
	function (zone, time) {
		var month = function () {
			var _v0 = A2($elm$time$Time$toMonth, zone, time);
			switch (_v0) {
				case 0:
					return '1';
				case 1:
					return '2';
				case 2:
					return '3';
				case 3:
					return '4';
				case 4:
					return '5';
				case 5:
					return '6';
				case 6:
					return '7';
				case 7:
					return '8';
				case 8:
					return '9';
				case 9:
					return '10';
				case 10:
					return '11';
				default:
					return '12';
			}
		}();
		var day = $elm$core$String$fromInt(
			A2($elm$time$Time$toDay, zone, time));
		return A2(
			$elm$core$String$join,
			'/',
			_List_fromArray(
				[month, day]));
	});
var $author$project$Env$todaysLearnedCount = function (_v0) {
	var env = _v0;
	var today_ = A2($author$project$Env$dateString, env.bQ, env.bi);
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Dict$get,
			today_,
			$elm$core$Dict$fromList(env.az)));
};
var $author$project$Env$incrementTodaysLearnedCount = function (e) {
	var env = e;
	var today_ = A2($author$project$Env$dateString, env.bQ, env.bi);
	var history_ = A2(
		$elm$core$List$filter,
		function (_v0) {
			var day = _v0.a;
			var count = _v0.b;
			return !_Utils_eq(day, today_);
		},
		env.az);
	var current = $author$project$Env$todaysLearnedCount(e);
	return _Utils_update(
		env,
		{
			az: A2(
				$elm$core$List$cons,
				_Utils_Tuple2(today_, current + 1),
				history_)
		});
};
var $author$project$SelectKeyboard$Randomized = function (a) {
	return {$: 1, a: a};
};
var $elm$core$String$any = _String_any;
var $author$project$SelectKeyboard$listAt = F2(
	function (index, list) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, index, list));
	});
var $elm$random$Random$map2 = F3(
	function (func, _v0, _v1) {
		var genA = _v0;
		var genB = _v1;
		return function (seed0) {
			var _v2 = genA(seed0);
			var a = _v2.a;
			var seed1 = _v2.b;
			var _v3 = genB(seed1);
			var b = _v3.a;
			var seed2 = _v3.b;
			return _Utils_Tuple2(
				A2(func, a, b),
				seed2);
		};
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$SelectKeyboard$initAllCharKeyboard = F4(
	function (elemIndex, blankIndex, answers, dummies) {
		var correctAnswer = A2($author$project$SelectKeyboard$listAt, blankIndex, answers);
		var genAnswer = $elm$random$Random$constant(
			A2(
				$elm$core$List$map,
				$elm$core$String$fromChar,
				$elm_community$list_extra$List$Extra$unique(
					$elm$core$String$toList(
						A2($elm$core$Maybe$withDefault, '', correctAnswer)))));
		var containsChar = F2(
			function (c, s) {
				return A2(
					$elm$core$String$any,
					function (sc) {
						return _Utils_eq(sc, c);
					},
					s);
			});
		var dummieCharacters = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				$elm$core$String$fromChar,
				A2(
					$elm$core$List$filter,
					function (c) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Basics$not,
									containsChar(c)),
								correctAnswer));
					},
					$elm$core$List$concat(
						A2(
							$elm$core$List$map,
							$elm$core$String$toList,
							_Utils_ap(answers, dummies))))));
		var answerLength = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2($elm$core$Maybe$map, $elm$core$String$length, correctAnswer));
		var maxNumDummies = (answerLength < 7) ? (10 - answerLength) : 3;
		var genShuffledDummies = A2(
			$elm$random$Random$map,
			$elm$core$List$take(maxNumDummies),
			$elm_community$random_extra$Random$List$shuffle(dummieCharacters));
		var randomGen = A2(
			$elm$random$Random$map,
			$elm$core$List$singleton,
			A2(
				$elm$random$Random$map,
				$elm$core$List$sort,
				A3($elm$random$Random$map2, $elm$core$Basics$append, genAnswer, genShuffledDummies)));
		return _Utils_Tuple2(
			{
				ah: _List_Nil,
				ek: '',
				aL: false,
				bF: _Utils_Tuple2(elemIndex, blankIndex)
			},
			A2($elm$random$Random$generate, $author$project$SelectKeyboard$Randomized, randomGen));
	});
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $author$project$SelectKeyboard$complementOption = F2(
	function (len, opt) {
		var repeatCount = (($elm$core$String$length(opt) % len) > 0) ? (((len / $elm$core$String$length(opt)) | 0) + 1) : ((len / $elm$core$String$length(opt)) | 0);
		return A3(
			$elm$core$String$slice,
			0,
			len,
			A2($elm$core$String$repeat, repeatCount, opt));
	});
var $author$project$SelectKeyboard$foldRandomGeneratorList = function (generators) {
	var folder = F2(
		function (genA, gens) {
			return A2(
				$elm$random$Random$andThen,
				function (res) {
					return A2(
						$elm$random$Random$map,
						function (v) {
							return A2($elm$core$List$cons, v, res);
						},
						genA);
				},
				gens);
		});
	return A3(
		$elm$core$List$foldr,
		folder,
		$elm$random$Random$constant(_List_Nil),
		generators);
};
var $author$project$SelectKeyboard$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$author$project$SelectKeyboard$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $author$project$SelectKeyboard$initCharKeyboard = F4(
	function (elemIndex, blankIndex, answers, dummies) {
		var allOptions = $elm_community$list_extra$List$Extra$unique(
			_Utils_ap(answers, dummies));
		var longestOptionsLength = A2(
			$elm$core$Maybe$withDefault,
			1,
			$elm$core$List$maximum(
				A2($elm$core$List$map, $elm$core$String$length, allOptions)));
		var complementedOptions = A2(
			$elm$core$List$map,
			$author$project$SelectKeyboard$complementOption(longestOptionsLength),
			allOptions);
		var randomGen = $author$project$SelectKeyboard$foldRandomGeneratorList(
			A2(
				$elm$core$List$map,
				$elm$random$Random$constant,
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $elm_community$list_extra$List$Extra$unique, $elm$core$List$sort),
					$author$project$SelectKeyboard$transpose(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$toList,
								$elm$core$List$map($elm$core$String$fromChar)),
							complementedOptions)))));
		return _Utils_Tuple2(
			{
				ah: _List_Nil,
				ek: '',
				aL: false,
				bF: _Utils_Tuple2(elemIndex, blankIndex)
			},
			A2($elm$random$Random$generate, $author$project$SelectKeyboard$Randomized, randomGen));
	});
var $author$project$SelectKeyboard$initStringKeyboard = F4(
	function (elemIndex, blankIndex, answers, dummies) {
		var allOptions = $elm_community$list_extra$List$Extra$unique(
			_Utils_ap(answers, dummies));
		var randomGen = A2(
			$elm$random$Random$map,
			function (opt) {
				return _List_fromArray(
					[opt]);
			},
			$elm$random$Random$constant(allOptions));
		return _Utils_Tuple2(
			{
				ah: _List_Nil,
				ek: '',
				aL: false,
				bF: _Utils_Tuple2(elemIndex, blankIndex)
			},
			A2($elm$random$Random$generate, $author$project$SelectKeyboard$Randomized, randomGen));
	});
var $author$project$Page$Learn$Session = F3(
	function (upcomingPages, passedPages, questions) {
		return {am: passedPages, ce: questions, S: upcomingPages};
	});
var $author$project$Page$Learn$nextQuiz = function (session) {
	var _v0 = session.S;
	if (_v0.b) {
		var curr = _v0.a;
		var rest = _v0.b;
		return A3(
			$author$project$Page$Learn$Session,
			rest,
			A2($elm$core$List$cons, curr, session.am),
			session.ce);
	} else {
		return A3($author$project$Page$Learn$Session, _List_Nil, _List_Nil, _List_Nil);
	}
};
var $author$project$QuizDB$nextScheduledReview = _Platform_outgoingPort(
	'nextScheduledReview',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'count',
					$elm$json$Json$Encode$int($.fZ)),
					_Utils_Tuple2(
					'tags',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.fn))
				]));
	});
var $author$project$Page$Learn$Page = F2(
	function (quiz, record) {
		return {de: quiz, eX: record};
	});
var $author$project$Page$Learn$parseQuizSession = function (records) {
	var entries = A2(
		$elm$core$List$map,
		function ($) {
			return $.d3;
		},
		records);
	var questions = A2(
		$elm$core$List$filterMap,
		function (s) {
			if (!s.$) {
				var qiz = s.a;
				return $elm$core$Maybe$Just(qiz);
			} else {
				var err = s.a;
				return $elm$core$Maybe$Nothing;
			}
		},
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.de;
				},
				$author$project$WikiParser$parse),
			entries));
	var quizes = $author$project$Page$Learn$foldRandomGeneratorList(
		A2($elm$core$List$map, $author$project$Page$Learn$renderQuiz, questions));
	var pages = A2(
		$elm$random$Random$map,
		function (qs) {
			return A3($elm$core$List$map2, $author$project$Page$Learn$Page, qs, records);
		},
		quizes);
	var all_options = A2(
		$elm$core$List$concatMap,
		function (question) {
			return A2(
				$elm$core$List$concatMap,
				function (body) {
					if (body.$ === 1) {
						var answer = body.a.fI;
						var dummies = body.a.aX;
						return _Utils_ap(answer, dummies);
					} else {
						return _List_Nil;
					}
				},
				question.de);
		},
		questions);
	return A2(
		$elm$random$Random$map,
		function (ps) {
			return A3($author$project$Page$Learn$Session, ps, _List_Nil, entries);
		},
		pages);
};
var $elm$random$Random$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var genA = _v0;
		var genB = _v1;
		var genC = _v2;
		return function (seed0) {
			var _v3 = genA(seed0);
			var a = _v3.a;
			var seed1 = _v3.b;
			var _v4 = genB(seed1);
			var b = _v4.a;
			var seed2 = _v4.b;
			var _v5 = genC(seed2);
			var c = _v5.a;
			var seed3 = _v5.b;
			return _Utils_Tuple2(
				A3(func, a, b, c),
				seed3);
		};
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Page$Learn$randomGeneratorSentenceBody = function (body) {
	switch (body.$) {
		case 1:
			var ans = body.a;
			var opts = body.b;
			var answers = $elm$core$Set$toList(ans);
			return A2(
				$elm$random$Random$map,
				$author$project$Data$Quizes$BlankSelection(ans),
				A2(
					$elm$random$Random$map,
					function (opts_) {
						return A2(
							$author$project$Data$Quizes$Options,
							_Utils_ap(answers, opts_),
							A2(
								$elm$core$List$repeat,
								$elm$core$Set$size(ans),
								$elm$core$Maybe$Nothing));
					},
					A2(
						$elm$random$Random$andThen,
						$elm_community$random_extra$Random$List$shuffle,
						A2(
							$elm$random$Random$map,
							function (dummies) {
								return _Utils_ap(answers, dummies);
							},
							$elm_community$random_extra$Random$List$shuffle(
								$elm_community$list_extra$List$Extra$unique(opts.gM))))));
		case 2:
			var ans = body.a;
			var opts = body.b;
			var numOpts = A2(
				$elm$core$Basics$max,
				$elm$core$Set$size(ans),
				8);
			var answers = $elm$core$Set$toList(ans);
			return A2(
				$elm$random$Random$map,
				$author$project$Data$Quizes$BlankChoice(ans),
				A2(
					$elm$random$Random$map,
					function (opts_) {
						return A2(
							$author$project$Data$Quizes$Options,
							_Utils_ap(answers, opts_),
							A2(
								$elm$core$List$repeat,
								$elm$core$Set$size(ans),
								$elm$core$Maybe$Nothing));
					},
					A2(
						$elm$random$Random$andThen,
						$elm_community$random_extra$Random$List$shuffle,
						A2(
							$elm$random$Random$map,
							$elm$core$List$take(numOpts),
							A2(
								$elm$random$Random$map,
								function (dummies) {
									return _Utils_ap(answers, dummies);
								},
								$elm_community$random_extra$Random$List$shuffle(
									$elm_community$list_extra$List$Extra$unique(opts.gM)))))));
		default:
			return $elm$random$Random$constant(body);
	}
};
var $author$project$Page$Learn$randomGeneratorSentence = function (sentence) {
	var folder = F2(
		function (body, accum) {
			return A2(
				$elm$random$Random$andThen,
				function (res) {
					return A2(
						$elm$random$Random$map,
						function (randomBody) {
							return A2($elm$core$List$cons, randomBody, res);
						},
						body);
				},
				accum);
		});
	return $author$project$Page$Learn$foldRandomGeneratorList(
		A2($elm$core$List$map, $author$project$Page$Learn$randomGeneratorSentenceBody, sentence));
};
var $author$project$Page$Learn$randomGeneratorQuiz = function (_v0) {
	var sentence = _v0.g1;
	var image = _v0.gl;
	var genSentence = $author$project$Page$Learn$randomGeneratorSentence(sentence);
	return A3(
		$elm$random$Random$map2,
		$author$project$Data$Quizes$Quiz,
		genSentence,
		$elm$random$Random$constant(image));
};
var $author$project$Page$Learn$randomGeneratorSession = function (session) {
	var questions = $elm$random$Random$constant(session.ce);
	var genUpcomingPages = $author$project$Page$Learn$foldRandomGeneratorList(
		A2(
			$elm$core$List$map,
			function (page) {
				return A2(
					$elm$random$Random$map,
					function (quiz) {
						return _Utils_update(
							page,
							{de: quiz});
					},
					$author$project$Page$Learn$randomGeneratorQuiz(page.de));
			},
			session.S));
	var genPassedPages = $author$project$Page$Learn$foldRandomGeneratorList(
		A2(
			$elm$core$List$map,
			function (page) {
				return A2(
					$elm$random$Random$map,
					function (quiz) {
						return _Utils_update(
							page,
							{de: quiz});
					},
					$author$project$Page$Learn$randomGeneratorQuiz(page.de));
			},
			session.am));
	return A4($elm$random$Random$map3, $author$project$Page$Learn$Session, genUpcomingPages, genPassedPages, questions);
};
var $author$project$Page$Learn$recordResult = function (updatedRecord) {
	return $author$project$QuizDB$updateQuestions(
		_List_fromArray(
			[
				$author$project$Data$Quizes$quizRecordEncoder(updatedRecord)
			]));
};
var $author$project$Page$Learn$resetTimer = F2(
	function (time, model) {
		var now = $elm$time$Time$posixToMillis(time);
		return _Utils_update(
			model,
			{
				dW: $elm$core$Maybe$Just(now),
				bZ: A2($author$project$Env$setToday, time, model.bZ),
				fj: $elm$core$Maybe$Just(now)
			});
	});
var $author$project$Page$Learn$ResetTimer = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Learn$resetTimerCommand = function (t) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Page$Learn$ResetTimer,
		A2(
			$elm$core$Task$andThen,
			function (_v0) {
				return $elm$time$Time$now;
			},
			$elm$core$Process$sleep(t)));
};
var $author$project$Env$tuple2Encoder = F3(
	function (enc1, enc2, _v0) {
		var value1 = _v0.a;
		var value2 = _v0.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					enc1(value1),
					enc2(value2)
				]));
	});
var $author$project$Env$historyEncoder = function (history_) {
	return A2(
		$elm$json$Json$Encode$list,
		A2($author$project$Env$tuple2Encoder, $elm$json$Json$Encode$string, $elm$json$Json$Encode$int),
		history_);
};
var $author$project$Env$saveLocalStorage = _Platform_outgoingPort(
	'saveLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'key',
					$elm$json$Json$Encode$string($.ep)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string($.fw))
				]));
	});
var $author$project$Env$saveHistory = function (_v0) {
	var env = _v0;
	return $author$project$Env$saveLocalStorage(
		{
			ep: 'history',
			fw: A2(
				$elm$json$Json$Encode$encode,
				0,
				$author$project$Env$historyEncoder(
					A2($elm$core$List$take, 7, env.az)))
		});
};
var $author$project$Env$setLastQuiz = F2(
	function (quiz, _v0) {
		var env = _v0;
		return _Utils_update(
			env,
			{b$: quiz});
	});
var $author$project$Page$Learn$ShowQuiz = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Learn$showQuizCommand = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$identity,
	A2(
		$elm$core$Task$map,
		function (_v0) {
			return $author$project$Page$Learn$ShowQuiz(true);
		},
		$elm$core$Process$sleep(100)));
var $author$project$Ports$Browser$speak = _Platform_outgoingPort('speak', $elm$json$Json$Encode$string);
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$SelectKeyboard$update = F2(
	function (msg, model) {
		var currentCandidate = $elm$core$List$head(model.ah);
		var nextCandidates = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (current, rest) {
						return _Utils_ap(
							rest,
							_List_fromArray(
								[current]));
					}),
				currentCandidate,
				$elm$core$List$tail(model.ah)));
		switch (msg.$) {
			case 0:
				var input = msg.a;
				var newInput = _Utils_ap(model.ek, input);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: nextCandidates, ek: newInput}),
					A2(
						$elm$core$Task$perform,
						$author$project$SelectKeyboard$Submit(model.bF),
						$elm$core$Task$succeed(newInput)));
			case 1:
				var candidates = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: candidates, aL: true}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aL: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Quizes$BlankInput = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Learn$updateInput = F4(
	function (session, blankIndex, inputIndex, userInput) {
		var updateUserAnswer = function (opt) {
			switch (opt.$) {
				case 2:
					var answer = opt.a;
					var opts = opt.b;
					return A2(
						$author$project$Data$Quizes$BlankChoice,
						answer,
						A2(
							$author$project$Data$Quizes$Options,
							opts.gM,
							_Utils_ap(
								A2($elm$core$List$take, inputIndex, opts.hr),
								A2(
									$elm$core$List$cons,
									userInput,
									A2($elm$core$List$drop, inputIndex + 1, opts.hr)))));
				case 1:
					var answer = opt.a;
					var opts = opt.b;
					return A2(
						$author$project$Data$Quizes$BlankSelection,
						answer,
						A2(
							$author$project$Data$Quizes$Options,
							opts.gM,
							_Utils_ap(
								A2($elm$core$List$take, inputIndex, opts.hr),
								A2(
									$elm$core$List$cons,
									userInput,
									A2($elm$core$List$drop, inputIndex + 1, opts.hr)))));
				case 3:
					var answer = opt.a;
					var currentInput = opt.b;
					return A2(
						$author$project$Data$Quizes$BlankInput,
						answer,
						_Utils_ap(
							A2($elm$core$List$take, inputIndex, currentInput),
							A2(
								$elm$core$List$cons,
								userInput,
								A2($elm$core$List$drop, inputIndex + 1, currentInput))));
				default:
					var s = opt;
					return s;
			}
		};
		var p = A2(
			$elm$core$Maybe$andThen,
			function (sess) {
				return $elm$core$List$head(sess.S);
			},
			session);
		var q = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.de;
			},
			p);
		var currentPage = function () {
			var sentence = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.g1;
				},
				q);
			var image = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.gl;
				},
				q);
			var currentBlank = A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$drop(blankIndex),
					$elm$core$List$head),
				sentence);
			var updatedSentence = A2(
				$elm$core$Maybe$andThen,
				function (sen) {
					return A2(
						$elm$core$Maybe$map,
						function (blank) {
							return _Utils_ap(
								A2($elm$core$List$take, blankIndex, sen),
								A2(
									$elm$core$List$cons,
									updateUserAnswer(blank),
									A2($elm$core$List$drop, blankIndex + 1, sen)));
						},
						currentBlank);
				},
				sentence);
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (p_, quiz) {
						return _Utils_update(
							p_,
							{de: quiz});
					}),
				p,
				A3($elm$core$Maybe$map2, $author$project$Data$Quizes$Quiz, updatedSentence, image));
		}();
		return A2(
			$elm$core$Maybe$andThen,
			function (pages) {
				return A2(
					$elm$core$Maybe$map,
					function (sess) {
						return _Utils_update(
							sess,
							{S: pages});
					},
					session);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (rest) {
					return A2(
						$elm$core$Maybe$map,
						function (p_) {
							return A2($elm$core$List$cons, p_, rest);
						},
						currentPage);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (sess) {
						return $elm$core$List$tail(sess.S);
					},
					session)));
	});
var $author$project$Page$Learn$updateRecord = F3(
	function (index, records, newRecord) {
		var beforeNewRecord = A2($elm$core$List$take, index, records);
		var afterNewRecord = A2($elm$core$List$drop, index + 1, records);
		return _Utils_ap(
			beforeNewRecord,
			_Utils_ap(
				_List_fromArray(
					[newRecord]),
				afterNewRecord));
	});
var $author$project$Page$Learn$updateResult = F2(
	function (quiz, result) {
		return $author$project$Page$Learn$isCorrect(quiz) ? _Utils_update(
			result,
			{ey: result.ey + 1, fs: result.fs + 1}) : _Utils_update(
			result,
			{ey: result.ey - 1, fs: result.fs + 1});
	});
var $elm$core$Basics$round = _Basics_round;
var $author$project$Page$Learn$updateSchedule = F3(
	function (boost, masteringCount, currentTime) {
		var intervalRate = 3.0;
		var indexNumber = masteringCount - 1;
		var firstInterval = 30.0;
		var boostedIntervalRate = 3.0;
		var boostedFirstInterval = 5.0;
		var reviewInterval = boost ? (boostedFirstInterval * A2($elm$core$Basics$pow, boostedIntervalRate, indexNumber)) : (firstInterval * A2($elm$core$Basics$pow, intervalRate, indexNumber));
		return A2(
			$author$project$Page$Learn$addMinutes,
			currentTime,
			$elm$core$Basics$round(
				A2($elm$core$Basics$max, 10.0, reviewInterval)));
	});
var $author$project$Page$Learn$TemporaryMessage = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Learn$Timeout = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Learn$updateTemporaryMessage = F2(
	function (msg, model) {
		var newModel = function () {
			switch (msg.$) {
				case 1:
					var message_ = msg.a;
					return _Utils_update(
						model,
						{gx: message_, bP: true});
				case 2:
					return _Utils_update(
						model,
						{bP: false});
				default:
					return model;
			}
		}();
		var command = function () {
			switch (msg.$) {
				case 1:
					var message_ = msg.a;
					return A2(
						$elm$core$Task$perform,
						A2($elm$core$Basics$composeR, $author$project$Page$Learn$Timeout, $author$project$Page$Learn$TemporaryMessage),
						$elm$core$Process$sleep(model.dy));
				case 2:
					return $elm$core$Platform$Cmd$none;
				default:
					return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(newModel, command);
	});
var $author$project$Page$Learn$update = F2(
	function (msg, model) {
		var conf = $author$project$Env$config(model.bZ);
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 19:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fc: !model.fc}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var name = msg.a.gC;
				var version = msg.a.hs;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dF: model.dF + 1}),
					A2($elm$core$Task$perform, $author$project$Page$Learn$StartNextSession, $elm$time$Time$now));
			case 3:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dh: $elm$core$Maybe$Nothing,
							fi: $elm$core$Maybe$Just(
								$elm$time$Time$posixToMillis(time))
						}),
					$author$project$QuizDB$nextScheduledReview(
						{fZ: 10, fn: model.dv.fn}));
			case 4:
				var quizes = msg.a;
				var generateSessionCmd = A2(
					$elm$random$Random$generate,
					$author$project$Page$Learn$SessionRandomized,
					A2(
						$elm$random$Random$andThen,
						$author$project$Page$Learn$randomGeneratorSession,
						A2(
							$elm$random$Random$andThen,
							$author$project$Page$Learn$parseQuizSession,
							A2(
								$elm$random$Random$map,
								$elm$core$List$take(10),
								$elm_community$random_extra$Random$List$shuffle(
									A2(
										$elm_community$list_extra$List$Extra$uniqueBy,
										function (q) {
											return q.ep;
										},
										quizes))))));
				return $elm$core$List$isEmpty(quizes) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[generateSessionCmd])));
			case 5:
				var session = msg.a;
				var nextPage = $elm$core$List$head(session.S);
				var isEnglishQuiz = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (page) {
							return A2($elm$core$List$member, '英語', page.eX.fn);
						},
						nextPage));
				var englishPart = A2(
					$elm$core$Maybe$map,
					$author$project$Page$Learn$abstractEnglishPart(1),
					nextPage);
				var speakCommand = (isEnglishQuiz && conf.fg) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2($elm$core$Maybe$map, $author$project$Ports$Browser$speak, englishPart)) : $elm$core$Platform$Cmd$none;
				var displayTime = A2($author$project$Page$Learn$calcDisplayTime, conf, nextPage);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fb: $elm$core$Maybe$Just(session)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Analytics$logEvent(
								_Utils_Tuple2(
									'start_learning',
									$author$project$Page$Learn$encodeSessionQuizes(session))),
								speakCommand,
								$author$project$Page$Learn$showQuizCommand,
								conf.dU ? $elm$core$Platform$Cmd$none : $author$project$Page$Learn$resetTimerCommand(displayTime)
							])));
			case 6:
				var todaysLearnedCount = $author$project$Env$todaysLearnedCount;
				var newSession = A2($elm$core$Maybe$map, $author$project$Page$Learn$nextQuiz, model.fb);
				var nextPage = A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.S;
						},
						$elm$core$List$head),
					newSession);
				var isEnglishQuiz = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (page) {
							return A2($elm$core$List$member, '英語', page.eX.fn);
						},
						nextPage));
				var history = $author$project$Env$history(model.bZ);
				var finished = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var upcomingPages = _v2.S;
							return $elm$core$List$isEmpty(upcomingPages);
						},
						newSession));
				var englishPart = A2(
					$elm$core$Maybe$map,
					$author$project$Page$Learn$abstractEnglishPart(1),
					nextPage);
				var speakCommand = (isEnglishQuiz && conf.fg) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2($elm$core$Maybe$map, $author$project$Ports$Browser$speak, englishPart)) : $elm$core$Platform$Cmd$none;
				var displayTime = A2($author$project$Page$Learn$calcDisplayTime, conf, nextPage);
				var finishCommand = finished ? A2(
					$elm$core$Task$perform,
					$author$project$Page$Learn$SessionFinished,
					$elm$core$Task$succeed(true)) : $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Page$Learn$showQuizCommand,
							conf.dU ? $elm$core$Platform$Cmd$none : $author$project$Page$Learn$resetTimerCommand(displayTime)
						]));
				var currentPage = A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.am;
						},
						$elm$core$List$head),
					newSession);
				var lq = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.eX;
					},
					currentPage);
				var config = $author$project$Env$config(model.bZ);
				var initialTimeout = config.ei;
				var timeBonus = A2(
					$elm$core$Maybe$withDefault,
					0,
					A4(
						$elm$core$Maybe$map3,
						F3(
							function (enableTimeBonus, t, s) {
								return enableTimeBonus ? A2($elm$core$Basics$max, 0, config.ei - (t - s)) : 0;
							}),
						$elm$core$Maybe$Just(config.fq),
						model.dW,
						model.fj));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bZ: A2(
								$author$project$Env$setLastQuiz,
								lq,
								$author$project$Env$incrementTodaysLearnedCount(model.bZ)),
							eq: $elm$core$Maybe$Nothing,
							fb: newSession,
							fd: false,
							fj: $elm$core$Maybe$Nothing,
							fr: initialTimeout + timeBonus
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								finishCommand,
								A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									function (page) {
										return A2(
											$elm$core$Task$perform,
											$author$project$Page$Learn$RecordResult(page),
											$elm$time$Time$now);
									},
									currentPage)),
								A2(
								$elm$core$Task$perform,
								function (_v1) {
									return $author$project$Page$Learn$KeyboardMsg($author$project$SelectKeyboard$Dismiss);
								},
								$elm$core$Task$succeed(0)),
								speakCommand
							])));
			case 10:
				var page = msg.a;
				var answeredTime = msg.b;
				var record = page.eX;
				var updatedResult = A2($author$project$Page$Learn$updateResult, page.de, record.dh);
				var nextScheduledDate = A3($author$project$Page$Learn$updateSchedule, page.eX.dL, updatedResult.ey, answeredTime);
				var newRecord = _Utils_update(
					record,
					{eF: nextScheduledDate, dh: updatedResult});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fb: A2(
								$elm$core$Maybe$andThen,
								function (sess) {
									return A2(
										$elm$core$Maybe$map,
										function (rest) {
											return _Utils_update(
												sess,
												{
													am: A2(
														$elm$core$List$cons,
														_Utils_update(
															page,
															{eX: newRecord}),
														rest)
												});
										},
										$elm$core$List$tail(sess.am));
								},
								model.fb)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Page$Learn$recordResult(newRecord),
								$author$project$Env$saveHistory(model.bZ)
							])));
			case 11:
				var finished = msg.a;
				var score = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Page$Learn$countCorrect(model.fb));
				var makeResult = function (page) {
					return _Utils_Tuple2(page.de, page.eX);
				};
				var resultPage = A2(
					$elm$core$Maybe$map,
					$author$project$Page$Learn$ResultPage(score),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(makeResult),
							$elm$core$List$reverse),
						A2(
							$elm$core$Maybe$map,
							function (sess) {
								return _Utils_ap(sess.am, sess.S);
							},
							model.fb)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dW: $elm$core$Maybe$Nothing, dh: resultPage, fb: $elm$core$Maybe$Nothing, fi: $elm$core$Maybe$Nothing, fj: $elm$core$Maybe$Nothing}),
					$author$project$Analytics$logEvent(
						_Utils_Tuple2(
							'session_finished',
							$author$project$Page$Learn$encodeSessionResult(
								{
									bX: A2(
										$elm$core$Maybe$withDefault,
										0,
										A3(
											$elm$core$Maybe$map2,
											F2(
												function (current, start) {
													return current - start;
												}),
											model.dW,
											model.fi)),
									cg: score
								}))));
			case 13:
				var index = msg.a;
				var record = msg.b;
				var quiz = msg.c;
				var boost = msg.d;
				var newRecord = _Utils_update(
					record,
					{
						dL: boost,
						dh: boost ? record.dh : A2($author$project$Data$Quizes$QuizResult, 0, record.dh.fs)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dh: A2(
								$elm$core$Maybe$map,
								function (page) {
									return _Utils_update(
										page,
										{
											gU: A3(
												$author$project$Page$Learn$updateRecord,
												index,
												page.gU,
												_Utils_Tuple2(quiz, newRecord))
										});
								},
								model.dh)
						}),
					A2(
						$elm$core$Task$perform,
						$author$project$Page$Learn$RescheduleQuiz(newRecord),
						A2(
							$elm$core$Task$map,
							function (now) {
								return A2($author$project$Page$Learn$addMinutes, now, 10);
							},
							$elm$time$Time$now)));
			case 14:
				var record = msg.a;
				var newSchedule = msg.b;
				return _Utils_Tuple2(
					model,
					$author$project$QuizDB$updateQuestions(
						_List_fromArray(
							[
								$author$project$Data$Quizes$quizRecordEncoder(
								_Utils_update(
									record,
									{eF: newSchedule}))
							])));
			case 12:
				var blankIndex = msg.a;
				var inputIndex = msg.b;
				var userAnswer = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fb: A4(
								$author$project$Page$Learn$updateInput,
								model.fb,
								blankIndex,
								inputIndex,
								$elm$core$Maybe$Just(userAnswer))
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var tempMsg = msg.a;
				var _v3 = A2($author$project$Page$Learn$updateTemporaryMessage, tempMsg, model.fo);
				var temporaryMessage = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fo: temporaryMessage}),
					cmd);
			case 7:
				var shown = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fd: shown}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Learn$resetTimer, time, model),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				var timeIsUp = A2(
					$elm$core$Maybe$withDefault,
					false,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (t, s) {
								return _Utils_cmp(t - s, model.fr) > -1;
							}),
						model.dW,
						model.fj));
				var cmd = timeIsUp ? A2(
					$elm$core$Task$perform,
					function (_v4) {
						return $author$project$Page$Learn$NextQuiz;
					},
					$elm$core$Task$succeed(0)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dW: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$time$Time$posixToMillis)(time)
						}),
					cmd);
			case 16:
				var elemIndex = msg.a;
				var blankIndex = msg.b;
				var opts = msg.c;
				var newModel = _Utils_update(
					model,
					{
						fb: A4($author$project$Page$Learn$updateInput, model.fb, elemIndex, blankIndex, $elm$core$Maybe$Nothing)
					});
				var _v5 = model.eq;
				if (!_v5.$) {
					var km = _v5.a;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								eq: $elm$core$Maybe$Just(
									_Utils_update(
										km,
										{ek: ''}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var resetTimerCommand_ = conf.dU ? $author$project$Page$Learn$resetTimerCommand(0) : $elm$core$Platform$Cmd$none;
					var keyboardFunc = conf.el ? $author$project$SelectKeyboard$initCharKeyboard : $author$project$SelectKeyboard$initAllCharKeyboard;
					var _v6 = A4(keyboardFunc, elemIndex, blankIndex, opts.gM, _List_Nil);
					var keyboardModel = _v6.a;
					var keyboardCmd = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								eq: $elm$core$Maybe$Just(keyboardModel)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Page$Learn$KeyboardMsg, keyboardCmd),
									resetTimerCommand_
								])));
				}
			case 17:
				var elemIndex = msg.a;
				var blankIndex = msg.b;
				var opts = msg.c;
				var newModel = _Utils_update(
					model,
					{
						fb: A4($author$project$Page$Learn$updateInput, model.fb, elemIndex, blankIndex, $elm$core$Maybe$Nothing)
					});
				var _v7 = model.eq;
				if (!_v7.$) {
					var km = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								eq: $elm$core$Maybe$Just(
									_Utils_update(
										km,
										{ek: ''}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var resetTimerCommand_ = conf.dU ? $author$project$Page$Learn$resetTimerCommand(0) : $elm$core$Platform$Cmd$none;
					var _v8 = A4($author$project$SelectKeyboard$initStringKeyboard, elemIndex, blankIndex, opts.gM, _List_Nil);
					var keyboardModel = _v8.a;
					var keyboardCmd = _v8.b;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								eq: $elm$core$Maybe$Just(keyboardModel)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Page$Learn$KeyboardMsg, keyboardCmd),
									resetTimerCommand_
								])));
				}
			default:
				if (msg.a.$ === 3) {
					var _v9 = msg.a;
					var _v10 = _v9.a;
					var elemIndex = _v10.a;
					var blankIndex = _v10.b;
					var result = _v9.b;
					var keyboardResult = A2(
						$elm$core$Maybe$map,
						function (km) {
							return A2(
								$author$project$SelectKeyboard$update,
								A2(
									$author$project$SelectKeyboard$Submit,
									_Utils_Tuple2(elemIndex, blankIndex),
									result),
								km);
						},
						model.eq);
					var newModel = A2($elm$core$Maybe$map, $elm$core$Tuple$first, keyboardResult);
					var keyboardCmd = A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $elm$core$Tuple$second, keyboardResult));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eq: newModel,
								fb: A4(
									$author$project$Page$Learn$updateInput,
									model.fb,
									elemIndex,
									blankIndex,
									$elm$core$Maybe$Just(result))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Learn$KeyboardMsg, keyboardCmd));
				} else {
					var keyboardMsg = msg.a;
					var keyboardResult = A2(
						$elm$core$Maybe$map,
						function (km) {
							return A2($author$project$SelectKeyboard$update, keyboardMsg, km);
						},
						model.eq);
					var newModel = A2($elm$core$Maybe$map, $elm$core$Tuple$first, keyboardResult);
					var keyboardCmd = A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $elm$core$Tuple$second, keyboardResult));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eq: newModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Learn$KeyboardMsg, keyboardCmd));
				}
		}
	});
var $author$project$Page$Quizes$DoDeleteAll = {$: 14};
var $author$project$Page$Quizes$GetQuizes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Quizes$Init = {$: 7};
var $author$project$Page$Quizes$Mark = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Page$Quizes$QuizFetched = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.g6));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {eZ: reqs, fl: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.ft;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.eZ));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.fl)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					fG: r.fG,
					fL: r.fL,
					gb: A2(_Http_mapExpect, func, r.gb),
					ea: r.ea,
					gy: r.gy,
					fr: r.fr,
					ft: r.ft,
					hp: r.hp
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{fG: false, fL: r.fL, gb: r.gb, ea: r.ea, gy: r.gy, fr: r.fr, ft: r.ft, hp: r.hp}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{fL: $elm$http$Http$emptyBody, gb: r.gb, ea: _List_Nil, gy: 'GET', fr: $elm$core$Maybe$Nothing, ft: $elm$core$Maybe$Nothing, hp: r.hp});
};
var $author$project$Data$Quizes$quizEntryDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Quizes$QuizEntry,
	A2($elm$json$Json$Decode$field, 'quiz', $elm$json$Json$Decode$string));
var $author$project$Page$Quizes$quizEntriesDecoder = A2(
	$elm$json$Json$Decode$field,
	'questions',
	$elm$json$Json$Decode$list($author$project$Data$Quizes$quizEntryDecoder));
var $author$project$Page$Quizes$fetchQuizes = function (genre) {
	return $elm$http$Http$get(
		{
			gb: A2($elm$http$Http$expectJson, $author$project$Page$Quizes$QuizFetched, $author$project$Page$Quizes$quizEntriesDecoder),
			hp: 'json/' + (genre + '/problem.json')
		});
};
var $author$project$QuizDB$getAllEntries = _Platform_outgoingPort(
	'getAllEntries',
	$elm$json$Json$Encode$list($elm$json$Json$Encode$string));
var $author$project$QuizDB$getQuizes = _Platform_outgoingPort(
	'getQuizes',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'count',
					$elm$json$Json$Encode$int($.fZ)),
					_Utils_Tuple2(
					'page',
					$elm$json$Json$Encode$int($.gO))
				]));
	});
var $author$project$Data$Quizes$parseQuizEntries = function (entries) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$author$project$Data$Quizes$foldResult(
			A2($elm$core$List$map, $author$project$Data$Quizes$decodeQuizRecord, entries)));
};
var $author$project$Ports$FileSaver$saveRqz = _Platform_outgoingPort(
	'saveRqz',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string($.fW)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.gC))
				]));
	});
var $author$project$Ports$Browser$simpleConfirm = _Platform_outgoingPort('simpleConfirm', $elm$json$Json$Encode$string);
var $author$project$Env$today = function (_v0) {
	var env = _v0;
	return env.bi;
};
var $author$project$Page$Quizes$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 7:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$Page$Quizes$GetQuizes,
							$elm$core$Task$succeed(model.eM)));
				case 6:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fc: !model.fc}),
						$elm$core$Platform$Cmd$none);
				case 0:
					var genre = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Page$Quizes$fetchQuizes(genre));
				case 1:
					if (!msg.a.$) {
						var quizes = msg.a.a;
						var questions = A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.de;
								},
								$author$project$Data$Quizes$makeRecord(
									_List_fromArray(
										['中学受験']))),
							quizes);
						return _Utils_Tuple2(
							model,
							$author$project$QuizDB$updateQuestions(
								A2($elm$core$List$map, $author$project$Data$Quizes$quizRecordEncoder, questions)));
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 2:
					var pageContext = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eM: pageContext}),
						$author$project$QuizDB$getQuizes(pageContext));
				case 4:
					var entries = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								d2: $elm$core$Dict$fromList(entries)
							}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var entries = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								d1: $author$project$Data$Quizes$parseQuizEntries(entries)
							}),
						$elm$core$Platform$Cmd$none);
				case 5:
					var zone = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bQ: zone}),
						A2(
							$elm$core$Task$perform,
							function (_v1) {
								return $author$project$Page$Quizes$Init;
							},
							$elm$core$Process$sleep(0.5)));
				case 8:
					var key = msg.a;
					var marked = msg.b;
					var markedRecord = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (q) {
								return _Utils_eq(q.ep, key);
							},
							model.d1));
					var toBeProcessed = marked ? A2(
						$elm$core$Maybe$withDefault,
						model.d2,
						A2(
							$elm$core$Maybe$map,
							function (q) {
								return A3($elm$core$Dict$insert, key, q, model.d2);
							},
							markedRecord)) : A2($elm$core$Dict$remove, key, model.d2);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d2: toBeProcessed}),
						$elm$core$Platform$Cmd$none);
				case 9:
					var keys = msg.a;
					var marked = msg.b;
					return A3(
						$elm$core$List$foldr,
						F2(
							function (key, _v2) {
								var mod = _v2.a;
								var cmd = _v2.b;
								var _v3 = A2(
									$author$project$Page$Quizes$update,
									A2($author$project$Page$Quizes$Mark, key, marked),
									mod);
								var newModel = _v3.a;
								var newCmd = _v3.b;
								return _Utils_Tuple2(
									newModel,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[cmd, newCmd])));
							}),
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						keys);
				case 10:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d2: $elm$core$Dict$empty}),
						$author$project$QuizDB$getAllEntries(model.dv.fn));
				case 11:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d2: $elm$core$Dict$empty}),
						$elm$core$Platform$Cmd$none);
				case 12:
					return _Utils_Tuple2(
						model,
						$author$project$Ports$Browser$simpleConfirm('チェックした問題をすべて削除します。よろしいですか?'));
				case 13:
					var yes = msg.a;
					if (yes) {
						var $temp$msg = $author$project$Page$Quizes$DoDeleteAll,
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 14:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d2: $elm$core$Dict$empty}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								$author$project$QuizDB$deleteQuiz,
								$elm$core$Dict$keys(model.d2))));
				case 15:
					var content = msg.a;
					var timeString = $elm$core$String$fromInt(
						$elm$time$Time$posixToMillis(
							$author$project$Env$today(model.bZ)));
					var name = 'run-run-learn-' + timeString;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$FileSaver$saveRqz(
							{fW: content, gC: name}));
				default:
					var tagChooserMsg = msg.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (tm) {
							return _Utils_update(
								model,
								{dv: tm});
						},
						$elm$core$Platform$Cmd$map($author$project$Page$Quizes$TagChooserMsg),
						A2($author$project$Page$TagChooser$update, tagChooserMsg, model.dv));
			}
		}
	});
var $author$project$Main$updateEnv = F2(
	function (newEnv, model) {
		return _Utils_update(
			model,
			{bZ: newEnv});
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var env = $author$project$Main$toEnv(model);
		switch (msg.$) {
			case 10:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var quizMsg = msg.a;
				return A3(
					$author$project$Main$updateWith,
					$author$project$Main$LearnMsg,
					2,
					A2($author$project$Page$Learn$update, quizMsg, model));
			case 6:
				var url = msg.a;
				return A2(
					$author$project$Main$changeRouteTo,
					$author$project$Route$fromUrl(url),
					model);
			case 7:
				var req = msg.a;
				if (!req.$) {
					var url = req.a;
					return ((url.cd === '/') || (url.cd === '/memory-quiz/doc.html')) ? _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url.cd)) : _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$replaceUrl,
							$author$project$Env$key(env),
							url.cd));
				} else {
					var url = req.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 2:
				var indexMsg = msg.a;
				return A3(
					$author$project$Main$updateWith,
					$author$project$Main$IndexMsg,
					1,
					A2($author$project$Page$Index$update, indexMsg, model));
			case 3:
				var quizesMsg = msg.a;
				return A3(
					$author$project$Main$updateWith,
					$author$project$Main$QuizesMsg,
					3,
					A2($author$project$Page$Quizes$update, quizesMsg, model));
			case 4:
				var editQuizMsg = msg.a;
				return A3(
					$author$project$Main$updateWith,
					$author$project$Main$EditQuizMsg,
					4,
					A2($author$project$Page$EditQuiz$update, editQuizMsg, model));
			case 5:
				var importQuizesMsg = msg.a;
				return A3(
					$author$project$Main$updateWith,
					$author$project$Main$ImportQuizesMsg,
					5,
					A2($author$project$Page$ImportQuizes$update, importQuizesMsg, model));
			case 8:
				var newEnv = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Main$updateEnv, newEnv, model),
					$elm$core$Platform$Cmd$none);
			case 0:
				if (!msg.a.$) {
					var quizes = msg.a.a;
					var questions = A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.de;
							},
							$author$project$Data$Quizes$makeRecord(model.dv.fn)),
						quizes);
					return _Utils_Tuple2(
						model,
						$author$project$QuizDB$updateQuestions(
							A2($elm$core$List$map, $author$project$Data$Quizes$quizRecordEncoder, questions)));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var e = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {fL: body, dz: title};
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Env$title = function (_v0) {
	var env = _v0;
	return env.dz;
};
var $author$project$Page$EditQuiz$DeleteQuiz = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$EditQuiz$ModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$EditQuiz$OnBlur = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Page$EditQuiz$OnClicked = {$: 8};
var $author$project$Page$EditQuiz$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$EditQuiz$QuizMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$EditQuiz$SaveQuiz = {$: 2};
var $author$project$ImageSelector$SelectImageFile = {$: 0};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Route$href = function (route) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$routeToString(route));
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Page$EditQuiz$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$EditQuiz$isValid = function (quiz) {
	var includesBlanks = A2(
		$elm$core$Maybe$map,
		function (q) {
			return !$elm$core$List$isEmpty(
				A2(
					$elm$core$List$filter,
					function (s) {
						if (!s.$) {
							return false;
						} else {
							return true;
						}
					},
					q.g1));
		},
		quiz);
	return A2($elm$core$Maybe$withDefault, false, includesBlanks);
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $author$project$Page$EditQuiz$onBlurWithSelectedPosition = function (toMsg) {
	var selectionStartDecoder = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'selectionStart']),
		$elm$json$Json$Decode$int);
	var selectionEndDecoder = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'selectionEnd']),
		$elm$json$Json$Decode$int);
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		A3($elm$json$Json$Decode$map2, toMsg, selectionStartDecoder, selectionEndDecoder));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions = {dd: true, du: false};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$Event = F5(
	function (pointerType, pointer, pointerId, isPrimary, contactDetails) {
		return {fV: contactDetails, gs: isPrimary, eP: pointer, gQ: pointerId, gR: pointerType};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$ContactDetails = F5(
	function (width, height, pressure, tiltX, tiltY) {
		return {eb: height, gT: pressure, hg: tiltX, hh: tiltY, fB: width};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$contactDetailsDecoder = A6(
	$elm$json$Json$Decode$map5,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$ContactDetails,
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pressure', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'tiltX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'tiltY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event = F6(
	function (keys, button, clientPos, offsetPos, pagePos, screenPos) {
		return {fN: button, aW: clientPos, gt: keys, gI: offsetPos, gP: pagePos, g_: screenPos};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$BackButton = 4;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ErrorButton = 0;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ForwardButton = 5;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MainButton = 1;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MiddleButton = 2;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$SecondButton = 3;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId = function (id) {
	switch (id) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		default:
			return 0;
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder = A2(
	$elm$json$Json$Decode$map,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId,
	A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
var $mpizenberg$elm_pointer_events$Internal$Decode$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys = F3(
	function (alt, ctrl, shift) {
		return {fH: alt, f_: ctrl, g2: shift};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $mpizenberg$elm_pointer_events$Internal$Decode$keys = A4(
	$elm$json$Json$Decode$map3,
	$mpizenberg$elm_pointer_events$Internal$Decode$Keys,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$pagePos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$screenPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'screenX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'screenY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder = A7($elm$json$Json$Decode$map6, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event, $mpizenberg$elm_pointer_events$Internal$Decode$keys, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder, $mpizenberg$elm_pointer_events$Internal$Decode$clientPos, $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos, $mpizenberg$elm_pointer_events$Internal$Decode$pagePos, $mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$MouseType = 0;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$PenType = 2;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$TouchType = 1;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$stringToPointerType = function (str) {
	switch (str) {
		case 'pen':
			return 2;
		case 'touch':
			return 1;
		default:
			return 0;
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$pointerTypeDecoder = A2($elm$json$Json$Decode$map, $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$stringToPointerType, $elm$json$Json$Decode$string);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$eventDecoder = A6(
	$elm$json$Json$Decode$map5,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$Event,
	A2($elm$json$Json$Decode$field, 'pointerType', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$pointerTypeDecoder),
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder,
	A2($elm$json$Json$Decode$field, 'pointerId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'isPrimary', $elm$json$Json$Decode$bool),
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$contactDetailsDecoder);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions = F3(
	function (event, options, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						gx: tag(ev),
						dd: options.dd,
						du: options.du
					};
				},
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$eventDecoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions, 'pointerdown', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions);
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Page$TagChooser$AddTag = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$TagChooser$DeleteTag = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$TagChooser$EndInput = {$: 5};
var $author$project$Page$TagChooser$ReadyInput = {$: 4};
var $author$project$Page$TagChooser$UpdateTag = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$Attributes$list = _VirtualDom_attribute('list');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Page$TagChooser$tagChooser = function (model) {
	var candidatesClass = model.g3 ? _List_Nil : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('hidden')
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between px-2 pt-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-grow-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('タグを追加')
							])),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-2xl text-blue-800 far fa-plus-square'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v0) {
									return $author$project$Page$TagChooser$AddTag(model.he);
								})
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col flex-grow')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-2 flex-grow border border-gray-800'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$list('tag-candidates'),
										$elm$html$Html$Events$onInput($author$project$Page$TagChooser$UpdateTag),
										$elm$html$Html$Events$onClick($author$project$Page$TagChooser$ReadyInput),
										$elm$html$Html$Events$onBlur($author$project$Page$TagChooser$EndInput),
										$elm$html$Html$Attributes$value(model.he)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				candidatesClass,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('tag-candidates'),
								$elm$html$Html$Attributes$class('absolute right-0 mr-2 bg-white z-50 text-xl ml-2')
							]),
						A2(
							$elm$core$List$map,
							function (cand) {
								return A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-4 border border-blue-800'),
											$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
											function (_v1) {
												return $author$project$Page$TagChooser$AddTag(cand);
											})
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(cand)
										]));
							},
							model.hd))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('m-2 p-2 text-xs border border-green-600')
					]),
				A2(
					$elm$core$List$map,
					function (tag) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('border inline-block rounded-full bg-purple-300 px-2 py-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(tag),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-2'),
											$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
											function (_v2) {
												return $author$project$Page$TagChooser$DeleteTag(tag);
											})
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fas fa-times')
												]),
											_List_Nil)
										]))
								]));
					},
					model.fn))
			]));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$ImageSelector$CancelImageSelection = {$: 14};
var $author$project$ImageSelector$EndResize = function (a) {
	return {$: 6, a: a};
};
var $author$project$ImageSelector$EndTransformImage = function (a) {
	return {$: 9, a: a};
};
var $author$project$ImageSelector$RenderImage = {$: 12};
var $author$project$ImageSelector$Resize = function (a) {
	return {$: 5, a: a};
};
var $author$project$ImageSelector$RotateImage = function (a) {
	return {$: 10, a: a};
};
var $author$project$ImageSelector$StartResize = function (a) {
	return {$: 4, a: a};
};
var $author$project$ImageSelector$StartTransformImage = function (a) {
	return {$: 7, a: a};
};
var $author$project$ImageSelector$TransformImage = function (a) {
	return {$: 8, a: a};
};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$image = $elm$svg$Svg$trustedNode('image');
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions = {dd: true, du: false};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event = F4(
	function (keys, changedTouches, targetTouches, touches) {
		return {fR: changedTouches, gt: keys, hf: targetTouches, bj: touches};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch = F4(
	function (identifier, clientPos, pagePos, screenPos) {
		return {aW: clientPos, gk: identifier, gP: pagePos, g_: screenPos};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch,
	A2($elm$json$Json$Decode$field, 'identifier', $elm$json$Json$Decode$int),
	$mpizenberg$elm_pointer_events$Internal$Decode$clientPos,
	$mpizenberg$elm_pointer_events$Internal$Decode$pagePos,
	$mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Internal$Decode$all = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf = function (itemDecoder) {
	var decodeOne = function (n) {
		return A2(
			$elm$json$Json$Decode$field,
			$elm$core$String$fromInt(n),
			itemDecoder);
	};
	var decodeN = function (n) {
		return $mpizenberg$elm_pointer_events$Internal$Decode$all(
			A2(
				$elm$core$List$map,
				decodeOne,
				A2($elm$core$List$range, 0, n - 1)));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeN,
		A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder = $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event,
	$mpizenberg$elm_pointer_events$Internal$Decode$keys,
	A2(
		$elm$json$Json$Decode$field,
		'changedTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'targetTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'touches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions = F3(
	function (event, options, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						gx: tag(ev),
						dd: options.dd,
						du: options.du
					};
				},
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onEnd = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchend', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onMove = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions, 'pointermove', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onMove = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchmove', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onStart = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchstart', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onUp = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions, 'pointerup', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions);
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$ImageSelector$showModalClass = function (model) {
	return model.ba ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('opacity-100 pointer-events-auto')
		]) : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('opacity-0 pointer-events-none')
		]);
};
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $author$project$ImageSelector$toSvgTransform = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	var tx = _v0.e;
	var ty = _v0.f;
	var comps = A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			$elm$core$String$fromFloat,
			_List_fromArray(
				[a, b, c, d, tx, ty])));
	return 'matrix(' + (comps + ')');
};
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$ImageSelector$viewImageSelector = function (model) {
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal')
				]),
			$author$project$ImageSelector$showModalClass(model)),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-gray-600 fixed top-0 bottom-0 left-0 right-0 opacity-75')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed top-0 bottom-0 left-0 right-0 m-4 bg-white border-2 border-gray-400 shadow-lg')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$header,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-card-head')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-title')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('delete'),
										$elm$html$Html$Events$onClick($author$project$ImageSelector$CancelImageSelection)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between w-full py-4 px-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										$author$project$ImageSelector$RotateImage(90))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-undo fa-flip-horizontal')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										$author$project$ImageSelector$RotateImage(-90))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-undo')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$section,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-card-body image')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$svg,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('edit_image'),
										$elm$svg$Svg$Attributes$x('0'),
										$elm$svg$Svg$Attributes$y('0'),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat($author$project$ImageSelector$maxImageSize.a)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat($author$project$ImageSelector$maxImageSize.b)),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onStart($author$project$ImageSelector$StartTransformImage),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onMove($author$project$ImageSelector$TransformImage),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onEnd($author$project$ImageSelector$EndTransformImage)
									]),
								_List_fromArray(
									[
										A2(
										$elm$core$Maybe$withDefault,
										A2($elm$svg$Svg$g, _List_Nil, _List_Nil),
										A2(
											$elm$core$Maybe$map,
											function (url) {
												var svgMatrix = $author$project$ImageSelector$toSvgTransform(model.ap);
												return A2(
													$elm$svg$Svg$g,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$svg$Svg$image,
															_List_fromArray(
																[
																	$elm$svg$Svg$Attributes$xlinkHref(url),
																	$elm$svg$Svg$Attributes$x('0'),
																	$elm$svg$Svg$Attributes$y('0'),
																	$elm$svg$Svg$Attributes$width(
																	$elm$core$String$fromFloat(model.a$)),
																	$elm$svg$Svg$Attributes$height(
																	$elm$core$String$fromFloat(model.a_)),
																	$elm$svg$Svg$Attributes$transform(svgMatrix)
																]),
															_List_Nil),
															A2(
															$elm$svg$Svg$rect,
															_List_fromArray(
																[
																	$elm$svg$Svg$Attributes$x(
																	$elm$core$String$fromFloat(0)),
																	$elm$svg$Svg$Attributes$y(
																	$elm$core$String$fromFloat(0)),
																	$elm$svg$Svg$Attributes$width(
																	$elm$core$String$fromFloat(model.G.a)),
																	$elm$svg$Svg$Attributes$height(
																	$elm$core$String$fromFloat(model.G.b)),
																	$elm$svg$Svg$Attributes$stroke('blue'),
																	$elm$svg$Svg$Attributes$strokeWidth('2'),
																	$elm$svg$Svg$Attributes$strokeDasharray('2 2'),
																	$elm$svg$Svg$Attributes$fillOpacity('0')
																]),
															_List_Nil),
															A2(
															$elm$svg$Svg$g,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$svg$Svg$rect,
																	_List_fromArray(
																		[
																			$elm$svg$Svg$Attributes$x(
																			$elm$core$String$fromFloat(model.G.a - 10)),
																			$elm$svg$Svg$Attributes$y(
																			$elm$core$String$fromFloat(model.G.b - 10)),
																			$elm$svg$Svg$Attributes$width(
																			$elm$core$String$fromFloat(10)),
																			$elm$svg$Svg$Attributes$height(
																			$elm$core$String$fromFloat(10)),
																			$elm$svg$Svg$Attributes$stroke('white'),
																			$elm$svg$Svg$Attributes$fill('green')
																		]),
																	_List_Nil),
																	A2(
																	$elm$svg$Svg$rect,
																	_List_fromArray(
																		[
																			$elm$svg$Svg$Attributes$x(
																			$elm$core$String$fromFloat(model.G.a - 25)),
																			$elm$svg$Svg$Attributes$y(
																			$elm$core$String$fromFloat(model.G.b - 25)),
																			$elm$svg$Svg$Attributes$width(
																			$elm$core$String$fromFloat(50)),
																			$elm$svg$Svg$Attributes$height(
																			$elm$core$String$fromFloat(50)),
																			$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown($author$project$ImageSelector$StartResize),
																			$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onMove($author$project$ImageSelector$Resize),
																			$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onUp($author$project$ImageSelector$EndResize),
																			$elm$svg$Svg$Attributes$strokeOpacity('0'),
																			$elm$svg$Svg$Attributes$fillOpacity('0')
																		]),
																	_List_Nil)
																]))
														]));
											},
											model.aC))
									]))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('py-2 bg-green-400 rounded-lg px-4 w-full mt-4'),
								$elm$html$Html$Events$onClick($author$project$ImageSelector$RenderImage)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('決定')
							]))
					]))
			]));
};
var $author$project$Page$EditQuiz$Cancelled = {$: 1};
var $author$project$Page$EditQuiz$Confirmed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$EditQuiz$Update = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$EditQuiz$viewModalCard = function (model) {
	var showModalClass = model.ba ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('opacity-100 pointer-events-auto')
		]) : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('opacity-0 pointer-events-none')
		]);
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('modal'),
			showModalClass),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-gray-600 fixed top-0 bottom-0 left-0 right-0 opacity-75')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed top-0 bottom-0 left-0 right-0 m-4 bg-white border-2 border-gray-400 shadow-lg')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$header,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex pt-4 pl-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-xl')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('選択肢の追加')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('delete'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v0) {
											return $author$project$Page$EditQuiz$Cancelled;
										})
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$section,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-card-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full text-lg p-4 font-black')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(model.fI),
										A2(
										$elm$html$Html$textarea,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full h-64 my-4 border-2 border-blue-600'),
												$elm$html$Html$Events$onInput($author$project$Page$EditQuiz$Update),
												$elm$html$Html$Attributes$value(
												A2($elm$core$String$join, '\n', model.aX))
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between w-full pb-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex-auto bg-green-400 py-2 px-4 rounded-full border-2'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v1) {
											return $author$project$Page$EditQuiz$Confirmed(model.aX);
										})
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OK')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex-auto bg-blue-400 py-2 px-4 rounded-full border-2'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v2) {
											return $author$project$Page$EditQuiz$Cancelled;
										})
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Learn$InputAnswer = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Page$Learn$OpenCharKeyboard = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Page$Learn$OpenStringKeyboard = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Page$Learn$listAt = F2(
	function (index, list) {
		return $elm$core$List$head(
			A2($elm$core$List$drop, index, list));
	});
var $author$project$Page$Learn$onChange = function (handler) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2(
			$elm$json$Json$Decode$map,
			handler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'value']),
				$elm$json$Json$Decode$string)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Page$Learn$sentenceBodyToHtml = F2(
	function (idx, body) {
		switch (body.$) {
			case 0:
				var s = body.a;
				return A2(
					$elm$core$List$map,
					function (t) {
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[t]));
					},
					A2(
						$elm$core$List$map,
						$elm$html$Html$text,
						A2(
							$elm$core$List$map,
							$elm$core$String$fromChar,
							$elm$core$String$toList(s))));
			case 1:
				var answer = body.a;
				var opts = body.b;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block')
							]),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (blankIdx, _v1) {
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-block min-w-16 h-10 rounded border border-gray-600 px-2'),
												$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
												function (_v2) {
													return A3($author$project$Page$Learn$OpenStringKeyboard, idx, blankIdx, opts);
												})
											]),
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text('???'),
												A2(
													$elm$core$Maybe$map,
													$elm$html$Html$text,
													A2(
														$elm$core$Maybe$withDefault,
														$elm$core$Maybe$Nothing,
														A2($author$project$Page$Learn$listAt, blankIdx, opts.hr))))
											]));
								}),
							$elm$core$Set$toList(answer)))
					]);
			case 2:
				var answer = body.a;
				var opts = body.b;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-block')
							]),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (blankIdx, _v3) {
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-block min-w-16 h-10 rounded border border-gray-600 px-2'),
												$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
												function (_v4) {
													return A3($author$project$Page$Learn$OpenCharKeyboard, idx, blankIdx, opts);
												})
											]),
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text('???'),
												A2(
													$elm$core$Maybe$map,
													$elm$html$Html$text,
													A2(
														$elm$core$Maybe$withDefault,
														$elm$core$Maybe$Nothing,
														A2($author$project$Page$Learn$listAt, blankIdx, opts.hr))))
											]));
								}),
							$elm$core$Set$toList(answer)))
					]);
			default:
				var answer = body.a;
				var userInput = body.b;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (blankIdx, _v5) {
									var inputString = A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$withDefault,
											$elm$core$Maybe$Nothing,
											A2($author$project$Page$Learn$listAt, blankIdx, userInput)));
									var inputLength = ($elm$core$String$length(inputString) * 2) + 2;
									return A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('????'),
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromInt(inputLength) + 'ch'),
												A2($elm$html$Html$Attributes$style, 'min-width', '10ch'),
												$elm$html$Html$Attributes$class('input is-medium'),
												$author$project$Page$Learn$onChange(
												A2($author$project$Page$Learn$InputAnswer, idx, blankIdx)),
												$elm$html$Html$Attributes$value(inputString)
											]),
										_List_Nil);
								}),
							$elm$core$Set$toList(answer)))
					]);
		}
	});
var $author$project$Page$Learn$viewQuiz = F3(
	function (cps, show, quiz) {
		var showClass = show ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('show')
			]) : _List_Nil;
		var delayStep = A2(
			$elm$core$Maybe$withDefault,
			0.0,
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return 1.0 / c;
				},
				cps));
		var showBody = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, elem) {
					var delay = i * delayStep;
					var delayStyle = show ? _List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$style,
							'transition-delay',
							$elm$core$String$fromFloat(delay) + 's')
						]) : _List_Nil;
					return A2(
						$elm$html$Html$span,
						_Utils_ap(
							showClass,
							_Utils_ap(
								delayStyle,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('char')
									]))),
						_List_fromArray(
							[elem]));
				}),
			$elm$core$List$concat(
				A2($elm$core$List$indexedMap, $author$project$Page$Learn$sentenceBodyToHtml, quiz.g1)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white h-screen w-screen text-2xl mt-8 left-0 absolute px-6 pt-4 mb-12 text-gray-800 overflow-y-scroll pb-64')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$div, _List_Nil, showBody),
					A2(
					$elm$core$Maybe$withDefault,
					A2($elm$html$Html$div, _List_Nil, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (url) {
							return A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(url)
									]),
								_List_Nil);
						},
						quiz.gl))
				]));
	});
var $author$project$Page$EditQuiz$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col m-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full h-48 text-2xl left-0 right-0'),
								$elm$html$Html$Attributes$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.d3;
											},
											function ($) {
												return $.de;
											}),
										model.eX))),
								$elm$html$Html$Events$onInput($author$project$Page$EditQuiz$OnInput),
								$author$project$Page$EditQuiz$onBlurWithSelectedPosition($author$project$Page$EditQuiz$OnBlur)
							]),
						_List_Nil),
						A2(
						$elm$core$Maybe$withDefault,
						A2($elm$html$Html$div, _List_Nil, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (dataUrl) {
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(dataUrl)
										]),
									_List_Nil);
							},
							model.eg)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-blue-300 text-gray-800 rounded py-2 px-4'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v0) {
											return $author$project$Page$EditQuiz$OnClicked;
										})
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('ここを空欄にする')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-green-300 text-gray-800 rounded py-2 px-4'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v1) {
											return $author$project$Page$EditQuiz$ImageSelectorMsg($author$project$ImageSelector$SelectImageFile);
										})
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('画像を添付する')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Page$EditQuiz$TagChooserMsg,
						$author$project$Page$TagChooser$tagChooser(model.dv))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('overflow-y-scroll w-full -mt-8')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Page$EditQuiz$QuizMsg,
						A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('...')
									])),
							A2(
								$elm$core$Maybe$map,
								A2($author$project$Page$Learn$viewQuiz, $elm$core$Maybe$Nothing, true),
								model.de)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed bottom-0 bg-white w-full flex justify-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-auto bg-green-400 text-gray-800 border-2 rounded-lg py-2 px-4 text-center'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v2) {
									return $author$project$Page$EditQuiz$SaveQuiz;
								}),
								$elm$html$Html$Attributes$disabled(
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Page$EditQuiz$isValid)(model.de))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('保存')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-auto bg-red-600 text-white border-2 rounded-lg py-2 px-4 text-center'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v3) {
									return $author$project$Page$EditQuiz$DeleteQuiz(
										A2($elm$core$Maybe$withDefault, '', model.ep));
								}),
								$elm$html$Html$Attributes$disabled(
								$author$project$Page$EditQuiz$isNothing(model.ep))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('削除')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-auto bg-white text-gray-800 border-2 rounded-lg py-2 px-4 text-center'),
								$author$project$Route$href($author$project$Route$Quizes)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('戻る')
							]))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Page$EditQuiz$ModalMsg,
				$author$project$Page$EditQuiz$viewModalCard(model.eA)),
				A2(
				$elm$html$Html$map,
				$author$project$Page$EditQuiz$ImageSelectorMsg,
				$author$project$ImageSelector$viewImageSelector(model.eh))
			]));
};
var $author$project$Page$ImportQuizes$ImportFileSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$ImportQuizes$ImportQuizesAndBack = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$ImportQuizes$OnInput = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $author$project$Page$ImportQuizes$isNothing = function (m) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return false;
			},
			m));
};
var $author$project$Page$ImportQuizes$onFileSelected = function (toMsg) {
	var decoder = A2(
		$elm$json$Json$Decode$map,
		toMsg,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$head,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'files']),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$value))));
	return A2($elm$html$Html$Events$on, 'change', decoder);
};
var $author$project$Page$ImportQuizes$view = function (model) {
	var textAreaBody = $author$project$Page$ImportQuizes$isNothing(model.e8) ? _List_Nil : _List_fromArray(
		[
			$elm$html$Html$text(
			A2($elm$core$String$join, '\n\n', model.gU))
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex-col flex'),
				A2($elm$html$Html$Attributes$style, 'height', '100vh')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('top-0')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('まとめて問題を作る')
					])),
				A2(
				$elm$html$Html$textarea,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-grow border border-blue-400 m-2 shadow-lg'),
						$elm$html$Html$Attributes$placeholder('一問ごとに一行の空行を入れてください。'),
						$elm$html$Html$Attributes$disabled(
						A3($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Page$ImportQuizes$isNothing, model.e8)),
						$elm$html$Html$Events$onInput($author$project$Page$ImportQuizes$OnInput)
					]),
				textAreaBody),
				A2(
				$elm$html$Html$map,
				$author$project$Page$ImportQuizes$TagChooserMsg,
				$author$project$Page$TagChooser$tagChooser(model.dv)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col p-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('.rqz ファイルから取り込む')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('file'),
										$elm$html$Html$Attributes$accept('.rqz'),
										$author$project$Page$ImportQuizes$onFileSelected($author$project$Page$ImportQuizes$ImportFileSelected)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between py-4 bottom-0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-green-400 mx-4 px-4 py-2 rounded-lg disabled:opacity-50'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v0) {
									return A2($author$project$Page$ImportQuizes$ImportQuizesAndBack, model.gU, model.dv.fn);
								}),
								$elm$html$Html$Attributes$disabled(
								($elm$core$List$isEmpty(model.gU) || A2($elm$core$List$all, $elm$core$String$isEmpty, model.gU)) && $author$project$Page$ImportQuizes$isNothing(model.e8))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('とりこむ')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-gray-400 mx-4 px-4 py-2 rounded-lg'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v1) {
									return $author$project$Page$ImportQuizes$NavigationBack;
								})
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('キャンセル')
							]))
					]))
			]));
};
var $author$project$Page$Index$ShowChart = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Index$ShowConfigDialog = {$: 7};
var $author$project$Page$Index$ToggleMenu = {$: 6};
var $author$project$Page$Index$buy_me_a_coffee = function (shown) {
	return shown ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col w-full items-center mt-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mx-auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('https://www.buymeacoffee.com/run.run.learn')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=run.run.learn&button_colour=FFDD00&font_colour=000000&font_family=Cookie&outline_colour=000000&coffee_colour=ffffff')
									]),
								_List_Nil)
							]))
					]))
			])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Env$lastQuiz = function (_v0) {
	var env = _v0;
	return env.b$;
};
var $author$project$WikiParser$normalize = function (wiki) {
	var bodyToStr = function (body) {
		if (!body.$) {
			var s = body.a;
			return s;
		} else {
			var options = body.a;
			return '[[' + (A2($elm$core$String$join, ',', options.fI) + ']]');
		}
	};
	var norm = function (q) {
		return A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, bodyToStr, q.de));
	};
	return A2(
		$elm$core$Result$map,
		norm,
		$author$project$WikiParser$parse(wiki));
};
var $author$project$Env$origin = function (_v0) {
	var env = _v0;
	return env.c0;
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Page$Common$showNavBar = F3(
	function (showMenu, toggleMsg, menuItems) {
		var showMenuClass = showMenu ? 'normal' : 'hide';
		var buttonIcon = showMenu ? _List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-times')
					]),
				_List_Nil)
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-bars')
					]),
				_List_Nil)
			]);
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-green-400 fixed w-full top-0 z-50')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center h-12')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg pl-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Run Run LEARN!')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pr-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('focus:outline-none text-2xl'),
											$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
											function (_v0) {
												return toggleMsg;
											})
										]),
									buttonIcon)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hamburger ' + showMenuClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute right-0 text-gray-800 bg-white border-l border-r')
								]),
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('hover:bg-gray-300 hover:text-gray-800 block px-4 py-2 border-b')
											]),
										_List_fromArray(
											[item]));
								},
								menuItems))
						]))
				]));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Page$Index$truncateString = F2(
	function (len, s) {
		return (_Utils_cmp(
			$elm$core$String$length(s),
			len) > 0) ? function (s_) {
			return s_ + '..';
		}(
			$elm$core$String$fromList(
				A2(
					$elm$core$List$take,
					len - 1,
					$elm$core$String$toList(s)))) : s;
	});
var $author$project$Page$Config$CloseConfigDialog = {$: 7};
var $author$project$Page$Config$SaveUpdatedConfig = {$: 6};
var $author$project$Page$Config$SetDisplaySpeed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Config$SetTimeout = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Config$UpdateCountDownOnSelectBlank = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Config$UpdateInputEachChar = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Config$UpdateSpeakEnglish = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Config$UpdateTimeBonus = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Page$Config$intOptions = F4(
	function (lowerBound, upperBound, step, selectedValue) {
		return A2(
			$elm$core$List$map,
			function (value_) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromInt(value_)),
							$elm$html$Html$Attributes$selected(
							_Utils_eq(value_, selectedValue))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(value_))
						]));
			},
			A2(
				$elm$core$List$filter,
				function (v) {
					return !A2($elm$core$Basics$modBy, step, v);
				},
				A2($elm$core$List$range, lowerBound, upperBound)));
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Page$Config$view = function (model) {
	var timeBonus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fq;
			},
			model.dR));
	var speakEnglish = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fg;
			},
			model.dR));
	var inputEachChar = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.el;
			},
			model.dR));
	var currentTimeout = A2(
		$elm$core$Maybe$withDefault,
		10,
		A2(
			$elm$core$Maybe$map,
			function (t) {
				return (t / 1000) | 0;
			},
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ei;
				},
				model.dR)));
	var currentCps = A2(
		$elm$core$Maybe$withDefault,
		24,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dV;
			},
			model.dR));
	var countDownOnSelectBlank = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dU;
			},
			model.dR));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col top-0 bottom-0 w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b flex justify-between md:flex md:justify-between md:items-center py-2 mr-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block text-gray-800 flex justify-between w-full items-center px-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('1問あたりの制限時間')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(
												$elm$core$String$fromInt(currentTimeout)),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2(
														$elm$core$Basics$composeL,
														$author$project$Page$Config$SetTimeout,
														$elm$core$Maybe$withDefault(currentTimeout)),
													$elm$core$String$toInt))
											]),
										A4($author$project$Page$Config$intOptions, 5, 20, 1, currentTimeout)),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('秒')
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b flex justify-between md:flex md:justify-between md:items-center py-2 mr-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block text-gray-800 flex justify-between w-full items-center px-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('問題の表示スピード')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(
												$elm$core$String$fromInt(currentCps)),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2(
														$elm$core$Basics$composeL,
														$author$project$Page$Config$SetDisplaySpeed,
														$elm$core$Maybe$withDefault(currentTimeout)),
													$elm$core$String$toInt))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$option,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$value('12'),
														$elm$html$Html$Attributes$selected(currentCps === 12)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('低速')
													])),
												A2(
												$elm$html$Html$option,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$value('24'),
														$elm$html$Html$Attributes$selected(currentCps === 24)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('中速')
													])),
												A2(
												$elm$html$Html$option,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$value('48'),
														$elm$html$Html$Attributes$selected(currentCps === 48)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('高速')
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b flex justify-start md:flex md:justify-between md:items-center py-2 mr-4 px-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block text-gray-800 flex items-center w-full justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('解答時間ボーナスあり')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-2 leading-tight'),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(timeBonus),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v0) {
											return $author$project$Page$Config$UpdateTimeBonus(!timeBonus);
										})
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b flex justify-start md:flex md:justify-between md:items-center py-2 mr-4 px-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block text-gray-800 flex items-center w-full justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('一文字ずつ別々に入力する')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-2 leading-tight'),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(inputEachChar),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v1) {
											return $author$project$Page$Config$UpdateInputEachChar(!inputEachChar);
										})
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b flex justify-start md:flex md:justify-between md:items-center py-2 mr-4 px-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block text-gray-800 flex items-center w-full justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('空欄選択時にタイマーをスタートする')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-2 leading-tight'),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(countDownOnSelectBlank),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v2) {
											return $author$project$Page$Config$UpdateCountDownOnSelectBlank(!countDownOnSelectBlank);
										})
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('border-b flex justify-start md:flex md:justify-between md:items-center py-2 mr-4 px-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block text-gray-800 flex items-center w-full justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('英語を読み上げる(実験的機能)')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-2 leading-tight'),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(speakEnglish),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v3) {
											return $author$project$Page$Config$UpdateSpeakEnglish(!speakEnglish);
										})
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between py-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border mx-4 px-4 py-1 rounded-md bg-green-400'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v4) {
									return $author$project$Page$Config$SaveUpdatedConfig;
								})
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('OK')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border mx-4 px-4 py-1 rounded-md bg-gray-400'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v5) {
									return $author$project$Page$Config$CloseConfigDialog;
								})
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							]))
					]))
			]));
};
var $elm_community$typed_svg$TypedSvg$Types$Fill = function (a) {
	return {$: 0, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$Translate = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $gampleman$elm_visualization$Scale$Scale = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $gampleman$elm_visualization$Scale$Band$normalizeConfig = function (_v0) {
	var paddingInner = _v0.eK;
	var paddingOuter = _v0.eL;
	var align = _v0.dI;
	return {
		dI: A3($elm$core$Basics$clamp, 0, 1, align),
		eK: A3($elm$core$Basics$clamp, 0, 1, paddingInner),
		eL: A3($elm$core$Basics$clamp, 0, 1, paddingOuter)
	};
};
var $gampleman$elm_visualization$Scale$Band$bandwidth = F3(
	function (cfg, domain, _v0) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		var n = $elm$core$List$length(domain);
		var _v1 = (_Utils_cmp(d0, d1) < 0) ? _Utils_Tuple2(d0, d1) : _Utils_Tuple2(d1, d0);
		var start = _v1.a;
		var stop = _v1.b;
		var _v2 = $gampleman$elm_visualization$Scale$Band$normalizeConfig(cfg);
		var paddingInner = _v2.eK;
		var paddingOuter = _v2.eL;
		var align = _v2.dI;
		var step = (stop - start) / A2($elm$core$Basics$max, 1, (n - paddingInner) + (paddingOuter * 2));
		return step * (1 - paddingInner);
	});
var $gampleman$elm_visualization$Scale$Band$computePositions = F4(
	function (index, cfg, n, _v0) {
		var start = _v0.a;
		var stop = _v0.b;
		var _v1 = $gampleman$elm_visualization$Scale$Band$normalizeConfig(cfg);
		var paddingInner = _v1.eK;
		var paddingOuter = _v1.eL;
		var align = _v1.dI;
		var step = (stop - start) / A2($elm$core$Basics$max, 1, (n - paddingInner) + (paddingOuter * 2));
		var start2 = start + (((stop - start) - (step * (n - paddingInner))) * align);
		return _Utils_Tuple2(start2, step);
	});
var $gampleman$elm_visualization$Scale$Band$indexOfHelp = F3(
	function (index, value, list) {
		indexOfHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (_Utils_eq(value, x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$value = value,
						$temp$list = xs;
					index = $temp$index;
					value = $temp$value;
					list = $temp$list;
					continue indexOfHelp;
				}
			}
		}
	});
var $gampleman$elm_visualization$Scale$Band$indexOf = $gampleman$elm_visualization$Scale$Band$indexOfHelp(0);
var $gampleman$elm_visualization$Scale$Band$convert = F4(
	function (cfg, domain, _v0, value) {
		var start = _v0.a;
		var stop = _v0.b;
		var _v1 = A2($gampleman$elm_visualization$Scale$Band$indexOf, value, domain);
		if (!_v1.$) {
			var index = _v1.a;
			var n = $elm$core$List$length(domain);
			if (_Utils_cmp(start, stop) < 0) {
				var _v2 = A4(
					$gampleman$elm_visualization$Scale$Band$computePositions,
					index,
					cfg,
					n,
					_Utils_Tuple2(start, stop));
				var start2 = _v2.a;
				var step = _v2.b;
				return start2 + (step * index);
			} else {
				var _v3 = A4(
					$gampleman$elm_visualization$Scale$Band$computePositions,
					index,
					cfg,
					n,
					_Utils_Tuple2(stop, start));
				var stop2 = _v3.a;
				var step = _v3.b;
				return stop2 + (step * ((n - index) - 1));
			}
		} else {
			return 0 / 0;
		}
	});
var $gampleman$elm_visualization$Scale$band = F3(
	function (config, range_, domain_) {
		return {
			cs: A3($gampleman$elm_visualization$Scale$Band$bandwidth, config, domain_, range_),
			H: $gampleman$elm_visualization$Scale$Band$convert(config),
			cz: domain_,
			w: range_
		};
	});
var $gampleman$elm_visualization$Scale$bandwidth = function (_v0) {
	var scale = _v0;
	return scale.cs;
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $gampleman$elm_visualization$Scale$tickFormat = function (_v0) {
	var opts = _v0;
	return opts.dw(opts.cz);
};
var $gampleman$elm_visualization$Scale$ticks = F2(
	function (_v0, count) {
		var scale = _v0;
		return A2(scale.dx, scale.cz, count);
	});
var $gampleman$elm_visualization$Axis$computeOptions = F2(
	function (attrs, scale) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (attr, _v1) {
					var babyOpts = _v1.a;
					var post = _v1.b;
					switch (attr.$) {
						case 2:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{bf: val}),
								post);
						case 3:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{bg: val}),
								post);
						case 4:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{aG: val}),
								post);
						case 5:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{bG: val}),
								post);
						default:
							return _Utils_Tuple2(
								babyOpts,
								A2($elm$core$List$cons, attr, post));
					}
				}),
			_Utils_Tuple2(
				{bf: 10, bG: 3, bg: 6, aG: 6},
				_List_Nil),
			attrs);
		var opts = _v0.a;
		var postList = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (attr, options) {
					switch (attr.$) {
						case 0:
							var val = attr.a;
							return _Utils_update(
								options,
								{dx: val});
						case 1:
							var val = attr.a;
							return _Utils_update(
								options,
								{dw: val});
						default:
							return options;
					}
				}),
			{
				bf: opts.bf,
				dw: A2($gampleman$elm_visualization$Scale$tickFormat, scale, opts.bf),
				bG: opts.bG,
				bg: opts.bg,
				aG: opts.aG,
				dx: A2($gampleman$elm_visualization$Scale$ticks, scale, opts.bf)
			},
			postList);
	});
var $gampleman$elm_visualization$Scale$convert = F2(
	function (_v0, value) {
		var scale = _v0;
		return A3(scale.H, scale.cz, scale.w, value);
	});
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$dy = _VirtualDom_attribute('dy');
var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $gampleman$elm_visualization$Scale$rangeExtent = function (_v0) {
	var options = _v0;
	return A2(options.a9, options.cz, options.w);
};
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $gampleman$elm_visualization$Axis$element = F4(
	function (_v0, k, displacement, textAnchorPosition) {
		var x = _v0.cn;
		var y = _v0.co;
		var x1 = _v0.hw;
		var x2 = _v0.hx;
		var y1 = _v0.hA;
		var y2 = _v0.hB;
		var translate = _v0.dB;
		var horizontal = _v0.cC;
		return F2(
			function (attrs, scale) {
				var rangeExtent = $gampleman$elm_visualization$Scale$rangeExtent(scale);
				var range1 = rangeExtent.b + 0.5;
				var range0 = rangeExtent.a + 0.5;
				var position = $gampleman$elm_visualization$Scale$convert(scale);
				var opts = A2($gampleman$elm_visualization$Axis$computeOptions, attrs, scale);
				var spacing = A2($elm$core$Basics$max, opts.bg, 0) + opts.bG;
				var drawTick = function (tick) {
					return A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('tick'),
								$elm$svg$Svg$Attributes$transform(
								translate(
									position(tick)))
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stroke('#000'),
										x2(k * opts.bg),
										y1(0.5),
										y2(0.5)
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$text_,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('#000'),
										x(k * spacing),
										y(0.5),
										$elm$svg$Svg$Attributes$dy(displacement)
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$text(
										opts.dw(tick))
									]))
							]));
				};
				var domainLine = horizontal ? ('M' + ($elm$core$String$fromFloat(k * opts.aG) + (',' + ($elm$core$String$fromFloat(range0) + ('H0.5V' + ($elm$core$String$fromFloat(range1) + ('H' + $elm$core$String$fromFloat(k * opts.aG)))))))) : ('M' + ($elm$core$String$fromFloat(range0) + (',' + ($elm$core$String$fromFloat(k * opts.aG) + ('V0.5H' + ($elm$core$String$fromFloat(range1) + ('V' + $elm$core$String$fromFloat(k * opts.aG))))))));
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$fontSize('10'),
							$elm$svg$Svg$Attributes$fontFamily('sans-serif'),
							$elm$svg$Svg$Attributes$textAnchor(textAnchorPosition)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('domain'),
									$elm$svg$Svg$Attributes$stroke('#000'),
									$elm$svg$Svg$Attributes$d(domainLine)
								]),
							_List_Nil),
						A2($elm$core$List$map, drawTick, opts.dx)));
			});
	});
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $gampleman$elm_visualization$Axis$verticalAttrs = {
	cC: false,
	dB: function (x) {
		return 'translate(' + ($elm$core$String$fromFloat(x) + ', 0)');
	},
	cn: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y, $elm$core$String$fromFloat),
	hw: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y1, $elm$core$String$fromFloat),
	hx: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y2, $elm$core$String$fromFloat),
	co: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x, $elm$core$String$fromFloat),
	hA: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x1, $elm$core$String$fromFloat),
	hB: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x2, $elm$core$String$fromFloat)
};
var $gampleman$elm_visualization$Axis$bottom = A4($gampleman$elm_visualization$Axis$element, $gampleman$elm_visualization$Axis$verticalAttrs, 1, '0.71em', 'middle');
var $gampleman$elm_visualization$Scale$defaultBandConfig = {dI: 0.5, eK: 0.0, eL: 0.0};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm_community$typed_svg$TypedSvg$Core$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm_community$typed_svg$TypedSvg$TypesToStrings$fillToString = function (fill) {
	if (!fill.$) {
		var color = fill.a;
		return $avh4$elm_color$Color$toCssString(color);
	} else {
		return 'none';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$fill = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('fill'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$fillToString);
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm_community$typed_svg$TypedSvg$Core$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm_community$typed_svg$TypedSvg$g = $elm_community$typed_svg$TypedSvg$Core$node('g');
var $avh4$elm_color$Color$green = A4($avh4$elm_color$Color$RgbaSpace, 115 / 255, 210 / 255, 22 / 255, 1.0);
var $elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString = function (length) {
	switch (length.$) {
		case 0:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'cm';
		case 1:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'em';
		case 2:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'ex';
		case 3:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'in';
		case 4:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'mm';
		case 5:
			var x = length.a;
			return $elm$core$String$fromFloat(x);
		case 6:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pc';
		case 7:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + '%';
		case 8:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pt';
		default:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'px';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$height = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'height',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Types$Px = function (a) {
	return {$: 9, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$px = $elm_community$typed_svg$TypedSvg$Types$Px;
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$height = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$height(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $gampleman$elm_visualization$Axis$horizontalAttrs = {
	cC: true,
	dB: function (y) {
		return 'translate(0, ' + ($elm$core$String$fromFloat(y) + ')');
	},
	cn: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x, $elm$core$String$fromFloat),
	hw: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x1, $elm$core$String$fromFloat),
	hx: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x2, $elm$core$String$fromFloat),
	co: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y, $elm$core$String$fromFloat),
	hA: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y1, $elm$core$String$fromFloat),
	hB: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y2, $elm$core$String$fromFloat)
};
var $gampleman$elm_visualization$Axis$left = A4($gampleman$elm_visualization$Axis$element, $gampleman$elm_visualization$Axis$horizontalAttrs, -1, '0.32em', 'end');
var $gampleman$elm_visualization$Scale$Internal$bimap = F4(
	function (_v0, _v1, deinterpolate, reinterpolate) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		var r0 = _v1.a;
		var r1 = _v1.b;
		var _v2 = (_Utils_cmp(d1, d0) < 0) ? _Utils_Tuple2(
			A2(deinterpolate, d1, d0),
			A2(reinterpolate, r1, r0)) : _Utils_Tuple2(
			A2(deinterpolate, d0, d1),
			A2(reinterpolate, r0, r1));
		var de = _v2.a;
		var re = _v2.b;
		return A2($elm$core$Basics$composeL, re, de);
	});
var $gampleman$elm_visualization$Scale$Linear$deinterpolate = F3(
	function (a, b, x) {
		var normalizedB = b - a;
		return (!normalizedB) ? 0 : ((x - a) / normalizedB);
	});
var $gampleman$elm_visualization$Scale$Internal$interpolateFloat = F3(
	function (from, to, time) {
		return from + ((to - from) * time);
	});
var $gampleman$elm_visualization$Scale$Linear$convert = F2(
	function (domain, range) {
		return A4($gampleman$elm_visualization$Scale$Internal$bimap, domain, range, $gampleman$elm_visualization$Scale$Linear$deinterpolate, $gampleman$elm_visualization$Scale$Internal$interpolateFloat);
	});
var $gampleman$elm_visualization$Scale$Linear$interpolate = $gampleman$elm_visualization$Scale$Internal$interpolateFloat;
var $gampleman$elm_visualization$Scale$Linear$invert = F2(
	function (domain, range) {
		return A4($gampleman$elm_visualization$Scale$Internal$bimap, range, domain, $gampleman$elm_visualization$Scale$Linear$deinterpolate, $gampleman$elm_visualization$Scale$Linear$interpolate);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Basics$e = _Basics_e;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $gampleman$elm_visualization$Statistics$tickStep = F3(
	function (start, stop, count) {
		var step0 = $elm$core$Basics$abs(stop - start) / A2($elm$core$Basics$max, 0, count);
		var step1 = A2(
			$elm$core$Basics$pow,
			10,
			$elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Basics$e, step0) / A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10)));
		var error = step0 / step1;
		var step2 = (_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(50)) > -1) ? (step1 * 10) : ((_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(10)) > -1) ? (step1 * 5) : ((_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(2)) > -1) ? (step1 * 2) : step1));
		return (_Utils_cmp(stop, start) < 0) ? (-step2) : step2;
	});
var $gampleman$elm_visualization$Scale$Linear$nice = F2(
	function (_v0, count) {
		var start = _v0.a;
		var stop = _v0.b;
		var step0 = A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count);
		var step1 = A3(
			$gampleman$elm_visualization$Statistics$tickStep,
			$elm$core$Basics$floor(start / step0) * step0,
			$elm$core$Basics$ceiling(stop / step0) * step0,
			count);
		return _Utils_Tuple2(
			$elm$core$Basics$floor(start / step1) * step1,
			$elm$core$Basics$ceiling(stop / step1) * step1);
	});
var $gampleman$elm_visualization$Scale$Linear$rangeExtent = F2(
	function (d, r) {
		return r;
	});
var $gampleman$elm_visualization$Scale$Linear$exponent = function (x) {
	return (!x) ? 0 : ((x < 1) ? (1 + $gampleman$elm_visualization$Scale$Linear$exponent(x * 10)) : 0);
};
var $gampleman$elm_visualization$Scale$Linear$precisionFixed = function (step) {
	return A2(
		$elm$core$Basics$max,
		0,
		$gampleman$elm_visualization$Scale$Linear$exponent(
			$elm$core$Basics$abs(step)));
};
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $gampleman$elm_visualization$Scale$Internal$toFixed = F2(
	function (precision, value) {
		var power = A2($elm$core$Basics$pow, 10, precision);
		var pad = function (num) {
			_v0$2:
			while (true) {
				if (num.b) {
					if (num.b.b) {
						if (!num.b.b.b) {
							var x = num.a;
							var _v1 = num.b;
							var y = _v1.a;
							return _List_fromArray(
								[
									x,
									A3($elm$core$String$padRight, precision, '0', y)
								]);
						} else {
							break _v0$2;
						}
					} else {
						var val = num.a;
						return (precision > 0) ? _List_fromArray(
							[
								val,
								A3($elm$core$String$padRight, precision, '0', '')
							]) : _List_fromArray(
							[val]);
					}
				} else {
					break _v0$2;
				}
			}
			var val = num;
			return val;
		};
		return A2(
			$elm$core$String$join,
			'.',
			pad(
				A2(
					$elm$core$String$split,
					'.',
					$elm$core$String$fromFloat(
						$elm$core$Basics$round(value * power) / power))));
	});
var $gampleman$elm_visualization$Scale$Linear$tickFormat = F2(
	function (_v0, count) {
		var start = _v0.a;
		var stop = _v0.b;
		return $gampleman$elm_visualization$Scale$Internal$toFixed(
			$gampleman$elm_visualization$Scale$Linear$precisionFixed(
				A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count)));
	});
var $gampleman$elm_visualization$Statistics$range = F3(
	function (start, stop, step) {
		var n = A2(
			$elm$core$Basics$max,
			0,
			0 | $elm$core$Basics$ceiling((stop - start) / step));
		var helper = F2(
			function (i, list) {
				return (i >= 0) ? A2(
					helper,
					i - 1,
					A2($elm$core$List$cons, start + (step * i), list)) : list;
			});
		return A2(helper, n - 1, _List_Nil);
	});
var $gampleman$elm_visualization$Statistics$ticks = F3(
	function (start, stop, count) {
		var step = A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count);
		var end = ($elm$core$Basics$floor(stop / step) * step) + (step / 2);
		var beg = $elm$core$Basics$ceiling(start / step) * step;
		return A3($gampleman$elm_visualization$Statistics$range, beg, end, step);
	});
var $gampleman$elm_visualization$Scale$Linear$ticks = F2(
	function (_v0, count) {
		var start = _v0.a;
		var end = _v0.b;
		return A3($gampleman$elm_visualization$Statistics$ticks, start, end, count);
	});
var $gampleman$elm_visualization$Scale$linear = F2(
	function (range_, domain_) {
		return {H: $gampleman$elm_visualization$Scale$Linear$convert, cz: domain_, b_: $gampleman$elm_visualization$Scale$Linear$invert, by: $gampleman$elm_visualization$Scale$Linear$nice, w: range_, a9: $gampleman$elm_visualization$Scale$Linear$rangeExtent, dw: $gampleman$elm_visualization$Scale$Linear$tickFormat, dx: $gampleman$elm_visualization$Scale$Linear$ticks};
	});
var $elm_community$typed_svg$TypedSvg$rect = $elm_community$typed_svg$TypedSvg$Core$node('rect');
var $author$project$BarChart$roundUpOf = F2(
	function (m, n) {
		var rem = m % n;
		var l = (n / m) | 0;
		return (rem > 0) ? ((l + 1) * m) : (l * m);
	});
var $elm_community$typed_svg$TypedSvg$svg = $elm_community$typed_svg$TypedSvg$Core$node('svg');
var $gampleman$elm_visualization$Axis$TickCount = function (a) {
	return {$: 2, a: a};
};
var $gampleman$elm_visualization$Axis$tickCount = $gampleman$elm_visualization$Axis$TickCount;
var $gampleman$elm_visualization$Scale$toRenderable = F2(
	function (toString, _v0) {
		var scale = _v0;
		return {
			H: F3(
				function (dmn, rng, value) {
					return A3(scale.H, dmn, rng, value) + (A2($elm$core$Basics$max, scale.cs - 1, 0) / 2);
				}),
			cz: scale.cz,
			w: scale.w,
			a9: F2(
				function (_v1, rng) {
					return rng;
				}),
			dw: F2(
				function (_v2, _v3) {
					return toString;
				}),
			dx: F2(
				function (dmn, _v4) {
					return dmn;
				})
		};
	});
var $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString = function (xform) {
	var tr = F2(
		function (name, args) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						'(',
						A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, args)),
						')'
					]));
		});
	switch (xform.$) {
		case 0:
			var a = xform.a;
			var b = xform.b;
			var c = xform.c;
			var d = xform.d;
			var e = xform.e;
			var f = xform.f;
			return A2(
				tr,
				'matrix',
				_List_fromArray(
					[a, b, c, d, e, f]));
		case 1:
			var a = xform.a;
			var x = xform.b;
			var y = xform.c;
			return A2(
				tr,
				'rotate',
				_List_fromArray(
					[a, x, y]));
		case 2:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'scale',
				_List_fromArray(
					[x, y]));
		case 3:
			var x = xform.a;
			return A2(
				tr,
				'skewX',
				_List_fromArray(
					[x]));
		case 4:
			var y = xform.a;
			return A2(
				tr,
				'skewY',
				_List_fromArray(
					[y]));
		default:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'translate',
				_List_fromArray(
					[x, y]));
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$transform = function (transforms) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'transform',
		A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString, transforms)));
};
var $elm_community$typed_svg$TypedSvg$Attributes$viewBox = F4(
	function (minX, minY, vWidth, vHeight) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$attribute,
			'viewBox',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromFloat,
					_List_fromArray(
						[minX, minY, vWidth, vHeight]))));
	});
var $avh4$elm_color$Color$white = A4($avh4$elm_color$Color$RgbaSpace, 255 / 255, 255 / 255, 255 / 255, 1.0);
var $elm_community$typed_svg$TypedSvg$Attributes$width = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'width',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$width = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$width(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$x = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$BarChart$view = F2(
	function (data, model) {
		var values = A2($elm$core$List$map, $elm$core$Tuple$second, data);
		var rate = A3($elm$core$Basics$clamp, 0.0, 1.0, model.aV / model.bX);
		var maxCount = A2(
			$author$project$BarChart$roundUpOf,
			50,
			A2(
				$elm$core$Maybe$withDefault,
				100,
				$elm$core$List$maximum(
					A2($elm$core$List$map, $elm$core$Tuple$second, data))));
		var yScale = A2(
			$gampleman$elm_visualization$Scale$linear,
			_Utils_Tuple2((model.ai - model.al) - 10, 0),
			_Utils_Tuple2(0, maxCount));
		var labels = A2($elm$core$List$map, $elm$core$Tuple$first, data);
		var xScale = A3(
			$gampleman$elm_visualization$Scale$band,
			$gampleman$elm_visualization$Scale$defaultBandConfig,
			_Utils_Tuple2(0, model.aS - model.al),
			labels);
		return A2(
			$elm_community$typed_svg$TypedSvg$svg,
			_List_fromArray(
				[
					A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, model.aS, model.ai),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(model.aS),
					$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(model.ai)
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(model.aS),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(model.ai),
							$elm_community$typed_svg$TypedSvg$Attributes$fill(
							$elm_community$typed_svg$TypedSvg$Types$Fill($avh4$elm_color$Color$white))
						]),
					_List_Nil),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, model.al, 10)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var label = _v0.a;
							var value = _v0.b;
							return A2(
								$elm_community$typed_svg$TypedSvg$rect,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
										A2($gampleman$elm_visualization$Scale$convert, xScale, label)),
										$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
										A2($gampleman$elm_visualization$Scale$convert, yScale, rate * value)),
										$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
										$gampleman$elm_visualization$Scale$bandwidth(xScale)),
										$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(
										((model.ai - model.al) - 10) - A2($gampleman$elm_visualization$Scale$convert, yScale, rate * value)),
										$elm_community$typed_svg$TypedSvg$Attributes$fill(
										$elm_community$typed_svg$TypedSvg$Types$Fill($avh4$elm_color$Color$green))
									]),
								_List_Nil);
						},
						data)),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, model.al, model.ai - model.al)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$bottom,
							_List_Nil,
							A2($gampleman$elm_visualization$Scale$toRenderable, $elm$core$Basics$identity, xScale))
						])),
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, model.al, 10)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$gampleman$elm_visualization$Axis$left,
							_List_fromArray(
								[
									$gampleman$elm_visualization$Axis$tickCount(10)
								]),
							yScale)
						]))
				]));
	});
var $author$project$PieChart$PieSegment = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm_community$typed_svg$TypedSvg$Types$Rotate = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$core$Basics$acos = _Basics_acos;
var $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc = function (a) {
	return {$: 3, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$arcTo = $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$LargestArc = 1;
var $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc = 1;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$SmallestArc = 0;
var $folkertdev$one_true_path_experiment$LowLevel$Command$smallestArc = 0;
var $gampleman$elm_visualization$Shape$Pie$boolToArc = function (b) {
	return b ? $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc : $folkertdev$one_true_path_experiment$LowLevel$Command$smallestArc;
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$Clockwise = 0;
var $folkertdev$one_true_path_experiment$LowLevel$Command$clockwise = 0;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$CounterClockwise = 1;
var $folkertdev$one_true_path_experiment$LowLevel$Command$counterClockwise = 1;
var $gampleman$elm_visualization$Shape$Pie$boolToDirection = function (b) {
	return b ? $folkertdev$one_true_path_experiment$LowLevel$Command$counterClockwise : $folkertdev$one_true_path_experiment$LowLevel$Command$clockwise;
};
var $folkertdev$one_true_path_experiment$SubPath$Empty = {$: 1};
var $folkertdev$one_true_path_experiment$SubPath$empty = $folkertdev$one_true_path_experiment$SubPath$Empty;
var $gampleman$elm_visualization$Shape$Pie$epsilon = 1.0e-12;
var $elm$core$Basics$truncate = _Basics_truncate;
var $gampleman$elm_visualization$Shape$Pie$mod = F2(
	function (a, b) {
		var frac = a / b;
		return (frac - (frac | 0)) * b;
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$MoveTo = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$SubPath$SubPath = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_deque$Deque$Deque = $elm$core$Basics$identity;
var $folkertdev$elm_deque$Internal$rebalance = function (deque) {
	var sizeF = deque.C;
	var sizeR = deque.D;
	var front = deque.N;
	var rear = deque.O;
	var size1 = ((sizeF + sizeR) / 2) | 0;
	var size2 = (sizeF + sizeR) - size1;
	var balanceConstant = 4;
	if ((sizeF + sizeR) < 2) {
		return deque;
	} else {
		if (_Utils_cmp(sizeF, (balanceConstant * sizeR) + 1) > 0) {
			var newRear = _Utils_ap(
				rear,
				$elm$core$List$reverse(
					A2($elm$core$List$drop, size1, front)));
			var newFront = A2($elm$core$List$take, size1, front);
			return {N: newFront, O: newRear, C: size1, D: size2};
		} else {
			if (_Utils_cmp(sizeR, (balanceConstant * sizeF) + 1) > 0) {
				var newRear = A2($elm$core$List$take, size1, rear);
				var newFront = _Utils_ap(
					front,
					$elm$core$List$reverse(
						A2($elm$core$List$drop, size1, rear)));
				return {N: newFront, O: newRear, C: size1, D: size2};
			} else {
				return deque;
			}
		}
	}
};
var $folkertdev$elm_deque$Internal$fromList = function (list) {
	return $folkertdev$elm_deque$Internal$rebalance(
		{
			N: list,
			O: _List_Nil,
			C: $elm$core$List$length(list),
			D: 0
		});
};
var $folkertdev$elm_deque$Deque$fromList = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $folkertdev$elm_deque$Internal$fromList);
var $folkertdev$one_true_path_experiment$SubPath$with = F2(
	function (moveto, drawtos) {
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			{
				d_: $folkertdev$elm_deque$Deque$fromList(drawtos),
				eE: moveto
			});
	});
var $gampleman$elm_visualization$Shape$Pie$arc_ = F6(
	function (x, y, radius, a0, a1, ccw) {
		var tau = 2 * $elm$core$Basics$pi;
		var r = $elm$core$Basics$abs(radius);
		var dy = r * $elm$core$Basics$sin(a0);
		var y0_ = y + dy;
		var dx = r * $elm$core$Basics$cos(a0);
		var x0_ = x + dx;
		var origin = $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
			_Utils_Tuple2(x0_, y0_));
		var da = ccw ? (a0 - a1) : (a1 - a0);
		var cw = $gampleman$elm_visualization$Shape$Pie$boolToDirection(!ccw);
		if (!r) {
			return $folkertdev$one_true_path_experiment$SubPath$empty;
		} else {
			if (_Utils_cmp(da, tau - $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
				return A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					origin,
					_List_fromArray(
						[
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									cq: $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc,
									cy: cw,
									aE: _Utils_Tuple2(r, r),
									R: _Utils_Tuple2(x - dx, y - dy),
									at: 0
								}
								])),
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									cq: $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc,
									cy: cw,
									aE: _Utils_Tuple2(r, r),
									R: _Utils_Tuple2(x0_, y0_),
									at: 0
								}
								]))
						]));
			} else {
				var da_ = (da < 0) ? (A2($gampleman$elm_visualization$Shape$Pie$mod, da, tau) + tau) : da;
				return A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					origin,
					_List_fromArray(
						[
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									cq: $gampleman$elm_visualization$Shape$Pie$boolToArc(
										_Utils_cmp(da_, $elm$core$Basics$pi) > -1),
									cy: cw,
									aE: _Utils_Tuple2(r, r),
									R: _Utils_Tuple2(
										x + (r * $elm$core$Basics$cos(a1)),
										y + (r * $elm$core$Basics$sin(a1))),
									at: 0
								}
								]))
						]));
			}
		}
	});
var $elm$core$Basics$atan2 = _Basics_atan2;
var $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath = {$: 4};
var $folkertdev$one_true_path_experiment$LowLevel$Command$closePath = $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath;
var $folkertdev$elm_deque$Internal$empty = {N: _List_Nil, O: _List_Nil, C: 0, D: 0};
var $folkertdev$elm_deque$Internal$popBack = function (deque) {
	var front = deque.N;
	var rear = deque.O;
	var _v0 = _Utils_Tuple2(front, rear);
	if (!_v0.b.b) {
		if (!_v0.a.b) {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
		} else {
			if (!_v0.a.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(x),
					$folkertdev$elm_deque$Internal$empty);
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
			}
		}
	} else {
		var _v2 = _v0.b;
		var r = _v2.a;
		var rs = _v2.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(r),
			$folkertdev$elm_deque$Internal$rebalance(
				{N: deque.N, O: rs, C: deque.C, D: deque.D - 1}));
	}
};
var $folkertdev$elm_deque$Deque$unwrap = function (_v0) {
	var boundedDeque = _v0;
	return boundedDeque;
};
var $folkertdev$elm_deque$Deque$popBack = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Tuple$mapSecond($elm$core$Basics$identity),
		$folkertdev$elm_deque$Internal$popBack),
	$folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$elm_deque$Deque$mapAbstract = F2(
	function (f, _v0) {
		var _abstract = _v0;
		return f(_abstract);
	});
var $folkertdev$elm_deque$Deque$pushBack = F2(
	function (elem, _v0) {
		var deque = _v0;
		return A2(
			$folkertdev$elm_deque$Deque$mapAbstract,
			$folkertdev$elm_deque$Internal$rebalance,
			{
				N: deque.N,
				O: A2($elm$core$List$cons, elem, deque.O),
				C: deque.C,
				D: deque.D + 1
			});
	});
var $folkertdev$one_true_path_experiment$SubPath$close = function (subpath) {
	if (subpath.$ === 1) {
		return $folkertdev$one_true_path_experiment$SubPath$Empty;
	} else {
		var moveto = subpath.a.eE;
		var drawtos = subpath.a.d_;
		var _v1 = $folkertdev$elm_deque$Deque$popBack(drawtos);
		if ((!_v1.a.$) && (_v1.a.a.$ === 4)) {
			var _v2 = _v1.a.a;
			var preceding = _v1.b;
			return subpath;
		} else {
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				{
					d_: A2($folkertdev$elm_deque$Deque$pushBack, $folkertdev$one_true_path_experiment$LowLevel$Command$closePath, drawtos),
					eE: moveto
				});
		}
	}
};
var $folkertdev$one_true_path_experiment$SubPath$firstPoint = function (_v0) {
	var moveto = _v0.eE;
	var p = moveto;
	return p;
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$lineTo = $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo;
var $folkertdev$one_true_path_experiment$SubPath$map2 = F3(
	function (f, sub1, sub2) {
		var _v0 = _Utils_Tuple2(sub1, sub2);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $folkertdev$one_true_path_experiment$SubPath$Empty;
			} else {
				var _v3 = _v0.a;
				var subpath = _v0.b;
				return subpath;
			}
		} else {
			if (_v0.b.$ === 1) {
				var subpath = _v0.a;
				var _v4 = _v0.b;
				return subpath;
			} else {
				var a = _v0.a.a;
				var b = _v0.b.a;
				return A2(f, a, b);
			}
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$pushBack = F2(
	function (drawto, data) {
		return _Utils_update(
			data,
			{
				d_: A2($folkertdev$elm_deque$Deque$pushBack, drawto, data.d_)
			});
	});
var $folkertdev$elm_deque$Internal$length = function (deque) {
	return deque.C + deque.D;
};
var $folkertdev$elm_deque$Internal$isEmpty = function (deque) {
	return !$folkertdev$elm_deque$Internal$length(deque);
};
var $folkertdev$elm_deque$Deque$isEmpty = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$isEmpty, $folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$elm_deque$Deque$append = F2(
	function (p, q) {
		var x = p;
		var y = q;
		return $folkertdev$elm_deque$Deque$isEmpty(p) ? q : ($folkertdev$elm_deque$Deque$isEmpty(q) ? p : {
			N: _Utils_ap(
				x.N,
				$elm$core$List$reverse(x.O)),
			O: $elm$core$List$reverse(
				_Utils_ap(
					y.N,
					$elm$core$List$reverse(y.O))),
			C: x.C + x.D,
			D: y.C + y.D
		});
	});
var $folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate = F2(
	function (a, b) {
		return _Utils_update(
			a,
			{
				d_: A2($folkertdev$elm_deque$Deque$append, a.d_, b.d_)
			});
	});
var $folkertdev$one_true_path_experiment$SubPath$connect = function () {
	var helper = F2(
		function (right, left) {
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate,
					A2(
						$folkertdev$one_true_path_experiment$SubPath$pushBack,
						$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(
							_List_fromArray(
								[
									$folkertdev$one_true_path_experiment$SubPath$firstPoint(right)
								])),
						left),
					right));
		});
	return $folkertdev$one_true_path_experiment$SubPath$map2(helper);
}();
var $gampleman$elm_visualization$Shape$Pie$cornerTangents = F7(
	function (x0, y0, x1, y1, r1, rc, cw) {
		var y01 = y0 - y1;
		var x01 = x0 - x1;
		var r = r1 - rc;
		var lo = (cw ? rc : (-rc)) / $elm$core$Basics$sqrt(
			A2($elm$core$Basics$pow, x01, 2) + A2($elm$core$Basics$pow, y01, 2));
		var ox = lo * y01;
		var x10 = x1 + ox;
		var x11 = x0 + ox;
		var x00 = (x11 + x10) / 2;
		var oy = (-lo) * x01;
		var y10 = y1 + oy;
		var y11 = y0 + oy;
		var y00 = (y11 + y10) / 2;
		var dy = y10 - y11;
		var dx = x10 - x11;
		var dd = (x11 * y10) - (x10 * y11);
		var d2 = A2($elm$core$Basics$pow, dx, 2) + A2($elm$core$Basics$pow, dy, 2);
		var d = ((dy < 0) ? (-1) : 1) * $elm$core$Basics$sqrt(
			A2(
				$elm$core$Basics$max,
				0,
				(A2($elm$core$Basics$pow, r, 2) * d2) - A2($elm$core$Basics$pow, dd, 2)));
		var cy1 = (((-dd) * dx) + (dy * d)) / d2;
		var dy1 = cy1 - y00;
		var cy0 = (((-dd) * dx) - (dy * d)) / d2;
		var dy0 = cy0 - y00;
		var cx1 = ((dd * dy) + (dx * d)) / d2;
		var dx1 = cx1 - x00;
		var cx0 = ((dd * dy) - (dx * d)) / d2;
		var dx0 = cx0 - x00;
		var _v0 = (_Utils_cmp(
			A2($elm$core$Basics$pow, dx0, 2) + A2($elm$core$Basics$pow, dy0, 2),
			A2($elm$core$Basics$pow, dx1, 2) + A2($elm$core$Basics$pow, dy1, 2)) > 0) ? _Utils_Tuple2(cx1, cy1) : _Utils_Tuple2(cx0, cy0);
		var fcx = _v0.a;
		var fxy = _v0.b;
		return {y: fcx, z: fxy, X: -ox, as: fcx * ((r1 / r) - 1), Y: -oy, au: fxy * ((r1 / r) - 1)};
	});
var $gampleman$elm_visualization$Shape$Pie$intersect = F8(
	function (x0, y0, x1, y1, x2, y2, x3, y3) {
		var y32 = y3 - y2;
		var y10 = y1 - y0;
		var x32 = x3 - x2;
		var x10 = x1 - x0;
		var t = ((x32 * (y0 - y2)) - (y32 * (x0 - x2))) / ((y32 * x10) - (x32 * y10));
		return _Utils_Tuple2(x0 + (t * x10), y0 + (t * y10));
	});
var $ianmackenzie$elm_geometry$Vector2d$components = function (_v0) {
	var components_ = _v0;
	return components_;
};
var $ianmackenzie$elm_geometry$Geometry$Types$Vector2d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Vector2d$fromComponents = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Vector2d$difference = F2(
	function (firstVector, secondVector) {
		var _v0 = $ianmackenzie$elm_geometry$Vector2d$components(secondVector);
		var x2 = _v0.a;
		var y2 = _v0.b;
		var _v1 = $ianmackenzie$elm_geometry$Vector2d$components(firstVector);
		var x1 = _v1.a;
		var y1 = _v1.b;
		return $ianmackenzie$elm_geometry$Vector2d$fromComponents(
			_Utils_Tuple2(x1 - x2, y1 - y2));
	});
var $folkertdev$elm_deque$Internal$foldl = F3(
	function (f, initial, deque) {
		return function (initial_) {
			return A3($elm$core$List$foldr, f, initial_, deque.O);
		}(
			A3($elm$core$List$foldl, f, initial, deque.N));
	});
var $folkertdev$elm_deque$Deque$foldl = F2(
	function (f, initial) {
		return A2(
			$elm$core$Basics$composeL,
			A2($folkertdev$elm_deque$Internal$foldl, f, initial),
			$folkertdev$elm_deque$Deque$unwrap);
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$updateCursorState = F2(
	function (drawto, state) {
		var noControlPoint = function (currentState) {
			return _Utils_update(
				currentState,
				{s: $elm$core$Maybe$Nothing});
		};
		var maybeUpdateCursor = function (coordinate) {
			return _Utils_update(
				state,
				{
					i: A2($elm$core$Maybe$withDefault, state.i, coordinate)
				});
		};
		var _v0 = state.i;
		var cursorX = _v0.a;
		var cursorY = _v0.b;
		switch (drawto.$) {
			case 0:
				var coordinates = drawto.a;
				return noControlPoint(
					maybeUpdateCursor(
						$elm_community$list_extra$List$Extra$last(coordinates)));
			case 1:
				var coordinates = drawto.a;
				var _v2 = $elm_community$list_extra$List$Extra$last(coordinates);
				if (_v2.$ === 1) {
					return state;
				} else {
					var _v3 = _v2.a;
					var control1 = _v3.a;
					var control2 = _v3.b;
					var target = _v3.c;
					return _Utils_update(
						state,
						{
							i: target,
							s: $elm$core$Maybe$Just(control2)
						});
				}
			case 2:
				var coordinates = drawto.a;
				var _v4 = $elm_community$list_extra$List$Extra$last(coordinates);
				if (_v4.$ === 1) {
					return state;
				} else {
					var _v5 = _v4.a;
					var control = _v5.a;
					var target = _v5.b;
					return _Utils_update(
						state,
						{
							i: target,
							s: $elm$core$Maybe$Just(control)
						});
				}
			case 3:
				var _arguments = drawto.a;
				return noControlPoint(
					maybeUpdateCursor(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.R;
							},
							$elm_community$list_extra$List$Extra$last(_arguments))));
			default:
				return noControlPoint(state);
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$finalCursorState = function (_v0) {
	var moveto = _v0.eE;
	var drawtos = _v0.d_;
	var _v1 = moveto;
	var start = _v1;
	var initial = {i: start, s: $elm$core$Maybe$Nothing, dt: start};
	return A3($folkertdev$elm_deque$Deque$foldl, $folkertdev$one_true_path_experiment$LowLevel$Command$updateCursorState, initial, drawtos);
};
var $folkertdev$one_true_path_experiment$SubPath$finalPoint = A2(
	$elm$core$Basics$composeR,
	$folkertdev$one_true_path_experiment$SubPath$finalCursorState,
	function ($) {
		return $.i;
	});
var $folkertdev$elm_deque$Internal$map = F2(
	function (f, deque) {
		return {
			N: A2($elm$core$List$map, f, deque.N),
			O: A2($elm$core$List$map, f, deque.O),
			C: deque.C,
			D: deque.D
		};
	});
var $folkertdev$elm_deque$Deque$map = function (f) {
	return $folkertdev$elm_deque$Deque$mapAbstract(
		$folkertdev$elm_deque$Internal$map(f));
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo = function (a) {
	return {$: 2, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple2 = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple2(
			f(a),
			f(b));
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple3 = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			f(a),
			f(b),
			f(c));
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapCoordinateDrawTo = F2(
	function (f, drawto) {
		switch (drawto.$) {
			case 0:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(
					A2($elm$core$List$map, f, coordinates));
			case 1:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(
					A2(
						$elm$core$List$map,
						$folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple3(f),
						coordinates));
			case 2:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(
					A2(
						$elm$core$List$map,
						$folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple2(f),
						coordinates));
			case 3:
				var _arguments = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(
					A2(
						$elm$core$List$map,
						function (argument) {
							return _Utils_update(
								argument,
								{
									R: f(argument.R)
								});
						},
						_arguments));
			default:
				return $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath;
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$mapCoordinateInstructions = F2(
	function (f, _v0) {
		var moveto = _v0.eE;
		var drawtos = _v0.d_;
		var coordinate = moveto;
		return {
			d_: A2(
				$folkertdev$elm_deque$Deque$map,
				$folkertdev$one_true_path_experiment$LowLevel$Command$mapCoordinateDrawTo(f),
				drawtos),
			eE: f(coordinate)
		};
	});
var $ianmackenzie$elm_geometry$Vector2d$sum = F2(
	function (firstVector, secondVector) {
		var _v0 = $ianmackenzie$elm_geometry$Vector2d$components(secondVector);
		var x2 = _v0.a;
		var y2 = _v0.b;
		var _v1 = $ianmackenzie$elm_geometry$Vector2d$components(firstVector);
		var x1 = _v1.a;
		var y1 = _v1.b;
		return $ianmackenzie$elm_geometry$Vector2d$fromComponents(
			_Utils_Tuple2(x1 + x2, y1 + y2));
	});
var $folkertdev$one_true_path_experiment$SubPath$continue = function () {
	var helper = F2(
		function (right, left) {
			var distance = A2(
				$ianmackenzie$elm_geometry$Vector2d$difference,
				$ianmackenzie$elm_geometry$Vector2d$fromComponents(
					$folkertdev$one_true_path_experiment$SubPath$finalPoint(left)),
				$ianmackenzie$elm_geometry$Vector2d$fromComponents(
					$folkertdev$one_true_path_experiment$SubPath$firstPoint(right)));
			var mapper = A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$ianmackenzie$elm_geometry$Vector2d$components,
					$ianmackenzie$elm_geometry$Vector2d$sum(distance)),
				$ianmackenzie$elm_geometry$Vector2d$fromComponents);
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate,
					left,
					A2($folkertdev$one_true_path_experiment$SubPath$mapCoordinateInstructions, mapper, right)));
		});
	return $folkertdev$one_true_path_experiment$SubPath$map2(helper);
}();
var $gampleman$elm_visualization$Shape$Pie$makeArc = F6(
	function (x, y, radius, a0, a1, ccw) {
		return $folkertdev$one_true_path_experiment$SubPath$continue(
			A6($gampleman$elm_visualization$Shape$Pie$arc_, x, y, radius, a0, a1, ccw));
	});
var $elm$core$Basics$asin = _Basics_asin;
var $gampleman$elm_visualization$Shape$Pie$myAsin = function (x) {
	return (x >= 1) ? ($elm$core$Basics$pi / 2) : ((_Utils_cmp(x, -1) < 1) ? ((-$elm$core$Basics$pi) / 2) : $elm$core$Basics$asin(x));
};
var $gampleman$elm_visualization$Shape$Pie$arc = function (arcData) {
	var a1 = arcData.f9 - ($elm$core$Basics$pi / 2);
	var a0 = arcData.bE - ($elm$core$Basics$pi / 2);
	var cw = _Utils_cmp(a1, a0) > 0;
	var da = $elm$core$Basics$abs(a1 - a0);
	var _v0 = (_Utils_cmp(arcData.cK, arcData.c1) > 0) ? _Utils_Tuple2(arcData.c1, arcData.cK) : _Utils_Tuple2(arcData.cK, arcData.c1);
	var r0 = _v0.a;
	var r1 = _v0.b;
	var path = function () {
		if (_Utils_cmp(r1, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) {
			return _List_fromArray(
				[
					$folkertdev$one_true_path_experiment$SubPath$close(
					A2(
						$folkertdev$one_true_path_experiment$SubPath$with,
						$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
							_Utils_Tuple2(0, 0)),
						_List_Nil))
				]);
		} else {
			if (_Utils_cmp(da, (2 * $elm$core$Basics$pi) - $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
				var p = A7(
					$gampleman$elm_visualization$Shape$Pie$makeArc,
					0,
					0,
					r1,
					a0,
					a1,
					!cw,
					A2(
						$folkertdev$one_true_path_experiment$SubPath$with,
						$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
							_Utils_Tuple2(
								r1 * $elm$core$Basics$cos(a0),
								r1 * $elm$core$Basics$sin(a0))),
						_List_Nil));
				return (_Utils_cmp(r0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? _List_fromArray(
					[
						p,
						$folkertdev$one_true_path_experiment$SubPath$close(
						A7(
							$gampleman$elm_visualization$Shape$Pie$makeArc,
							0,
							0,
							r0,
							a1,
							a0,
							cw,
							A2(
								$folkertdev$one_true_path_experiment$SubPath$with,
								$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
									_Utils_Tuple2(
										r0 * $elm$core$Basics$cos(a1),
										r0 * $elm$core$Basics$sin(a1))),
								_List_Nil)))
					]) : _List_fromArray(
					[
						$folkertdev$one_true_path_experiment$SubPath$close(p)
					]);
			} else {
				var rc = A2(
					$elm$core$Basics$min,
					$elm$core$Basics$abs(r1 - r0) / 2,
					arcData.cw);
				var ap = arcData.c2 / 2;
				var rp = (_Utils_cmp(ap, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? ((arcData.c3 > 0) ? arcData.c3 : $elm$core$Basics$sqrt(
					A2($elm$core$Basics$pow, r0, 2) + A2($elm$core$Basics$pow, r1, 2))) : 0;
				var p0 = $gampleman$elm_visualization$Shape$Pie$myAsin(
					(rp / r0) * $elm$core$Basics$sin(ap));
				var p1 = $gampleman$elm_visualization$Shape$Pie$myAsin(
					(rp / r1) * $elm$core$Basics$sin(ap));
				var _v1 = (_Utils_cmp(rp, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? ((_Utils_cmp(da - (p1 * 2), $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? (cw ? _Utils_Tuple3(a0 + p1, a1 - p1, da - (p1 * 2)) : _Utils_Tuple3(a0 - p1, a1 + p1, da - (p1 * 2))) : _Utils_Tuple3((a0 + a1) / 2, (a0 + a1) / 2, 0)) : _Utils_Tuple3(a0, a1, da);
				var a01 = _v1.a;
				var a11 = _v1.b;
				var da1 = _v1.c;
				var x01 = r1 * $elm$core$Basics$cos(a01);
				var y01 = r1 * $elm$core$Basics$sin(a01);
				var x11 = r1 * $elm$core$Basics$cos(a11);
				var y11 = r1 * $elm$core$Basics$sin(a11);
				var _v2 = (_Utils_cmp(rp, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? ((_Utils_cmp(da - (p0 * 2), $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? (cw ? _Utils_Tuple3(a0 + p0, a1 - p0, da - (p0 * 2)) : _Utils_Tuple3(a0 - p0, a1 + p0, da - (p0 * 2))) : _Utils_Tuple3((a0 + a1) / 2, (a0 + a1) / 2, 0)) : _Utils_Tuple3(a0, a1, da);
				var a00 = _v2.a;
				var a10 = _v2.b;
				var da0 = _v2.c;
				var x00 = r0 * $elm$core$Basics$cos(a00);
				var y00 = r0 * $elm$core$Basics$sin(a00);
				var x10 = r0 * $elm$core$Basics$cos(a10);
				var y10 = r0 * $elm$core$Basics$sin(a10);
				var _v3 = (_Utils_cmp(da0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? A8($gampleman$elm_visualization$Shape$Pie$intersect, x01, y01, x00, y00, x11, y11, x10, y10) : _Utils_Tuple2(x10, y10);
				var ocx = _v3.a;
				var ocy = _v3.b;
				var lc = $elm$core$Basics$sqrt(
					A2($elm$core$Basics$pow, ocx, 2) + A2($elm$core$Basics$pow, ocy, 2));
				var _v4 = _Utils_Tuple2(x11 - ocx, y11 - ocy);
				var bx = _v4.a;
				var by = _v4.b;
				var _v5 = _Utils_Tuple2(x01 - ocx, y01 - ocy);
				var ax = _v5.a;
				var ay = _v5.b;
				var kc = 1 / $elm$core$Basics$sin(
					$elm$core$Basics$acos(
						((ax * bx) + (ay * by)) / ($elm$core$Basics$sqrt(
							A2($elm$core$Basics$pow, ax, 2) + A2($elm$core$Basics$pow, ay, 2)) * $elm$core$Basics$sqrt(
							A2($elm$core$Basics$pow, bx, 2) + A2($elm$core$Basics$pow, by, 2)))) / 2);
				var _v6 = ((_Utils_cmp(rc, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) && (_Utils_cmp(da, $elm$core$Basics$pi) < 0)) ? _Utils_Tuple2(
					A2($elm$core$Basics$min, rc, (r0 - lc) / (kc - 1)),
					A2($elm$core$Basics$min, rc, (r1 - lc) / (kc + 1))) : _Utils_Tuple2(rc, rc);
				var rc0 = _v6.a;
				var rc1 = _v6.b;
				var outerRing = function () {
					if (_Utils_cmp(da1, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) {
						return A2(
							$folkertdev$one_true_path_experiment$SubPath$with,
							$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
								_Utils_Tuple2(x01, y01)),
							_List_Nil);
					} else {
						if (_Utils_cmp(rc1, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
							var t1 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x11, y11, x10, y10, r1, rc1, cw);
							var t0 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x00, y00, x01, y01, r1, rc1, cw);
							var p = A2(
								$folkertdev$one_true_path_experiment$SubPath$with,
								$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
									_Utils_Tuple2(t0.y + t0.X, t0.z + t0.Y)),
								_List_Nil);
							return (_Utils_cmp(rc1, rc) < 0) ? A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								t0.y,
								t0.z,
								rc1,
								A2($elm$core$Basics$atan2, t0.Y, t0.X),
								A2($elm$core$Basics$atan2, t1.Y, t1.X),
								!cw,
								p) : A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								t1.y,
								t1.z,
								rc1,
								A2($elm$core$Basics$atan2, t1.au, t1.as),
								A2($elm$core$Basics$atan2, t1.Y, t1.X),
								!cw,
								A7(
									$gampleman$elm_visualization$Shape$Pie$makeArc,
									0,
									0,
									r1,
									A2($elm$core$Basics$atan2, t0.z + t0.au, t0.y + t0.as),
									A2($elm$core$Basics$atan2, t1.z + t1.au, t1.y + t1.as),
									!cw,
									A7(
										$gampleman$elm_visualization$Shape$Pie$makeArc,
										t0.y,
										t0.z,
										rc1,
										A2($elm$core$Basics$atan2, t0.Y, t0.X),
										A2($elm$core$Basics$atan2, t0.au, t0.as),
										!cw,
										p)));
						} else {
							return A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								0,
								0,
								r1,
								a01,
								a11,
								!cw,
								A2(
									$folkertdev$one_true_path_experiment$SubPath$with,
									$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
										_Utils_Tuple2(x01, y01)),
									_List_Nil));
						}
					}
				}();
				if ((_Utils_cmp(r0, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) || (_Utils_cmp(da0, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1)) {
					return _List_fromArray(
						[
							$folkertdev$one_true_path_experiment$SubPath$close(
							A2(
								$folkertdev$one_true_path_experiment$SubPath$connect,
								A2(
									$folkertdev$one_true_path_experiment$SubPath$with,
									$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
										_Utils_Tuple2(x10, y10)),
									_List_Nil),
								outerRing))
						]);
				} else {
					if (_Utils_cmp(rc0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
						var t1 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x01, y01, x00, y00, r0, -rc0, cw);
						var t0 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x10, y10, x11, y11, r0, -rc0, cw);
						var p = A2(
							$folkertdev$one_true_path_experiment$SubPath$connect,
							A2(
								$folkertdev$one_true_path_experiment$SubPath$with,
								$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
									_Utils_Tuple2(t0.y + t0.X, t0.z + t0.Y)),
								_List_Nil),
							outerRing);
						return (_Utils_cmp(rc0, rc) < 0) ? _List_fromArray(
							[
								$folkertdev$one_true_path_experiment$SubPath$close(
								A7(
									$gampleman$elm_visualization$Shape$Pie$makeArc,
									t0.y,
									t0.z,
									rc0,
									A2($elm$core$Basics$atan2, t0.Y, t0.X),
									A2($elm$core$Basics$atan2, t1.Y, t1.X),
									!cw,
									p))
							]) : _List_fromArray(
							[
								$folkertdev$one_true_path_experiment$SubPath$close(
								A7(
									$gampleman$elm_visualization$Shape$Pie$makeArc,
									t1.y,
									t1.z,
									rc0,
									A2($elm$core$Basics$atan2, t1.au, t1.as),
									A2($elm$core$Basics$atan2, t1.Y, t1.X),
									!cw,
									A7(
										$gampleman$elm_visualization$Shape$Pie$makeArc,
										0,
										0,
										r0,
										A2($elm$core$Basics$atan2, t0.z + t0.au, t0.y + t0.as),
										A2($elm$core$Basics$atan2, t1.z + t1.au, t1.y + t1.as),
										cw,
										A7(
											$gampleman$elm_visualization$Shape$Pie$makeArc,
											t0.y,
											t0.z,
											rc0,
											A2($elm$core$Basics$atan2, t0.Y, t0.X),
											A2($elm$core$Basics$atan2, t0.au, t0.as),
											!cw,
											p))))
							]);
					} else {
						return _List_fromArray(
							[
								$folkertdev$one_true_path_experiment$SubPath$close(
								A2(
									$folkertdev$one_true_path_experiment$SubPath$connect,
									A6($gampleman$elm_visualization$Shape$Pie$arc_, 0, 0, r0, a10, a00, cw),
									outerRing))
							]);
					}
				}
			}
		}
	}();
	return path;
};
var $gampleman$elm_visualization$Shape$arc = $gampleman$elm_visualization$Shape$Pie$arc;
var $gampleman$elm_visualization$Shape$Pie$centroid = function (arcData) {
	var r = (arcData.cK + arcData.c1) / 2;
	var a = ((arcData.bE + arcData.f9) / 2) - ($elm$core$Basics$pi / 2);
	return _Utils_Tuple2(
		$elm$core$Basics$cos(a) * r,
		$elm$core$Basics$sin(a) * r);
};
var $gampleman$elm_visualization$Shape$centroid = $gampleman$elm_visualization$Shape$Pie$centroid;
var $author$project$PieChart$dataLabel = function (_v0) {
	var label = _v0.a;
	return label;
};
var $author$project$PieChart$dataValue = function (_v0) {
	var value = _v0.b;
	return value;
};
var $gampleman$elm_visualization$Shape$defaultPieConfig = {cw: 0, f9: 2 * $elm$core$Basics$pi, cK: 0, c1: 100, c2: 0, c3: 0, g4: $elm$core$Basics$compare, bE: 0, fx: $elm$core$Basics$identity};
var $folkertdev$elm_deque$Deque$empty = $folkertdev$elm_deque$Internal$empty;
var $folkertdev$one_true_path_experiment$LowLevel$Command$merge = F2(
	function (instruction1, instruction2) {
		var _v0 = _Utils_Tuple2(instruction1, instruction2);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				default:
					if (_v0.b.$ === 4) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath);
					} else {
						break _v0$5;
					}
			}
		}
		return $elm$core$Result$Err(
			_Utils_Tuple2(instruction1, instruction2));
	});
var $folkertdev$elm_deque$Internal$toList = function (deque) {
	return _Utils_ap(
		deque.N,
		$elm$core$List$reverse(deque.O));
};
var $folkertdev$elm_deque$Deque$toList = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$toList, $folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$one_true_path_experiment$SubPath$compressHelper = function (drawtos) {
	var folder = F2(
		function (instruction, _v3) {
			var previous = _v3.a;
			var accum = _v3.b;
			var _v2 = A2($folkertdev$one_true_path_experiment$LowLevel$Command$merge, previous, instruction);
			if (!_v2.$) {
				var merged = _v2.a;
				return _Utils_Tuple2(merged, accum);
			} else {
				return _Utils_Tuple2(
					instruction,
					A2($elm$core$List$cons, previous, accum));
			}
		});
	var _v0 = $folkertdev$elm_deque$Deque$toList(drawtos);
	if (!_v0.b) {
		return $folkertdev$elm_deque$Deque$empty;
	} else {
		var first = _v0.a;
		var rest = _v0.b;
		return $folkertdev$elm_deque$Deque$fromList(
			$elm$core$List$reverse(
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$core$List$cons, a, b);
				}(
					A3(
						$elm$core$List$foldl,
						folder,
						_Utils_Tuple2(first, _List_Nil),
						rest))));
	}
};
var $folkertdev$one_true_path_experiment$SubPath$compress = function (subpath) {
	if (subpath.$ === 1) {
		return $folkertdev$one_true_path_experiment$SubPath$Empty;
	} else {
		var data = subpath.a;
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			_Utils_update(
				data,
				{
					d_: $folkertdev$one_true_path_experiment$SubPath$compressHelper(data.d_)
				}));
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$DecimalPlaces = $elm$core$Basics$identity;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$SubPath$defaultConfig = {bV: $elm$core$Maybe$Nothing, b3: false};
var $folkertdev$one_true_path_experiment$SubPath$optionFolder = F2(
	function (option, config) {
		if (!option.$) {
			var n = option.a;
			return _Utils_update(
				config,
				{
					bV: $elm$core$Maybe$Just(n)
				});
		} else {
			return _Utils_update(
				config,
				{b3: true});
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$Absolute = 1;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath = {$: 8};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo = function (drawto) {
	switch (drawto.$) {
		case 0:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo, 1, coordinates);
		case 1:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo, 1, coordinates);
		case 2:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo, 1, coordinates);
		case 3:
			var _arguments = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc, 1, _arguments);
		default:
			return $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath;
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo = function (_v0) {
	var target = _v0;
	return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo, 1, target);
};
var $folkertdev$one_true_path_experiment$SubPath$toLowLevel = function (subpath) {
	if (subpath.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var moveto = subpath.a.eE;
		var drawtos = subpath.a.d_;
		return $elm$core$Maybe$Just(
			{
				d_: A2(
					$elm$core$List$map,
					$folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo,
					$folkertdev$elm_deque$Deque$toList(drawtos)),
				eE: $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo(moveto)
			});
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig = {bu: $elm$core$String$fromFloat};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo = F2(
	function (n, value) {
		if (!n) {
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(value));
		} else {
			var sign = (value < 0.0) ? '-' : '';
			var exp = A2($elm$core$Basics$pow, 10, n);
			var raised = $elm$core$Basics$abs(
				$elm$core$Basics$round(value * exp));
			var decimals = raised % exp;
			return (!decimals) ? _Utils_ap(
				sign,
				$elm$core$String$fromInt((raised / exp) | 0)) : (sign + ($elm$core$String$fromInt((raised / exp) | 0) + ('.' + $elm$core$String$fromInt(decimals))));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder = F2(
	function (option, config) {
		var n = option;
		return _Utils_update(
			config,
			{
				bu: $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo(n)
			});
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions = A2($elm$core$List$foldl, $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder, $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig);
var $folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty = function (command) {
	switch (command.$) {
		case 0:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 1:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 2:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 3:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 4:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 5:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 6:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 7:
			var mode = command.a;
			var _arguments = command.b;
			return $elm$core$List$isEmpty(_arguments);
		default:
			return false;
	}
};
var $elm$core$Char$toLower = _Char_toLower;
var $elm$core$Char$toUpper = _Char_toUpper;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter = F2(
	function (mode, character) {
		if (mode === 1) {
			return $elm$core$String$fromChar(
				$elm$core$Char$toUpper(character));
		} else {
			return $elm$core$String$fromChar(
				$elm$core$Char$toLower(character));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate = F2(
	function (config, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return config.bu(x) + (',' + config.bu(y));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		var c3 = _v0.c;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + (A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c3))));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags = function (_v0) {
	var arcFlag = _v0.a;
	var direction = _v0.b;
	var _v1 = _Utils_Tuple2(arcFlag, direction);
	if (_v1.a === 1) {
		if (!_v1.b) {
			var _v2 = _v1.a;
			var _v3 = _v1.b;
			return _Utils_Tuple2(1, 0);
		} else {
			var _v6 = _v1.a;
			var _v7 = _v1.b;
			return _Utils_Tuple2(1, 1);
		}
	} else {
		if (!_v1.b) {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return _Utils_Tuple2(0, 0);
		} else {
			var _v8 = _v1.a;
			var _v9 = _v1.b;
			return _Utils_Tuple2(0, 1);
		}
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument = F2(
	function (config, _v0) {
		var radii = _v0.aE;
		var xAxisRotate = _v0.at;
		var arcFlag = _v0.cq;
		var direction = _v0.cy;
		var target = _v0.R;
		var _v1 = $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags(
			_Utils_Tuple2(arcFlag, direction));
		var arc = _v1.a;
		var sweep = _v1.b;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, radii),
					$elm$core$String$fromFloat(xAxisRotate),
					$elm$core$String$fromInt(arc),
					$elm$core$String$fromInt(sweep),
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, target)
				]));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo = F2(
	function (config, command) {
		if ($folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty(command)) {
			return '';
		} else {
			switch (command.$) {
				case 0:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'L'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 1:
					var mode = command.a;
					var coordinates = command.b;
					return $elm$core$List$isEmpty(coordinates) ? '' : _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'H'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 2:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'V'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 3:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'C'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3(config),
								coordinates)));
				case 4:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'S'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 5:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'Q'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 6:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'T'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 7:
					var mode = command.a;
					var _arguments = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'A'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument(config),
								_arguments)));
				default:
					return 'Z';
			}
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo = F2(
	function (config, _v0) {
		var mode = _v0.a;
		var coordinate = _v0.b;
		if (mode === 1) {
			return 'M' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		} else {
			return 'm' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath = F2(
	function (config, _v0) {
		var moveto = _v0.eE;
		var drawtos = _v0.d_;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo, config, moveto) + (' ' + A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo(config),
				drawtos)));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith = F2(
	function (options, subpaths) {
		var config = $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions(options);
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath(config),
				subpaths));
	});
var $folkertdev$one_true_path_experiment$SubPath$toStringWith = F2(
	function (options, subpath) {
		var config = A3($elm$core$List$foldl, $folkertdev$one_true_path_experiment$SubPath$optionFolder, $folkertdev$one_true_path_experiment$SubPath$defaultConfig, options);
		var lowLevelOptions = function () {
			var _v0 = config.bV;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var n = _v0.a;
				return _List_fromArray(
					[
						$folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces(n)
					]);
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith(lowLevelOptions),
					$elm$core$List$singleton),
				$folkertdev$one_true_path_experiment$SubPath$toLowLevel(
					(config.b3 ? $folkertdev$one_true_path_experiment$SubPath$compress : $elm$core$Basics$identity)(subpath))));
	});
var $folkertdev$one_true_path_experiment$SubPath$toString = function (subpath) {
	return A2($folkertdev$one_true_path_experiment$SubPath$toStringWith, _List_Nil, subpath);
};
var $folkertdev$one_true_path_experiment$Path$toString = A2(
	$elm$core$Basics$composeL,
	$elm$core$String$join(' '),
	$elm$core$List$map($folkertdev$one_true_path_experiment$SubPath$toString));
var $folkertdev$one_true_path_experiment$Path$element = F2(
	function (path, attributes) {
		return A2(
			$elm$svg$Svg$path,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$d(
					$folkertdev$one_true_path_experiment$Path$toString(path)),
				attributes),
			_List_Nil);
	});
var $elm$core$List$map3 = _List_map3;
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $gampleman$elm_visualization$Shape$Pie$pie = F2(
	function (settings, data) {
		var unsafeGet = F2(
			function (index, array) {
				unsafeGet:
				while (true) {
					var _v0 = A2($elm$core$Array$get, index, array);
					if (!_v0.$) {
						var v = _v0.a;
						return v;
					} else {
						var $temp$index = index,
							$temp$array = array;
						index = $temp$index;
						array = $temp$array;
						continue unsafeGet;
					}
				}
			});
		var summer = F2(
			function (a, b) {
				var v = settings.fx(a);
				return (v > 0) ? (v + b) : b;
			});
		var sum = A3($elm$core$List$foldr, summer, 0, data);
		var sortedIndices = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$map($elm$core$Tuple$first),
				$elm$core$List$sortWith(
					F2(
						function (_v2, _v3) {
							var a = _v2.b;
							var b = _v3.b;
							return A2(settings.g4, a, b);
						}))),
			$elm$core$List$indexedMap($elm$core$Tuple$pair));
		var dataArray = $elm$core$Array$fromList(data);
		var da = A2(
			$elm$core$Basics$min,
			2 * $elm$core$Basics$pi,
			A2($elm$core$Basics$max, (-2) * $elm$core$Basics$pi, settings.f9 - settings.bE));
		var p = A2(
			$elm$core$Basics$min,
			$elm$core$Basics$abs(da) / $elm$core$List$length(data),
			settings.c2);
		var pa = p * ((da < 0) ? (-1) : 1);
		var k = (!sum) ? 0 : ((da - ($elm$core$List$length(data) * pa)) / sum);
		var computeValue = F2(
			function (el, angle) {
				var value = settings.fx(el);
				return {
					cw: settings.cw,
					f9: (angle + ((value > 0) ? (value * k) : 0)) + pa,
					cK: settings.cK,
					c1: settings.c1,
					c2: p,
					c3: settings.c3,
					bE: angle
				};
			});
		var helper = F2(
			function (index, _v1) {
				var angle = _v1.a;
				var result = _v1.b;
				var r = A2(
					computeValue,
					A2(unsafeGet, index, dataArray),
					angle);
				return _Utils_Tuple2(
					r.f9,
					A3($elm$core$Dict$insert, index, r, result));
			});
		return $elm$core$Dict$values(
			A3(
				$elm$core$List$foldl,
				helper,
				_Utils_Tuple2(settings.bE, $elm$core$Dict$empty),
				sortedIndices(data)).b);
	});
var $gampleman$elm_visualization$Shape$pie = $gampleman$elm_visualization$Shape$Pie$pie;
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $author$project$PieChart$selectColor = F2(
	function (palette, idx) {
		return A2(
			$elm$core$Maybe$withDefault,
			$avh4$elm_color$Color$black,
			A2(
				$elm$core$Array$get,
				A2(
					$elm$core$Basics$modBy,
					$elm$core$Array$length(palette),
					idx),
				palette));
	});
var $elm_community$typed_svg$TypedSvg$Attributes$stroke = function (col) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'stroke',
		$avh4$elm_color$Color$toCssString(col));
};
var $elm_community$typed_svg$TypedSvg$text_ = $elm_community$typed_svg$TypedSvg$Core$node('text');
var $author$project$PieChart$viewPieChart = F4(
	function (_v0, endAngle, palette, data) {
		var w = _v0.a;
		var h = _v0.b;
		var pieConfig = _Utils_update(
			$gampleman$elm_visualization$Shape$defaultPieConfig,
			{
				f9: endAngle,
				c1: (w / 2) - 30,
				g4: F2(
					function (_v4, _v5) {
						return 0;
					})
			});
		var pieShapeWithLabel = A4(
			$elm$core$List$map3,
			$author$project$PieChart$PieSegment,
			A2($elm$core$List$map, $author$project$PieChart$dataLabel, data),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (idx, arc) {
						return A2(
							$folkertdev$one_true_path_experiment$Path$element,
							arc,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$fill(
									$elm_community$typed_svg$TypedSvg$Types$Fill(
										A2($author$project$PieChart$selectColor, palette, idx))),
									$elm_community$typed_svg$TypedSvg$Attributes$stroke($avh4$elm_color$Color$white)
								]));
					}),
				A2(
					$elm$core$List$map,
					$gampleman$elm_visualization$Shape$arc,
					A2(
						$gampleman$elm_visualization$Shape$pie,
						pieConfig,
						A2($elm$core$List$map, $author$project$PieChart$dataValue, data)))),
			A2(
				$elm$core$List$map,
				$gampleman$elm_visualization$Shape$centroid,
				A2(
					$gampleman$elm_visualization$Shape$pie,
					_Utils_update(
						pieConfig,
						{c1: pieConfig.c1 * 1.5}),
					A2($elm$core$List$map, $author$project$PieChart$dataValue, data))));
		return A2(
			$elm_community$typed_svg$TypedSvg$svg,
			_List_fromArray(
				[
					A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, w, h),
					$elm_community$typed_svg$TypedSvg$Attributes$width(
					$elm_community$typed_svg$TypedSvg$Types$Px(w)),
					$elm_community$typed_svg$TypedSvg$Attributes$height(
					$elm_community$typed_svg$TypedSvg$Types$Px(h))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$transform(
							_List_fromArray(
								[
									A2($elm_community$typed_svg$TypedSvg$Types$Translate, w / 2, h / 2)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (_v1) {
									var label = _v1.a;
									var pie = _v1.b;
									return A2(
										$elm_community$typed_svg$TypedSvg$g,
										_List_Nil,
										_List_fromArray(
											[pie]));
								},
								pieShapeWithLabel)),
							A2(
							$elm_community$typed_svg$TypedSvg$g,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (_v2) {
									var label = _v2.a;
									var _v3 = _v2.c;
									var x = _v3.a;
									var y = _v3.b;
									return A2(
										$elm_community$typed_svg$TypedSvg$g,
										_List_fromArray(
											[
												$elm_community$typed_svg$TypedSvg$Attributes$transform(
												_List_fromArray(
													[
														A3($elm_community$typed_svg$TypedSvg$Types$Rotate, 30, x, y)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$elm_community$typed_svg$TypedSvg$text_,
												_List_fromArray(
													[
														$elm_community$typed_svg$TypedSvg$Attributes$transform(
														_List_fromArray(
															[
																A2($elm_community$typed_svg$TypedSvg$Types$Translate, x, y)
															]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label)
													]))
											]));
								},
								pieShapeWithLabel))
						]))
				]));
	});
var $author$project$PieChart$viewChart = function (model) {
	var endAngle = $elm$core$Basics$degrees(model.av);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$PieChart$viewPieChart,
				_Utils_Tuple2(model.aS, model.ai),
				endAngle,
				model.c4,
				model.az)
			]));
};
var $author$project$PieChart$view = function (model) {
	return $author$project$PieChart$viewChart(model);
};
var $author$project$Page$Index$viewDashboard = function (model) {
	var _v0 = model.dO;
	if (!_v0.$) {
		var pieChartModel = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Page$Index$PieChartMsg,
			$author$project$PieChart$view(pieChartModel));
	} else {
		var barChartModel = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Page$Index$BarChartMsg,
			A2(
				$author$project$BarChart$view,
				$author$project$Env$history(model.bZ),
				barChartModel));
	}
};
var $author$project$Page$Index$view = function (model) {
	var todaysLearnedCount = $author$project$Env$todaysLearnedCount(model.bZ);
	var quizText = A2(
		$elm$core$Maybe$map,
		function (q) {
			return A2($author$project$Page$Index$truncateString, 104, q);
		},
		A2(
			$elm$core$Maybe$andThen,
			function (qr) {
				return $elm$core$Result$toMaybe(
					$author$project$WikiParser$normalize(qr.d3.de));
			},
			$author$project$Env$lastQuiz(model.bZ)));
	var passive_anchor_class = $elm$html$Html$Attributes$class('text-blue-500 hover:text-blue-800');
	var overlayDialog = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (_v4) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute top-0 bottom-0 w-full bg-white pt-12')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Page$Index$ConfigMsg,
								$author$project$Page$Config$view(model))
							]))
					]);
			},
			model.dR));
	var importUrl = A2(
		$elm$core$Maybe$map,
		function (qr) {
			return A3(
				$elm$url$Url$Builder$crossOrigin,
				$author$project$Env$origin(model.bZ),
				_List_fromArray(
					['memory-quiz']),
				A2(
					$elm$core$List$cons,
					A2($elm$url$Url$Builder$string, 'q', qr.d3.de),
					A2(
						$elm$core$List$map,
						function (tag) {
							return A2($elm$url$Url$Builder$string, 't', tag);
						},
						qr.fn)));
		},
		$author$project$Env$lastQuiz(model.bZ));
	var shareUrl = A3(
		$elm$core$Maybe$map2,
		F2(
			function (imUrl, quiz) {
				var body = '今日は\n\n' + (quiz + ('\n\nなど、' + ($elm$core$String$fromInt(
					$author$project$Env$todaysLearnedCount(model.bZ)) + '問学習しました!')));
				return A3(
					$elm$url$Url$Builder$crossOrigin,
					'https://twitter.com',
					_List_fromArray(
						['intent', 'tweet']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'hashtags', 'タノマナ'),
							A2($elm$url$Url$Builder$string, 'url', imUrl),
							A2($elm$url$Url$Builder$string, 'text', body)
						]));
			}),
		importUrl,
		quizText);
	var shareLink = A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$span(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gray-300')
				])),
		A2(
			$elm$core$Maybe$map,
			function (url) {
				return $elm$html$Html$a(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(url),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$class('text-blue-500')
						]));
			},
			shareUrl));
	var active_anchor_class = $elm$html$Html$Attributes$class('border-l border-t border-r rounded-t');
	var _v0 = function () {
		var _v1 = model.dO;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(active_anchor_class, passive_anchor_class);
		} else {
			return _Utils_Tuple2(passive_anchor_class, active_anchor_class);
		}
	}();
	var barchart_anchor_class = _v0.a;
	var piechart_anchor_class = _v0.b;
	var _v2 = function () {
		var _v3 = model.dO;
		if (_v3.$ === 1) {
			return _Utils_Tuple2(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('-mb-px mr-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mr-1')
					]));
		} else {
			return _Utils_Tuple2(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mr-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('-mb-px mr-1')
					]));
		}
	}();
	var historyViewAttr = _v2.a;
	var achievementViewAttr = _v2.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A3(
					$author$project$Page$Common$showNavBar,
					model.fc,
					$author$project$Page$Index$ToggleMenu,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$ImportQuizes)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('まとめて問題を作る(.rqzをとりこむ)')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://twitter.com/6cLzHLA5t6bJEww')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fab fa-twitter-square fa-lg text-blue-500 pr-1')
										]),
									_List_Nil),
									$elm$html$Html$text('新しい問題の通知を受け取る')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$Quizes)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('問題を管理する')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Page$Index$ShowConfigDialog)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('設定')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('doc.html')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('使い方を見る')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('../')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('他のゲーム')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-12 text-xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'今日は ' + ($elm$core$String$fromInt(todaysLearnedCount) + ' 問勉強しました。'))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex border-b')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							historyViewAttr,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$Events$preventDefaultOn,
											'click',
											$elm$json$Json$Decode$succeed(
												_Utils_Tuple2(
													$author$project$Page$Index$ShowChart('History'),
													true))),
											$elm$html$Html$Attributes$class('bg-white inline-block py-2 px-4 text-blue-700 font-semibold'),
											barchart_anchor_class,
											$elm$html$Html$Attributes$href('#')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('学習の記録')
										]))
								])),
							A2(
							$elm$html$Html$li,
							achievementViewAttr,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$Events$preventDefaultOn,
											'click',
											$elm$json$Json$Decode$succeed(
												_Utils_Tuple2(
													$author$project$Page$Index$ShowChart('Achievement'),
													true))),
											$elm$html$Html$Attributes$class('bg-white inline-block py-2 px-4 font-semibold text-blue-700'),
											piechart_anchor_class,
											$elm$html$Html$Attributes$href('#')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('成績')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Page$Index$viewDashboard(model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full flex justify-center pb-2')
						]),
					_List_fromArray(
						[
							shareLink(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-center underline mr-1')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('学習記録を共有する')
										])),
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fab fa-twitter-square fa-lg')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-center my-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-green-500 hover:bg-green-400 rounded-full'),
									$author$project$Route$href($author$project$Route$Learn)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('my-2 mx-8 inline-block text-xl text-white')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('スタート')
										]))
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Page$Index$TagChooserMsg,
					$author$project$Page$TagChooser$tagChooser(model.dv)),
					$author$project$Page$Index$buy_me_a_coffee(true)
				]),
			overlayDialog));
};
var $author$project$Page$Learn$ClickNextSession = {$: 2};
var $author$project$Page$Learn$ToggleMenu = {$: 19};
var $author$project$Page$Learn$sessionProgress = function (sess) {
	var total = $elm$core$List$length(sess.ce);
	var currentIndex = A3(
		$elm$core$Basics$composeR,
		$elm$core$List$length,
		$elm$core$Basics$add(1),
		sess.am);
	var progress = (currentIndex / total) * 100;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full bg-gray-400 rounded')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rounded h-2 bg-blue-600 text-xs text-black leading-none py-1 text-right pr-2'),
								A2(
								$elm$html$Html$Attributes$style,
								'width',
								$elm$core$String$fromFloat(progress) + '%')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Page$Learn$timerProgress = function (model) {
	var time = A2(
		$elm$core$Maybe$withDefault,
		0,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (t, s) {
					return t - s;
				}),
			model.dW,
			model.fj));
	var p = time / model.fr;
	var p_i = $elm$core$String$fromFloat(p * 100);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full relative')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shadow w-full bg-gray-400 rounded')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute h-2 rounded bg-green-400 text-xs text-black leading-none py-1 pr-2 text-right'),
								A2($elm$html$Html$Attributes$style, 'width', p_i + '%'),
								A2(
								$elm$html$Html$Attributes$style,
								'opacity',
								$elm$core$String$fromFloat(1.0 - p))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('absolute h-2 rounded bg-red-400 text-xs text-black leading-none py-1 pr-2 text-right'),
								A2($elm$html$Html$Attributes$style, 'width', p_i + '%'),
								A2(
								$elm$html$Html$Attributes$style,
								'opacity',
								$elm$core$String$fromFloat(p))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Page$Learn$Nop = {$: 0};
var $author$project$Page$Learn$answered = function (quiz) {
	switch (quiz.$) {
		case 0:
			return true;
		case 2:
			var answer = quiz.a;
			var options = quiz.b;
			return _Utils_eq(
				$elm$core$Set$size(answer),
				$elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq($elm$core$Maybe$Nothing),
						options.hr)));
		case 1:
			var answer = quiz.a;
			var options = quiz.b;
			return _Utils_eq(
				$elm$core$Set$size(answer),
				$elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq($elm$core$Maybe$Nothing),
						options.hr)));
		default:
			var answer = quiz.a;
			var input = quiz.b;
			return _Utils_eq(
				$elm$core$Set$size(answer),
				$elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq($elm$core$Maybe$Nothing),
						input)));
	}
};
var $author$project$SelectKeyboard$Select = function (a) {
	return {$: 0, a: a};
};
var $author$project$SelectKeyboard$visibilityAttribute = function (model) {
	return model.aL ? A2($elm$html$Html$Attributes$style, 'visibility', 'visible') : A2($elm$html$Html$Attributes$style, 'visibility', 'hidden');
};
var $author$project$SelectKeyboard$view = function (model) {
	var currentCandidates = $elm$core$List$head(model.ah);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$SelectKeyboard$visibilityAttribute(model)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-blue-200 shadow fixed bottom-0 left-0 right-0 px-4 pb-0 mb-0 h-64 text-gray-800 text-2xl bg-white overflow-y-scroll')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-row flex-wrap mt-2')
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$map(
									function (cand) {
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('rounded shadow text-left m-1 px-2 py-1 bg-white'),
													A2($elm$html$Html$Attributes$style, 'min-width', '2em'),
													$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
													function (_v0) {
														return $author$project$SelectKeyboard$Select(cand);
													})
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(cand)
												]));
									}),
								currentCandidates)))
					]))
			]));
};
var $author$project$Page$Learn$viewQuestion = F2(
	function (model, session) {
		var keyboardView = A2(
			$elm$html$Html$map,
			$author$project$Page$Learn$KeyboardMsg,
			A2(
				$elm$core$Maybe$withDefault,
				A2($elm$html$Html$div, _List_Nil, _List_Nil),
				A2($elm$core$Maybe$map, $author$project$SelectKeyboard$view, model.eq)));
		var currentPage = A2(
			$elm$core$Maybe$andThen,
			function (_v2) {
				var upcomingPages = _v2.S;
				return $elm$core$List$head(upcomingPages);
			},
			session);
		if (!currentPage.$) {
			var page = currentPage.a;
			var ready = A2($elm$core$List$all, $author$project$Page$Learn$answered, page.de.g1);
			var onNext = $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
				function (_v1) {
					return ready ? $author$project$Page$Learn$NextQuiz : $author$project$Page$Learn$Nop;
				});
			return _List_fromArray(
				[
					A3(
					$author$project$Page$Learn$viewQuiz,
					$elm$core$Maybe$Just(model.dV),
					model.fd,
					page.de),
					keyboardView,
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fixed rounded-full h-16 w-16 text-2xl shadow bg-blue-800 text-white right-0 bottom-0 mb-8 mr-8'),
							onNext,
							$elm$html$Html$Attributes$disabled(!ready)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-arrow-right')
								]),
							_List_Nil)
						]))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('no questions...')
				]);
		}
	});
var $author$project$Page$Learn$buy_me_a_coffee = function (shown) {
	return shown ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col w-full items-center mt-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mx-auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('https://www.buymeacoffee.com/run.run.learn')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=run.run.learn&button_colour=FFDD00&font_colour=000000&font_family=Cookie&outline_colour=000000&coffee_colour=ffffff')
									]),
								_List_Nil)
							]))
					]))
			])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $author$project$Page$Learn$SwitchBoost = F4(
	function (a, b, c, d) {
		return {$: 13, a: a, b: b, c: c, d: d};
	});
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Page$Learn$reviewStyle = function (record) {
	return record.dL ? $elm$html$Html$Attributes$class('boosted') : $elm$html$Html$Attributes$class('normal');
};
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Page$Learn$viewAnswers = F2(
	function (userInput, _v0) {
		var elems = _v0.a;
		var answers = _v0.b;
		var trimmedUserInput = function () {
			var t = $elm$core$String$trim(userInput);
			return (!$elm$core$String$length(t)) ? '?' : t;
		}();
		var isCorrect_ = A2($elm$core$Set$member, trimmedUserInput, answers);
		var remainingAnswers = isCorrect_ ? A2($elm$core$Set$remove, trimmedUserInput, answers) : answers;
		var clazz = $elm$html$Html$Attributes$class(
			isCorrect_ ? 'correct border border-green-600 rounded-full px-2' : 'wrong inline-block min-w-4 text-xs font-thin line-through px-2 bg-red-600 text-gray-400');
		var elem = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[clazz]),
			_List_fromArray(
				[
					$elm$html$Html$text(trimmedUserInput)
				]));
		return _Utils_Tuple2(
			A2($elm$core$List$cons, elem, elems),
			remainingAnswers);
	});
var $author$project$Page$Learn$sentenceBodyToResultHtml = function (body) {
	switch (body.$) {
		case 0:
			var s = body.a;
			return $elm$html$Html$text(s);
		case 1:
			var answer = body.a;
			var opts = body.b;
			var _v1 = A3(
				$elm$core$List$foldr,
				$author$project$Page$Learn$viewAnswers,
				_Utils_Tuple2(_List_Nil, answer),
				A2(
					$elm$core$List$map,
					$elm$core$Maybe$withDefault(''),
					opts.hr));
			var results = _v1.a;
			var remainingAnswers = _v1.b;
			var remainingViews = A2(
				$elm$core$List$map,
				function (rem) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-black border-green-800 border bg-yellow-400 px-2 rounded-full text-red-700')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rem)
							]));
				},
				$elm$core$Set$toList(remainingAnswers));
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content is-medium')
					]),
				_Utils_ap(results, remainingViews));
		case 2:
			var answer = body.a;
			var opts = body.b;
			var _v2 = A3(
				$elm$core$List$foldr,
				$author$project$Page$Learn$viewAnswers,
				_Utils_Tuple2(_List_Nil, answer),
				A2(
					$elm$core$List$map,
					$elm$core$Maybe$withDefault(''),
					opts.hr));
			var results = _v2.a;
			var remainingAnswers = _v2.b;
			var remainingViews = A2(
				$elm$core$List$map,
				function (rem) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-black border-green-800 border bg-yellow-400 px-2 rounded-full text-red-700')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rem)
							]));
				},
				$elm$core$Set$toList(remainingAnswers));
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content is-medium')
					]),
				_Utils_ap(results, remainingViews));
		default:
			var answer = body.a;
			var input = body.b;
			var _v3 = A3(
				$elm$core$List$foldr,
				$author$project$Page$Learn$viewAnswers,
				_Utils_Tuple2(_List_Nil, answer),
				A2(
					$elm$core$List$map,
					$elm$core$Maybe$withDefault(''),
					input));
			var results = _v3.a;
			var remainingAnswers = _v3.b;
			var remainingViews = A2(
				$elm$core$List$map,
				function (rem) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-black border-green-800 border bg-yellow-400 px-2 rounded-full text-red-700')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rem)
							]));
				},
				$elm$core$Set$toList(remainingAnswers));
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('')
					]),
				_Utils_ap(results, remainingViews));
	}
};
var $author$project$Page$Learn$viewResultSentences = function (results) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content is-medium px-4')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, _v0) {
							var quiz = _v0.a;
							var record = _v0.b;
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('content is-medium mb-2')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('checkbox icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$checked(record.dL),
														A2($elm$html$Html$Attributes$style, 'display', 'none'),
														$elm$html$Html$Events$onCheck(
														A3($author$project$Page$Learn$SwitchBoost, index, record, quiz))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('boost')
													]),
												_List_Nil)
											])),
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('ml-2'),
														$author$project$Page$Learn$reviewStyle(record)
													]),
												A2($elm$core$List$map, $author$project$Page$Learn$sentenceBodyToResultHtml, quiz.g1))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Route$href(
														$author$project$Route$EditQuiz(
															$elm$core$Maybe$Just(record.ep))),
														$elm$html$Html$Attributes$class('underline text-gray-600 text-xs hover:text-red-800')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('(問題を訂正する)')
													]))
											]))));
						}),
					results)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-center mt-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href($author$project$Route$Index),
								$elm$html$Html$Attributes$class('text-lg underline text-blue-800')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('トップページに戻る')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-center mt-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-green-500 hover:bg-green-400 rounded-full text-left'),
								A2(
								$elm$html$Html$Events$preventDefaultOn,
								'click',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$Page$Learn$ClickNextSession, true)))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('my-2 mx-8 inline-block text-xl text-white')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('次の問題')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Learn$viewScore = function (model) {
	var score = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.cg;
			},
			model.dh));
	var score_ = $elm$core$String$fromInt(score);
	var message = (score >= 10) ? 'パーフェクト!!' : ((score >= 8) ? 'すばらしい!!' : ((score >= 5) ? 'よくできました!' : 'おつかれさまでした!'));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-12 flex justify-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-bold py-4 text-3xl text-green-600')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message + (' (' + (score_ + ')')))
					]))
			]));
};
var $author$project$Page$Learn$TemporaryMessageMsgClose = {$: 0};
var $author$project$Page$Learn$viewTemporaryMessage = function (model) {
	var visible = model.bP;
	var message = model.gx;
	var class_ = visible ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('show')
		]) : _List_Nil;
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('notification')
				]),
			class_),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('delete'),
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
						function (_v0) {
							return $author$project$Page$Learn$TemporaryMessage($author$project$Page$Learn$TemporaryMessageMsgClose);
						})
					]),
				_List_Nil),
				$elm$html$Html$text(model.gx)
			]));
};
var $author$project$Page$Learn$viewResult = function (model) {
	var messageView = $author$project$Page$Learn$viewTemporaryMessage(model.fo);
	return _List_fromArray(
		[
			$author$project$Page$Learn$viewScore(model),
			A2(
			$elm$core$Maybe$withDefault,
			A2($elm$html$Html$div, _List_Nil, _List_Nil),
			A2(
				$elm$core$Maybe$map,
				$author$project$Page$Learn$viewResultSentences,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gU;
					},
					model.dh))),
			$author$project$Page$Learn$buy_me_a_coffee(true),
			messageView
		]);
};
var $author$project$Page$Learn$view = function (model) {
	var mainView = function () {
		var _v1 = model.dh;
		if (!_v1.$) {
			var result = _v1.a;
			return $author$project$Page$Learn$viewResult(model);
		} else {
			return A2($author$project$Page$Learn$viewQuestion, model, model.fb);
		}
	}();
	var headerView = function () {
		var _v0 = model.fb;
		if (!_v0.$) {
			var sess = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex bg-white fixed top-0 inset-x-0 z-100 h-12 items-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full h-4 max-w-screen-xl mx-auto px-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full')
									]),
								_List_fromArray(
									[
										$author$project$Page$Learn$sessionProgress(sess),
										$author$project$Page$Learn$timerProgress(model)
									]))
							]))
					]));
		} else {
			return A3(
				$author$project$Page$Common$showNavBar,
				model.fc,
				$author$project$Page$Learn$ToggleMenu,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-left'),
								A2(
								$elm$html$Html$Events$preventDefaultOn,
								'click',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$Page$Learn$ClickNextSession, true)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('次の問題')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href($author$project$Route$Index)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('トップページに戻る')
							]))
					]));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		A2($elm$core$List$cons, headerView, mainView));
};
var $author$project$Page$Quizes$ConfirmDeleteAll = {$: 12};
var $author$project$Page$Quizes$ExportFile = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Quizes$FetchQuiz = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Quizes$MarkAll = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Page$Quizes$SelectAll = {$: 10};
var $author$project$Page$Quizes$ToggleMenu = {$: 6};
var $author$project$Page$Quizes$UnselectAll = {$: 11};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Page$Quizes$viewEntry = F4(
	function (env, zone, toBeProcessed, record) {
		var isProcessed = A2($elm$core$Dict$member, record.ep, toBeProcessed);
		var itemClasses = isProcessed ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('quiz-item processed text-red-700')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('quiz-item text-gray-900')
			]);
		var trashIconClasses = isProcessed ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('fas fa-check-square processed')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('fas fa-check-square available')
			]);
		var importUrl = A3(
			$elm$url$Url$Builder$crossOrigin,
			$author$project$Env$origin(env),
			_List_fromArray(
				['memory-quiz']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'q', record.d3.de)
				]));
		var headPart = function (q) {
			return q + '...';
		}(
			$elm$core$String$fromList(
				A2(
					$elm$core$List$take,
					15,
					$elm$core$String$toList(
						A2(
							$elm$core$Result$withDefault,
							record.d3.de,
							$author$project$WikiParser$normalize(record.d3.de))))));
		var bodyText = $elm$core$Result$toMaybe(
			$author$project$WikiParser$normalize(record.d3.de));
		var shareUrl = A2(
			$elm$core$Maybe$map,
			function (body) {
				var truncated = $elm$core$String$fromList(
					A2(
						$elm$core$List$take,
						112,
						$elm$core$String$toList(body)));
				return A3(
					$elm$url$Url$Builder$crossOrigin,
					'https://twitter.com',
					_List_fromArray(
						['intent', 'tweet']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'hashtags', 'タノマナ'),
							A2($elm$url$Url$Builder$string, 'url', importUrl),
							A2($elm$url$Url$Builder$string, 'text', truncated)
						]));
			},
			bodyText);
		var shareLink = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$span(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gray-300')
					])),
			A2(
				$elm$core$Maybe$map,
				function (url) {
					return $elm$html$Html$a(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url),
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$class('text-blue-500')
							]));
				},
				shareUrl));
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox icon text-gray-800')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(isProcessed),
											A2($elm$html$Html$Attributes$style, 'display', 'none'),
											$elm$html$Html$Events$onCheck(
											$author$project$Page$Quizes$Mark(record.ep))
										]),
									_List_Nil),
									A2($elm$html$Html$i, trashIconClasses, _List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$style, 'text-overflow', 'elipsis'),
								itemClasses),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											$author$project$Route$EditQuiz(
												$elm$core$Maybe$Just(record.ep)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(headPart)
										]))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							shareLink(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fab fa-twitter-square fa-lg')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(record.dh.ey) + ('/' + $elm$core$String$fromInt(record.dh.fs)))
						]))
				]));
	});
var $author$project$Page$Quizes$view = function (model) {
	var quizContent = A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$map,
			function ($) {
				return $.de;
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.d3;
				},
				$elm$core$Dict$values(model.d2))));
	var pageContext = model.eM;
	var isAllProcessed = A2(
		$elm$core$List$all,
		function (k) {
			return A2($elm$core$Dict$member, k, model.d2);
		},
		A2(
			$elm$core$List$map,
			function ($) {
				return $.ep;
			},
			model.d1));
	var trashIconClasses = isAllProcessed ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('fas fa-check-square processed')
		]) : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('fas fa-check-square available')
		]);
	var getPrevMsg = $author$project$Page$Quizes$GetQuizes(
		_Utils_update(
			pageContext,
			{
				gO: A2($elm$core$Basics$max, 0, pageContext.gO) - 1
			}));
	var getNextMsg = $author$project$Page$Quizes$GetQuizes(
		_Utils_update(
			pageContext,
			{gO: pageContext.gO + 1}));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Page$Common$showNavBar,
				model.fc,
				$author$project$Page$Quizes$ToggleMenu,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href($author$project$Route$Index)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('トップページに戻る')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href(
								$author$project$Route$EditQuiz($elm$core$Maybe$Nothing))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('新しい問題を作る')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Events$preventDefaultOn,
								'click',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2(
										$author$project$Page$Quizes$FetchQuiz('new'),
										true))),
								$elm$html$Html$Attributes$href('#')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('新しい問題があればダウンロード')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Events$preventDefaultOn,
								'click',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2(
										$author$project$Page$Quizes$FetchQuiz('all'),
										true))),
								$elm$html$Html$Attributes$href('#')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('サンプル問題(中学受験 理社)')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href($author$project$Route$ImportQuizes)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('まとめて問題を作る')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container pt-12')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-gray-400')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('checkbox icon text-gray-800')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('checkbox'),
																$elm$html$Html$Attributes$checked(isAllProcessed),
																A2($elm$html$Html$Attributes$style, 'display', 'none'),
																$elm$html$Html$Events$onCheck(
																$author$project$Page$Quizes$MarkAll(
																	A2(
																		$elm$core$List$map,
																		function ($) {
																			return $.ep;
																		},
																		model.d1)))
															]),
														_List_Nil),
														A2($elm$html$Html$i, trashIconClasses, _List_Nil)
													]))
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('問題')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('シェア')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('正解率')
											]))
									])),
							A2(
								$elm$core$List$map,
								A3($author$project$Page$Quizes$viewEntry, model.bZ, model.bQ, model.d2),
								model.d1)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full pt-2 flex justify-between text-blue-800')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('px-4 py-2 disabled:opacity-25 disabled:text-gray-500'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v0) {
									return getPrevMsg;
								}),
								$elm$html$Html$Attributes$disabled(!model.eM.gO)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('<前')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('px-4 py-2 disabled:opacity-75 disabled:text-gray-500'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v1) {
									return getNextMsg;
								}),
								$elm$html$Html$Attributes$disabled(
								_Utils_cmp(
									model.eM.fZ,
									$elm$core$List$length(model.d1)) > 0)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('次>')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full px-2 pt-2 flex flex-col justify-between text-blue-800')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pb-4 disabled:opacity-25 disabled:text-gray-500'),
								$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
								function (_v2) {
									return $author$project$Page$Quizes$UnselectAll;
								}),
								$elm$html$Html$Attributes$disabled(
								$elm$core$Dict$isEmpty(model.d2))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fas fa-eraser')
									]),
								_List_Nil),
								$elm$html$Html$text('すべてのチェックを外す')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Page$Quizes$TagChooserMsg,
								$author$project$Page$TagChooser$tagChooser(model.dv))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex justify-between pt-2 px-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('disabled:opacity-25 disabled:text-gray-500 px-2'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v3) {
											return $author$project$Page$Quizes$SelectAll;
										})
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-clipboard-check')
											]),
										_List_Nil),
										$elm$html$Html$text('タグで選択')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('disabled:opacity-25 disabled:text-gray-500 px-2'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v4) {
											return $author$project$Page$Quizes$ExportFile(quizContent);
										}),
										$elm$html$Html$Attributes$disabled(
										$elm$core$Dict$isEmpty(model.d2))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-file-download')
											]),
										_List_Nil),
										$elm$html$Html$text('.rqz に保存')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('disabled:opacity-25 disabled:text-gray-500 px-2'),
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
										function (_v5) {
											return $author$project$Page$Quizes$ConfirmDeleteAll;
										}),
										$elm$html$Html$Attributes$disabled(
										$elm$core$Dict$isEmpty(model.d2))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-trash')
											]),
										_List_Nil),
										$elm$html$Html$text('すべて削除')
									]))
							]))
					]))
			]));
};
var $author$project$Main$view = function (model) {
	var subView = function () {
		var _v0 = model.bO;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('no such page')
						]));
			case 2:
				return A2(
					$elm$html$Html$map,
					$author$project$Main$LearnMsg,
					$author$project$Page$Learn$view(model));
			case 1:
				return A2(
					$elm$html$Html$map,
					$author$project$Main$IndexMsg,
					$author$project$Page$Index$view(model));
			case 3:
				return A2(
					$elm$html$Html$map,
					$author$project$Main$QuizesMsg,
					$author$project$Page$Quizes$view(model));
			case 4:
				return A2(
					$elm$html$Html$map,
					$author$project$Main$EditQuizMsg,
					$author$project$Page$EditQuiz$view(model));
			default:
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ImportQuizesMsg,
					$author$project$Page$ImportQuizes$view(model));
		}
	}();
	var env = $author$project$Main$toEnv(model);
	return A2(
		$elm$browser$Browser$Document,
		$author$project$Env$title(env),
		_List_fromArray(
			[subView]));
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{gq: $author$project$Main$init, gJ: $author$project$Main$OnUrlChange, gK: $author$project$Main$OnUrlRequest, ha: $author$project$Main$subscriptions, ho: $author$project$Main$update, ht: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (tags) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (origin) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (history) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (config) {
									return $elm$json$Json$Decode$succeed(
										{bU: config, az: history, c0: origin, fn: tags});
								},
								A2($elm$json$Json$Decode$field, 'config', $elm$json$Json$Decode$value));
						},
						A2($elm$json$Json$Decode$field, 'history', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'tags',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))(0)}});}(this));